
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("k7LtZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $88d2ad5b04dd39a4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $hzz48 = parcelRequire("hzz48");

var $cZTMg = parcelRequire("cZTMg");

var $aV23b = parcelRequire("aV23b");

var $akiS9 = parcelRequire("akiS9");

var $dTqD3 = parcelRequire("dTqD3");

var $16sa1 = parcelRequire("16sa1");
const $88d2ad5b04dd39a4$var$JiraIssuesArchive = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "jira-archives"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jira-issues-archives",
        packageName: "jira-archives",
        teamName: "kenji",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akiS9.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hzz48.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStatePageReady), null)))));
var $88d2ad5b04dd39a4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($88d2ad5b04dd39a4$var$JiraIssuesArchive);

});
parcelRegister("hzz48", function(module, exports) {
$parcel$export(module.exports, "default", () => $17d087749bead569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $29oZU = parcelRequire("29oZU");

var $5vQ2T = parcelRequire("5vQ2T");

var $kGj4V = parcelRequire("kGj4V");

var $i8mX1 = parcelRequire("i8mX1");

var $h4JbH = parcelRequire("h4JbH");

var $6eQho = parcelRequire("6eQho");

var $i0YXt = parcelRequire("i0YXt");

var $4n4SV = parcelRequire("4n4SV");

var $3ultg = parcelRequire("3ultg");

var $c85dS = parcelRequire("c85dS");

var $4AXtr = parcelRequire("4AXtr");

var $c4YZw = parcelRequire("c4YZw");

var $d5Bcm = parcelRequire("d5Bcm");

var $7s3BR = parcelRequire("7s3BR");
const $17d087749bead569$var$Archives = ()=>{
    const { archivesIssueDataPresent: archivesIssueDataPresent } = (0, $6eQho.useArchiveIssueStates)();
    const { setArchivesIssueDataPresent: setArchivesIssueDataPresent } = (0, $h4JbH.useArchiveIssueActions)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            // this is to make sure whenever we have empty state and user comes back to same route and fetch back results.
            !archivesIssueDataPresent && setArchivesIssueDataPresent(true);
        };
    }, [
        archivesIssueDataPresent,
        setArchivesIssueDataPresent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jiraArchiveIssuesPage",
        packageName: "jiraIssueArchivalArchives",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4n4SV.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "archivesPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7s3BR.LayoutMainWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c85dS.default), {
        bottomBar: archivesIssueDataPresent === false ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $29oZU.default), {
            justifyContent: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d5Bcm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3ultg.Filters), null))
    }), archivesIssueDataPresent === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0YXt.ArchivesTableEmptyState), {
        noDataState: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($17d087749bead569$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4AXtr.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4YZw.IssueManageBar), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8mX1.default), null)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $17d087749bead569$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _ca0qidpf _u5f31jfw _n3tdidpf _19bv1jfw _otyrxy5q",
            __cmplp.className
        ])
    });
});
var $17d087749bead569$export$2e2bcd8739ae039 = $17d087749bead569$var$Archives;

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("i8mX1", function(module, exports) {
$parcel$export(module.exports, "default", () => $4659cdc7dba7c949$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $9zdgX = parcelRequire("9zdgX");

var $ha7jd = parcelRequire("ha7jd");
const $4659cdc7dba7c949$var$runtimeProps = {};
const $4659cdc7dba7c949$var$entryPointParams = {};
const $4659cdc7dba7c949$var$AsyncUnarchiveModal = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $9zdgX.unarchiveModalEntryPoint), $4659cdc7dba7c949$var$entryPointParams);
    const { isUnarchiveIssueModalOpen: isUnarchiveIssueModalOpen } = (0, $ha7jd.useUnarchiveIssueModalStates)();
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isUnarchiveIssueModalOpen) {
            entryPointActions.load();
            return ()=>{
                entryPointActions.unload();
            };
        }
    }, [
        entryPointActions,
        isUnarchiveIssueModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira-unarchive-issue-modal",
        packageName: "jiraUnarchiveModal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $4659cdc7dba7c949$var$runtimeProps
    });
};
var $4659cdc7dba7c949$export$2e2bcd8739ae039 = $4659cdc7dba7c949$var$AsyncUnarchiveModal;

});
parcelRegister("9zdgX", function(module, exports) {
$parcel$export(module.exports, "unarchiveModalEntryPoint", () => $641175b79134d3aa$export$ea1ad361ecb74284);

var $lqL0W = parcelRequire("lqL0W");

var $gIWc7 = parcelRequire("gIWc7");

const $641175b79134d3aa$export$ea1ad361ecb74284 = (0, $gIWc7.createEntryPoint)({
    root: (0, $lqL0W.JSResourceForInteraction)(()=>(parcelRequire("hBgeb")), {
        moduleId: "675b37a7",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hBgeb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5CrmK").then(()=>parcelRequire('9juD3'));

});


parcelRegister("ha7jd", function(module, exports) {
$parcel$export(module.exports, "useUnarchiveIssueModalStates", () => $d7f5149e5dccf8d8$export$fe9c7d196b05307d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $98BOR = parcelRequire("98BOR");
const $d7f5149e5dccf8d8$export$fe9c7d196b05307d = (0, $iJq0l.createStateHook)((0, $98BOR.UnarchiveIssueModalStore));

});
parcelRegister("98BOR", function(module, exports) {
$parcel$export(module.exports, "UnarchiveIssueModalStore", () => $80574876aaea7df6$export$15ae11a500a318ea);
$parcel$export(module.exports, "useUnarchiveIssueModalActions", () => $80574876aaea7df6$export$a62f9f14820c45d1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $27lDc = parcelRequire("27lDc");

var $6cNBZ = parcelRequire("6cNBZ");
const $80574876aaea7df6$export$15ae11a500a318ea = (0, $GtRbT.createStore)({
    initialState: $6cNBZ.initialState,
    actions: (0, $27lDc.UnarchiveIssueModalActions),
    name: 'unarchiveIssueModalStore'
});
const $80574876aaea7df6$export$a62f9f14820c45d1 = (0, $iJq0l.createActionsHook)($80574876aaea7df6$export$15ae11a500a318ea);

});
parcelRegister("27lDc", function(module, exports) {
$parcel$export(module.exports, "UnarchiveIssueModalActions", () => $f434bc4b01e67a29$export$c18e6ef1c7bdce79);

var $12DRg = parcelRequire("12DRg");
const $f434bc4b01e67a29$export$c18e6ef1c7bdce79 = {
    openUnarchiveIssueModal: (issueKey)=>({ setState: setState })=>{
            setState({
                isUnarchiveIssueModalOpen: true,
                issueKey: issueKey
            });
        },
    closeUnarchiveIssueModal: ()=>({ setState: setState })=>{
            setState({
                isUnarchiveIssueModalOpen: false,
                issueKey: null
            });
        },
    openUnarchiveIssuesModal: ({ selectedIssuesDetails: selectedIssuesDetails, onSuccessCallback: onSuccessCallback, onErrorCallback: onErrorCallback, showViewIssueActionInSuccessFlag: showViewIssueActionInSuccessFlag })=>({ setState: setState })=>{
            setState({
                isUnarchiveIssueModalOpen: true,
                selectedIssuesDetails: selectedIssuesDetails,
                onSuccessCallback: onSuccessCallback || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                onErrorCallback: onErrorCallback || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                showViewIssueActionInSuccessFlag: showViewIssueActionInSuccessFlag || false
            });
        },
    closeUnarchiveIssuesModal: ()=>({ setState: setState })=>{
            setState({
                isUnarchiveIssueModalOpen: false,
                selectedIssuesDetails: [],
                onSuccessCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                onErrorCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                showViewIssueActionInSuccessFlag: false
            });
        }
};

});

parcelRegister("6cNBZ", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $5d528c8e69d7c308$export$d4c72bab9d6cc13a);

var $12DRg = parcelRequire("12DRg");
const $5d528c8e69d7c308$export$d4c72bab9d6cc13a = {
    isUnarchiveIssueModalOpen: false,
    issueKey: null,
    selectedIssuesDetails: [],
    onSuccessCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onErrorCallback: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    showViewIssueActionInSuccessFlag: false
};

});




parcelRegister("h4JbH", function(module, exports) {
$parcel$export(module.exports, "ArchiveIssuesStore", () => $7712fca6847169c0$export$4b4186aed8f7ee90);
$parcel$export(module.exports, "useArchiveIssueActions", () => $7712fca6847169c0$export$9cf896227421597b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $abyXI = parcelRequire("abyXI");

var $gHJsI = parcelRequire("gHJsI");
const $7712fca6847169c0$export$4b4186aed8f7ee90 = (0, $GtRbT.createStore)({
    initialState: $gHJsI.initialState,
    actions: (0, $abyXI.ArchiveIssueTableActions),
    name: 'archiveIssuesStore'
});
const $7712fca6847169c0$export$9cf896227421597b = (0, $iJq0l.createActionsHook)($7712fca6847169c0$export$4b4186aed8f7ee90);

});
parcelRegister("abyXI", function(module, exports) {
$parcel$export(module.exports, "ArchiveIssueTableActions", () => $2ad885dfa770b735$export$59c3a0901053708c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2ad885dfa770b735$export$59c3a0901053708c = {
    setIssuesInCurrentPage: (issues)=>({ setState: setState })=>{
            setState({
                issuesInCurrentPage: issues
            });
        },
    setProjectId: (projectId)=>({ setState: setState })=>{
            setState({
                projectId: projectId
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    updateIssueDetails: (issueDetails)=>{
        return ({ setState: setState })=>{
            setState({
                issueDetails: {
                    ...issueDetails
                }
            });
        };
    },
    selectIssue: ({ issueId: issueId, pageNumber: pageNumber })=>({ setState: setState, getState: getState })=>{
            const { selectedIssues: selectedIssues, numberOfSelectedIssues: numberOfSelectedIssues } = getState();
            const isSelected = selectedIssues[pageNumber]?.includes(issueId);
            if (!isSelected) {
                const updatedSelectedIssuesForPage = selectedIssues[pageNumber] ? [
                    ...selectedIssues[pageNumber],
                    issueId
                ] : [
                    issueId
                ];
                setState({
                    selectedIssues: {
                        ...selectedIssues,
                        [pageNumber]: updatedSelectedIssuesForPage
                    },
                    numberOfSelectedIssues: numberOfSelectedIssues + 1
                });
            }
        },
    deselectIssue: ({ issueId: issueId, pageNumber: pageNumber })=>({ setState: setState, getState: getState })=>{
            const { selectedIssues: selectedIssues, numberOfSelectedIssues: numberOfSelectedIssues } = getState();
            const isSelected = selectedIssues[pageNumber]?.includes(issueId);
            if (isSelected) {
                const updatedSelectedIssuesForPage = selectedIssues[pageNumber].filter((id)=>id !== issueId);
                setState({
                    selectedIssues: {
                        ...selectedIssues,
                        [pageNumber]: updatedSelectedIssuesForPage
                    },
                    numberOfSelectedIssues: numberOfSelectedIssues - 1
                });
            }
        },
    selectAllIssuesInCurrentPage: ()=>({ setState: setState, getState: getState })=>{
            const { selectedIssues: selectedIssues, issuesInCurrentPage: issuesInCurrentPage, numberOfSelectedIssues: numberOfSelectedIssues, currentPage: currentPage } = getState();
            const updatedSelectedIssuesForPage = [];
            issuesInCurrentPage.forEach((issueId)=>{
                updatedSelectedIssuesForPage.push(issueId);
            });
            const updatedNumberOfSelectedIssues = numberOfSelectedIssues + issuesInCurrentPage.length;
            setState({
                selectedIssues: {
                    ...selectedIssues,
                    [currentPage]: updatedSelectedIssuesForPage
                },
                numberOfSelectedIssues: updatedNumberOfSelectedIssues
            });
        },
    clearSelectionsInCurrentPage: ()=>({ setState: setState, getState: getState })=>{
            const { numberOfSelectedIssues: numberOfSelectedIssues, selectedIssues: selectedIssues, currentPage: currentPage } = getState();
            const selectedIssuesForCurrentPage = selectedIssues[currentPage];
            const numberOfSelectedIssuesOnCurrentPage = selectedIssuesForCurrentPage?.length || 0;
            const updatedselectedIssuesInPage = {
                ...selectedIssues,
                [currentPage]: []
            };
            setState({
                selectedIssues: updatedselectedIssuesInPage,
                numberOfSelectedIssues: numberOfSelectedIssues - numberOfSelectedIssuesOnCurrentPage
            });
        },
    clearAllSelections: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                selectedIssues: {},
                numberOfSelectedIssues: 0
            });
        },
    addIssueInCurrentPage: (issueId)=>({ setState: setState, getState: getState })=>{
            const { issuesInCurrentPage: issuesInCurrentPage } = getState();
            const isIssueInCurrentPage = issuesInCurrentPage.includes(issueId);
            if (!isIssueInCurrentPage) setState({
                issuesInCurrentPage: [
                    ...issuesInCurrentPage,
                    issueId
                ]
            });
        },
    clearIssuesInCurrentPage: ()=>({ setState: setState })=>{
            setState({
                issuesInCurrentPage: []
            });
        },
    setCurrentPage: (pageNumber)=>({ setState: setState })=>{
            setState({
                currentPage: pageNumber
            });
        },
    setFilters: (filterValue)=>({ setState: setState })=>{
            const updatedFilterValue = {
                ...filterValue
            };
            Object.keys(updatedFilterValue).forEach((key)=>{
                const value = updatedFilterValue[key];
                if (!Array.isArray(value) && value?.value && Object.keys(value.value).length === 0) delete updatedFilterValue[key];
            });
            setState({
                filters: updatedFilterValue,
                refetchArchivesIssuesData: true,
                currentPage: 1
            });
        },
    setSearchBy: (searchBy)=>({ setState: setState })=>{
            setState({
                searchBy: searchBy,
                refetchArchivesIssuesData: true,
                currentPage: 1
            });
        },
    setArchivesIssueDataPresent: (archivesIssueDataPresent)=>({ setState: setState })=>{
            setState({
                archivesIssueDataPresent: archivesIssueDataPresent
            });
        },
    setRefetchArchivesIssuesData: (refetchArchivesIssuesData)=>({ setState: setState })=>{
            setState({
                refetchArchivesIssuesData: refetchArchivesIssuesData
            });
        }
};

});

parcelRegister("gHJsI", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $b22b32597540ffca$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "filterFields", () => $b22b32597540ffca$export$488edbb91e4d1f17);

var $4yIsM = parcelRequire("4yIsM");
const $b22b32597540ffca$export$d4c72bab9d6cc13a = {
    isLoading: false,
    issuesInCurrentPage: [],
    selectedIssues: {},
    numberOfSelectedIssues: 0,
    currentPage: 1,
    totalPages: 2,
    issuesMockData: $4yIsM.issuesMockData,
    filters: {},
    projectId: '',
    searchBy: '',
    issueDetails: {},
    archivesIssueDataPresent: true,
    // this state has to be true intially to fetch intial load data
    refetchArchivesIssuesData: true
};
const $b22b32597540ffca$export$488edbb91e4d1f17 = {
    issueType: {
        label: 'ISSUE TYPE',
        options: [],
        type: 'AvatarSelectFilter'
    },
    reporter: {
        label: 'REPORTER',
        options: [],
        type: 'AvatarAsyncSelectFilter',
        defaultOptions: [],
        cacheOptions: true
    },
    archivedDate: {
        label: 'ARCHIVED DATE',
        type: 'DateFilter'
    },
    archivedBy: {
        label: 'ARCHIVED BY',
        options: [],
        type: 'AvatarAsyncSelectFilter',
        defaultOptions: [],
        cacheOptions: true
    }
};

});
parcelRegister("4yIsM", function(module, exports) {
$parcel$export(module.exports, "issuesMockData", () => $3de05fa0aaa96299$export$3e446492b22c602e);
const $3de05fa0aaa96299$export$3e446492b22c602e = {
    1: [
        {
            issueId: 10412,
            issueType: {
                issueTypeId: '10004',
                name: 'Story',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                }
            },
            issueKey: 'KAN-363',
            summary: 'This is a archived issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-05T08:34:03.07Z'
        },
        {
            issueId: 10411,
            issueType: {
                issueTypeId: '10006',
                name: 'Epic',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                }
            },
            issueKey: 'KAN-362',
            summary: 'This is a archived issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-04-24T08:34:03.07Z'
        },
        {
            issueId: 10410,
            issueType: {
                issueTypeId: '10005',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-361',
            summary: 'This is a archived issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-09-19T08:34:03.07Z'
        },
        {
            issueId: 10408,
            issueType: {
                issueTypeId: '10008',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-359',
            summary: 'This is a archived issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-02T08:34:03.07Z'
        },
        {
            issueId: 10409,
            issueType: {
                issueTypeId: '10005',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-360',
            summary: 'This is a archived issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-09-19T08:34:03.07Z'
        },
        {
            issueId: 10398,
            issueType: {
                issueTypeId: '10008',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-353',
            summary: 'This is a archived issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-02T08:34:03.07Z'
        },
        {
            issueId: 10352,
            issueType: {
                issueTypeId: '10004',
                name: 'Story',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                }
            },
            issueKey: 'KAN-397',
            summary: 'Dummy Issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-05T08:34:03.07Z'
        },
        {
            issueId: 10007,
            issueType: {
                issueTypeId: '10006',
                name: 'Epic',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                }
            },
            issueKey: 'SE-2',
            summary: 'testing',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-04-24T08:34:03.07Z'
        },
        {
            issueId: 10008,
            issueType: {
                issueTypeId: '10005',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-4',
            summary: 'test summary',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-09-19T08:34:03.07Z'
        },
        {
            issueId: 10009,
            issueType: {
                issueTypeId: '10005',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-4',
            summary: 'test summary',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-09-19T08:34:03.07Z'
        },
        {
            issueId: 10010,
            issueType: {
                issueTypeId: '10008',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-4',
            summary: 'dummy issues',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-02T08:34:03.07Z'
        },
        {
            issueId: 10011,
            issueType: {
                issueTypeId: '10004',
                name: 'Story',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                }
            },
            issueKey: 'SS-1',
            summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-05T08:34:03.07Z'
        },
        {
            issueId: 10012,
            issueType: {
                issueTypeId: '10006',
                name: 'Epic',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                }
            },
            issueKey: 'SE-2',
            summary: 'testing',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-04-24T08:34:03.07Z'
        },
        {
            issueId: 10013,
            issueType: {
                issueTypeId: '10006',
                name: 'Epic',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                }
            },
            issueKey: 'SE-2',
            summary: 'testing',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-04-24T08:34:03.07Z'
        },
        {
            issueId: 10014,
            issueType: {
                issueTypeId: '10005',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-4',
            summary: 'test summary',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-09-19T08:34:03.07Z'
        },
        {
            issueId: 10015,
            issueType: {
                issueTypeId: '10008',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-4',
            summary: 'dummy issues',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-02T08:34:03.07Z'
        },
        {
            issueId: 10016,
            issueType: {
                issueTypeId: '10005',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-4',
            summary: 'test summary',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-09-19T08:34:03.07Z'
        },
        {
            issueId: 10017,
            issueType: {
                issueTypeId: '10008',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-4',
            summary: 'dummy issues',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-02T08:34:03.07Z'
        },
        {
            issueId: 10018,
            issueType: {
                issueTypeId: '10004',
                name: 'Story',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                }
            },
            issueKey: 'SS-1',
            summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-05T08:34:03.07Z'
        },
        {
            issueId: 10019,
            issueType: {
                issueTypeId: '10006',
                name: 'Epic',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                }
            },
            issueKey: 'SE-2',
            summary: 'testing',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-04-24T08:34:03.07Z'
        }
    ],
    2: [
        {
            issueId: 10407,
            issueType: {
                issueTypeId: '10005',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-358',
            summary: 'This is a archived issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-09-19T08:34:03.07Z'
        },
        {
            issueId: 10406,
            issueType: {
                issueTypeId: '10008',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-357',
            summary: 'This is a archived issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-02T08:34:03.07Z'
        },
        {
            issueId: 10404,
            issueType: {
                issueTypeId: '10005',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-355',
            summary: 'This is a archived issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-09-19T08:34:03.07Z'
        },
        {
            issueId: 10399,
            issueType: {
                issueTypeId: '10008',
                name: 'Task',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                }
            },
            issueKey: 'KAN-354',
            summary: 'This is a archived issue',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-02T08:34:03.07Z'
        },
        {
            issueId: 10024,
            issueType: {
                issueTypeId: '10004',
                name: 'Story',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                }
            },
            issueKey: 'SS-1',
            summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-03-05T08:34:03.07Z'
        },
        {
            issueId: 10025,
            issueType: {
                issueTypeId: '10006',
                name: 'Epic',
                avatar: {
                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                }
            },
            issueKey: 'SE-2',
            summary: 'testing',
            archivedBy: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: '',
                    name: 'Unassigned',
                    __typename: 'AtlassianAccountUser'
                }
            },
            reporter: {
                user: {
                    id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                    accountStatus: 'active',
                    avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                    name: 'Rohit Kumar',
                    __typename: 'AtlassianAccountUser'
                }
            },
            archivedDate: '2024-04-24T08:34:03.07Z'
        }
    ]
};

});



parcelRegister("6eQho", function(module, exports) {
$parcel$export(module.exports, "useArchiveIssueStates", () => $da064078b8f0eb0f$export$486b776c8b816793);
$parcel$export(module.exports, "getAllSelectedIssuesWithDetails", () => $da064078b8f0eb0f$export$583fa87c588f3d49);
$parcel$export(module.exports, "isIssueSelected", () => $da064078b8f0eb0f$export$32568110248dd20a);
$parcel$export(module.exports, "getNumberOfSelectedIssues", () => $da064078b8f0eb0f$export$89dc5c606d599ac2);
$parcel$export(module.exports, "getNumberOfSelectedIssuesForPage", () => $da064078b8f0eb0f$export$d43a8ad2f8ecedd);
$parcel$export(module.exports, "getNumberOfIssuesForCurrentPage", () => $da064078b8f0eb0f$export$61283cd79b4124c4);
$parcel$export(module.exports, "getLoadingState", () => $da064078b8f0eb0f$export$2786ecc2e2951fe3);
$parcel$export(module.exports, "getCurrentPage", () => $da064078b8f0eb0f$export$7945ba8eb1c827e6);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $h4JbH = parcelRequire("h4JbH");
const $da064078b8f0eb0f$export$486b776c8b816793 = (0, $iJq0l.createStateHook)((0, $h4JbH.ArchiveIssuesStore));
const $da064078b8f0eb0f$export$3d538825a61bfe9b = ({ state: state, pageNumber: pageNumber })=>{
    const selectedIssues = state.selectedIssues?.[pageNumber];
    return selectedIssues || [];
};
const $da064078b8f0eb0f$export$6f1b9c3714a8d26e = ({ state: state })=>{
    if (!state.selectedIssues) return [];
    const selectedIssues = Object.values(state.selectedIssues);
    return selectedIssues.flat();
};
const $da064078b8f0eb0f$export$583fa87c588f3d49 = ({ state: state })=>{
    if (!state.selectedIssues) return [];
    const issueDetails = state.issueDetails;
    const selectedIssues = Object.values(state.selectedIssues);
    return selectedIssues.flat().map((issueId)=>{
        return issueDetails[issueId];
    });
};
const $da064078b8f0eb0f$export$c2e4f22ccec99b46 = ({ state: state, issueId: issueId })=>{
    let selectedIssuePagenumber;
    for(const pageNumber in state.selectedIssues)if (state.selectedIssues[pageNumber].includes(issueId)) selectedIssuePagenumber = Number(pageNumber);
    if (selectedIssuePagenumber === undefined) return undefined;
    return state.issuesMockData[selectedIssuePagenumber].find((issue)=>issue.issueId.toString() === issueId)?.issueKey;
};
const $da064078b8f0eb0f$export$32568110248dd20a = ({ state: state, pageNumber: pageNumber, issueId: issueId })=>{
    const selectedIssues = state.selectedIssues[pageNumber];
    return !!selectedIssues && selectedIssues.includes(issueId);
};
const $da064078b8f0eb0f$export$89dc5c606d599ac2 = ({ state: state })=>state.numberOfSelectedIssues;
const $da064078b8f0eb0f$export$d43a8ad2f8ecedd = ({ state: state, pageNumber: pageNumber })=>{
    const selectedIssues = state.selectedIssues[pageNumber];
    return selectedIssues ? selectedIssues.length : 0;
};
const $da064078b8f0eb0f$export$ff8213a8fac8bd8b = ({ state: state })=>state.issuesInCurrentPage;
const $da064078b8f0eb0f$export$61283cd79b4124c4 = ({ state: state })=>state.issuesInCurrentPage.length;
const $da064078b8f0eb0f$export$2786ecc2e2951fe3 = ({ state: state })=>state.isLoading;
const $da064078b8f0eb0f$export$7945ba8eb1c827e6 = ({ state: state })=>state.currentPage;
const $da064078b8f0eb0f$export$652b307566494a6 = ({ state: state })=>state.totalPages;
const $da064078b8f0eb0f$export$89040d072f281f85 = ({ state: state })=>state.projectId;
const $da064078b8f0eb0f$export$f6546bb98204a0ca = ({ state: state })=>state.filters;
const $da064078b8f0eb0f$export$b4497a6ae2ff3a2a = ({ state: state, currentPage: currentPage })=>state.issuesMockData[currentPage] || [];

});

parcelRegister("i0YXt", function(module, exports) {
$parcel$export(module.exports, "ArchivesTableEmptyState", () => $f15a84f523faf8db$export$7acb0f18fcb70012);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $l2azy = parcelRequire("l2azy");

var $hzdB4 = parcelRequire("hzdB4");

var $lRrud = parcelRequire("lRrud");
var $6CBB3 = parcelRequire("6CBB3");
var $e7uOb = parcelRequire("e7uOb");

var $khN6W = parcelRequire("khN6W");

var $epTsa = parcelRequire("epTsa");

var $7uL8m = parcelRequire("7uL8m");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $2rPWc = parcelRequire("2rPWc");

var $h4JbH = parcelRequire("h4JbH");

var $6eQho = parcelRequire("6eQho");

var $bKM9a = parcelRequire("bKM9a");
const $f15a84f523faf8db$var$NoIssuesIllustration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), {
        xcss: $f15a84f523faf8db$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7uL8m.default), {
        alt: ""
    }));
const $f15a84f523faf8db$export$7acb0f18fcb70012 = ({ noDataState: noDataState })=>{
    const emptyStateNoDataDescriptionMessageIssueTermRefreshGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $bKM9a.default).emptyStateNoDataDescriptionMessageIssueTermRefreshGalaxia : (0, $bKM9a.default).emptyStateNoDataDescriptionMessageIssueTermRefresh;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { setFilters: setFilters, setSearchBy: setSearchBy, setRefetchArchivesIssuesData: setRefetchArchivesIssuesData } = (0, $h4JbH.useArchiveIssueActions)();
    const { filters: filters, searchBy: searchBy } = (0, $6eQho.useArchiveIssueStates)();
    const showClearButton = Object.keys(filters).length > 0 || searchBy;
    const clearSearchOnClick = ()=>{
        setFilters({});
        setSearchBy('');
        setRefetchArchivesIssuesData(true);
    };
    const emptyStateNoDataHeader = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $bKM9a.default).emptyStateNoDataMessageIssueTermRefresh : (0, $bKM9a.default).emptyStateNoDataMessage;
    const emptyStateNoDataDescription = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? emptyStateNoDataDescriptionMessageIssueTermRefreshGalaxia : (0, $bKM9a.default).emptyStateNoDataDescriptionMessage;
    const emptyStateSupportMessage = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $bKM9a.default).emptyStateArchiveIssueSupportMessageIssueTermRefresh : (0, $bKM9a.default).emptyStateArchiveIssueSupportMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), {
        xcss: $f15a84f523faf8db$var$emptyIssuesContainerStyles,
        testId: `${(0, $2rPWc.ARCHIVES_TABLE_TEST_ID)}.empty-state`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hzdB4.default), {
        imageWidth: 228,
        header: noDataState ? formatMessage(emptyStateNoDataHeader) : formatMessage((0, $bKM9a.default).emptyStateMessage),
        description: noDataState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CBB3.default), {
            as: "p"
        }, formatMessage(emptyStateNoDataDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $khN6W.default), {
            href: "https://support.atlassian.com/jira-software-cloud/docs/archive-an-issue"
        }, formatMessage(emptyStateSupportMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CBB3.default), {
            as: "p"
        }, formatMessage((0, $bKM9a.default).emptyStateMessagePartTwo)),
        headingLevel: 2,
        primaryAction: showClearButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l2azy.default), {
            appearance: "primary",
            onClick: ()=>clearSearchOnClick(),
            testId: `${(0, $2rPWc.ARCHIVES_TABLE_TEST_ID)}.empty-state.clear-search-button`
        }, formatMessage((0, $bKM9a.default).clearSearchMessage)) : null,
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f15a84f523faf8db$var$NoIssuesIllustration, null)
    }));
};
const $f15a84f523faf8db$var$imageWrapperStyles = (0, $e7uOb.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});
const $f15a84f523faf8db$var$emptyIssuesContainerStyles = (0, $e7uOb.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    position: 'sticky',
    left: 'space.0',
    paddingBlock: 'space.800'
});

});
parcelRegister("7uL8m", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a8498e45c2fcae9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $1YwKZ = parcelRequire("1YwKZ");

var $fFVdD = parcelRequire("fFVdD");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $8a8498e45c2fcae9$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fFVdD)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1YwKZ))
});
var $8a8498e45c2fcae9$export$2e2bcd8739ae039 = $8a8498e45c2fcae9$var$Illustration;
// for advanced use only
const $8a8498e45c2fcae9$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("1YwKZ", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("fFVdD", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("2rPWc", function(module, exports) {
$parcel$export(module.exports, "ARCHIVE_TABLE_COLUMN_KEYS", () => $5dce8c75c54926ac$export$c5500cf522a3f99b);
$parcel$export(module.exports, "ARCHIVE_TABLE_COLUMN_WIDTHS", () => $5dce8c75c54926ac$export$5e400327feaf148);
$parcel$export(module.exports, "ARCHIVES_TABLE_TEST_ID", () => $5dce8c75c54926ac$export$d04a7179b5d2214e);
$parcel$export(module.exports, "NUMBER_OF_ISSUES_PER_PAGE", () => $5dce8c75c54926ac$export$ec00768bb4b64a4);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $5dce8c75c54926ac$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $5dce8c75c54926ac$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $5dce8c75c54926ac$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $5dce8c75c54926ac$export$17ed91292eb6c163);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $5dce8c75c54926ac$export$39aa3a14ebf850c7);
const $5dce8c75c54926ac$export$c5500cf522a3f99b = {
    SELECT: 'select',
    TYPE: 'type',
    KEY: 'key',
    SUMMARY: 'summary',
    ARCHIVED_BY: 'archivedBy',
    REPORTER: 'reporter',
    ARCHIVED_DATE: 'archived-date'
};
const $5dce8c75c54926ac$export$5e400327feaf148 = {
    SELECT: 4,
    TYPE: 5,
    KEY: 12,
    SUMMARY: 42,
    ARCHIVED_BY: 16,
    REPORTER: 16,
    ARCHIVED_DATE: 12
};
const $5dce8c75c54926ac$export$d04a7179b5d2214e = 'issue-archival-archives.archives-table';
const $5dce8c75c54926ac$export$ec00768bb4b64a4 = 50;
const $5dce8c75c54926ac$var$POPUP_WIDTH = 360;
const $5dce8c75c54926ac$export$90bfd0dcc25478e1 = 20;
const $5dce8c75c54926ac$export$dd535f74d98d8b3 = 32;
const $5dce8c75c54926ac$export$dba112976ea61483 = $5dce8c75c54926ac$var$POPUP_WIDTH - $5dce8c75c54926ac$export$90bfd0dcc25478e1 * 2;
const $5dce8c75c54926ac$export$fe1082abeeda69ed = 4;
const $5dce8c75c54926ac$export$17ed91292eb6c163 = 16;
const $5dce8c75c54926ac$export$de3cbeaaf9d2669 = 28;
const $5dce8c75c54926ac$export$39aa3a14ebf850c7 = 150;

});

parcelRegister("bKM9a", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e531bab000ea356$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7e531bab000ea356$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyStateMessage: {
        "id": "issue-archival-archives.archives-table.empty-state.empty-state-message",
        "defaultMessage": "We couldn\u2019t find what you\u2019re looking for"
    },
    emptyStateMessagePartTwo: {
        "id": "issue-archival-archives.archives-table.empty-state.empty-state-message-part-two",
        "defaultMessage": "Try using different search terms or filters."
    },
    emptyStateNoDataMessage: {
        "id": "issue-archival-archives.archives-table.empty-state.empty-state-no-data-message",
        "defaultMessage": "There are no archived issues"
    },
    emptyStateNoDataDescriptionMessage: {
        "id": "issue-archival-archives.archives-table.empty-state.empty-state-no-data-description-message",
        "defaultMessage": "Any archived issues in your project will appear here."
    },
    emptyStateArchiveIssueSupportMessage: {
        "id": "issue-archival-archives.archives-table.empty-state.empty-state-archive-issue-support-message",
        "defaultMessage": "More about archiving issues"
    },
    clearSearchMessage: {
        "id": "issue-archival-archives.archives-table.empty-state.clear-search-message",
        "defaultMessage": "Clear search"
    },
    emptyStateNoDataMessageIssueTermRefresh: {
        "id": "issue-archival-archives.archives-table.empty-state.empty-state-no-data-message-issue-term-refresh",
        "defaultMessage": "There are no archived work items"
    },
    emptyStateNoDataDescriptionMessageIssueTermRefresh: {
        "id": "issue-archival-archives.archives-table.empty-state.empty-state-no-data-description-message-issue-term-refresh",
        "defaultMessage": "Any archived work items in your project will appear here."
    },
    emptyStateArchiveIssueSupportMessageIssueTermRefresh: {
        "id": "issue-archival-archives.archives-table.empty-state.empty-state-archive-issue-support-message-issue-term-refresh",
        "defaultMessage": "More about archiving work items"
    },
    emptyStateNoDataDescriptionMessageIssueTermRefreshGalaxia: {
        "id": "issue-archival-archives.archives-table.empty-state.empty-state-no-data-description-message-issue-term-refresh-galaxia",
        "defaultMessage": "Any archived work items in your space will appear here."
    }
});

});


parcelRegister("4n4SV", function(module, exports) {
$parcel$export(module.exports, "default", () => $df448856d4d8b82a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $hzdB4 = parcelRequire("hzdB4");

var $dymbf = parcelRequire("dymbf");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $1LIko = parcelRequire("1LIko");
const $df448856d4d8b82a$var$MAX_IMAGE_WIDTH_PX = 188;
const $df448856d4d8b82a$var$MAX_IMAGE_HEIGHT_PX = 250;
const $df448856d4d8b82a$var$IMAGE_WIDTH_PX = 188;
const $df448856d4d8b82a$var$renderImage = ()=>(0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $dymbf.default))({
        imageWidth: $df448856d4d8b82a$var$IMAGE_WIDTH_PX,
        maxImageWidth: $df448856d4d8b82a$var$MAX_IMAGE_WIDTH_PX,
        maxImageHeight: $df448856d4d8b82a$var$MAX_IMAGE_HEIGHT_PX
    });
const $df448856d4d8b82a$var$ErrorState = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df448856d4d8b82a$export$412bc65ea3f44cf1, {
        "data-testid": "issue-archival-archives.ui.error-state.fetch-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hzdB4.default), {
        renderImage: $df448856d4d8b82a$var$renderImage,
        header: formatMessage((0, $1LIko.default).header),
        description: formatMessage((0, $1LIko.default).description),
        width: "narrow"
    }));
});
var $df448856d4d8b82a$export$2e2bcd8739ae039 // to be wrapped only for components where test-id can't be added on some components
 = $df448856d4d8b82a$var$ErrorState;
const $df448856d4d8b82a$export$412bc65ea3f44cf1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dymbf", function(module, exports) {
$parcel$export(module.exports, "default", () => $42825a5af59db372$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $42825a5af59db372$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("bb5s2")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1ue4T")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $c4huj = parcelRequire("c4huj");

var $1ue4T = parcelRequire("1ue4T");

var $bb5s2 = parcelRequire("bb5s2");
const $42825a5af59db372$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($bb5s2)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1ue4T))
});
var $42825a5af59db372$export$2e2bcd8739ae039 = $42825a5af59db372$var$Illustration;
// for advanced use only
const $42825a5af59db372$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("1ue4T", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("bb5s2", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("1LIko", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab5aaf16fbd0225e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ab5aaf16fbd0225e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    header: {
        "id": "issue-archival-archives.error-state.header",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "issue-archival-archives.error-state.description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian support."
    }
});

});


parcelRegister("3ultg", function(module, exports) {
$parcel$export(module.exports, "Filters", () => $2b73d740e7c1fb4c$export$92a576f896a9bf72);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5vQ2T = parcelRequire("5vQ2T");

var $kRgKj = parcelRequire("kRgKj");
var $awMH0 = parcelRequire("awMH0");

var $cNe2t = parcelRequire("cNe2t");

var $j4qI8 = parcelRequire("j4qI8");

var $lenW7 = parcelRequire("lenW7");

var $h4JbH = parcelRequire("h4JbH");

var $6eQho = parcelRequire("6eQho");

var $gTqmu = parcelRequire("gTqmu");

var $6qkqX = parcelRequire("6qkqX");
const $2b73d740e7c1fb4c$export$92a576f896a9bf72 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const close = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const { filters: filters, projectId: projectId } = (0, $6eQho.useArchiveIssueStates)();
    const { setFilters: setFilters } = (0, $h4JbH.useArchiveIssueActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $awMH0.useAnalyticsEvents)();
    const { fieldConfig: fieldConfig } = (0, $lenW7.getFilterFieldConfig)();
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $j4qI8.default));
    const toggle = (0, $eJOHy.useCallback)(()=>{
        projectId && loadQuery({
            projectId: projectId
        });
        setIsOpen((prevIsOpen)=>!prevIsOpen);
    }, [
        loadQuery,
        projectId
    ]);
    const count = Object.values(filters).flat().length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "issue.issue-view.activity.archived-issues-filter-selected",
        packageName: "jiraArchivedIssues",
        teamName: "kenji",
        fallback: "unmount",
        onError: (error)=>{
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'Filters Set', {
                error: error,
                meta: {
                    id: 'issue.issue-view.activity.archived-issues-filter-selectedr',
                    teamName: 'kenji'
                },
                attributes: {
                    experience: 'archivedIssuesFilterSelectionFailed',
                    analyticsSource: 'jiraArchivedIssues',
                    error: error
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        messageId: "issue-archival-archives.ui.filter.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gTqmu.MenuContent), {
                "data-testid": "issue-archival-archives.ui.filter.filter",
                count: count,
                fieldConfig: fieldConfig,
                filters: filters,
                setFilters: setFilters,
                queryReference: queryReference,
                projectId: projectId
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6qkqX.Trigger), {
                ...triggerProps,
                count: count,
                hasFiltersApplied: count > 0,
                isSelected: isOpen,
                onClick: toggle
            })
    }));
});

});
parcelRegister("j4qI8", function(module, exports) {
$parcel$export(module.exports, "default", () => $82aad3a37a4277e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<305dc7aa45f26b6b406fc962aba7f607>>
 * @relayHash 94c9b01a38450e035b8b9eacd84cf9e7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b0ed954688ed8e457d933100d3b4e1720e9c4e7f3022b071b7e794744efb2186
const $82aad3a37a4277e4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "projectId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v6 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v7 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 16
        }
    ], v8 = [
        {
            "concreteType": "JiraUserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        v4 /*: any*/ 
                    ]
                },
                v5 /*: any*/ 
            ]
        },
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_getArchivedIssuesFilterOptionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraArchivedIssuesFilterOptions",
                            "kind": "LinkedField",
                            "name": "getArchivedIssuesFilterOptions",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "issueTypeFilter_issueArchivalArchives"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "reporterFilter_issueArchivalArchives"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "archivedByFilter_issueArchivalArchives"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_getArchivedIssuesFilterOptionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraArchivedIssuesFilterOptions",
                            "kind": "LinkedField",
                            "name": "getArchivedIssuesFilterOptions",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 7
                                        }
                                    ],
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueTypeId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "medium"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                },
                                                                v2 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ],
                                    "storageKey": "issueTypes(first:7)"
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraUserConnection",
                                    "kind": "LinkedField",
                                    "name": "reporters",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "reporters(first:16)"
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraUserConnection",
                                    "kind": "LinkedField",
                                    "name": "archivedBy",
                                    "plural": false,
                                    "selections": v8 /*: any*/ ,
                                    "storageKey": "archivedBy(first:16)"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b0ed954688ed8e457d933100d3b4e1720e9c4e7f3022b071b7e794744efb2186",
            "metadata": {},
            "name": "main_getArchivedIssuesFilterOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$82aad3a37a4277e4$var$node.hash = "b02eec471fa1758425d0f3d68d9a1be0";
var $82aad3a37a4277e4$export$2e2bcd8739ae039 = $82aad3a37a4277e4$var$node;

});

parcelRegister("lenW7", function(module, exports) {
$parcel$export(module.exports, "getFilterFieldConfig", () => $c3d254425d4c23b9$export$10be1aa6d05cbb70);

var $lTFYR = parcelRequire("lTFYR");

var $gHJsI = parcelRequire("gHJsI");

var $6voQu = parcelRequire("6voQu");

var $111iJ = parcelRequire("111iJ");
const $c3d254425d4c23b9$export$10be1aa6d05cbb70 = ()=>{
    const issueTypes = (0, $6voQu.issueTypeFields)?.data?.node?.getArchivedIssuesFilterOptions?.issueTypes?.edges;
    const reporters = (0, $111iJ.reporterFilterOptions)?.data?.node?.getArchivedIssuesFilterOptions?.reporters?.edges;
    const archivedBy = (0, $lTFYR.archivedByFilterOptions)?.data?.node?.getArchivedIssuesFilterOptions?.archivedBy?.edges;
    const fieldConfig = {};
    const filterFieldsMap = {
        issueType: issueTypes.map((issueType)=>({
                ...issueType,
                label: issueType.name,
                avatar: issueType.avatar.medium,
                square: true,
                value: issueType.name,
                hierarchyLevel: issueType?.hierarchy?.level,
                id: issueType.issueTypeId
            })),
        reporter: reporters.map((reporter)=>({
                ...reporter,
                label: reporter.name,
                value: reporter.accountId,
                avatar: reporter.picture
            })),
        archivedBy: archivedBy.map((archivedByNode)=>({
                ...archivedByNode,
                label: archivedByNode.name,
                value: archivedByNode.accountId,
                avatar: archivedByNode.picture
            }))
    };
    Object.keys((0, $gHJsI.filterFields)).forEach((field)=>{
        if (filterFieldsMap[field] && (0, $gHJsI.filterFields)[field]) {
            (0, $gHJsI.filterFields)[field].options = filterFieldsMap[field];
            fieldConfig[field] = (0, $gHJsI.filterFields)[field];
        } else fieldConfig[field] = (0, $gHJsI.filterFields)[field];
    });
    return {
        fieldConfig: fieldConfig
    };
};

});
parcelRegister("lTFYR", function(module, exports) {
$parcel$export(module.exports, "archivedByFilterOptions", () => $4e5047bd02e0006f$export$34dc078ecb3cb160);
const $4e5047bd02e0006f$export$34dc078ecb3cb160 = {
    data: {
        node: {
            getArchivedIssuesFilterOptions: {
                projectId: 'ari:cloud:jira:TEST--e16459ae-437f-4e97-8a64-3eec474df71b:project/10001',
                archivedBy: {
                    edges: [
                        {
                            accountId: '7456224230842',
                            name: 'a1',
                            picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                        },
                        {
                            accountId: '8456225230842',
                            name: 'a2',
                            picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                        },
                        {
                            accountId: '2456224230840',
                            name: 'a3',
                            picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                        }
                    ]
                }
            }
        }
    }
};

});

parcelRegister("6voQu", function(module, exports) {
$parcel$export(module.exports, "issueTypeFields", () => $cf43bfca883a56ce$export$c05597541d190f45);
const $cf43bfca883a56ce$export$c05597541d190f45 = {
    data: {
        node: {
            getArchivedIssuesFilterOptions: {
                projectId: 'ari:cloud:jira:TEST--e16459ae-437f-4e97-8a64-3eec474df71b:project/10001',
                issueTypes: {
                    edges: [
                        {
                            id: 'ari:cloud:jira:28dfbea9-9711-4ee8-8d84-454e910384a9:issue-type/10029',
                            issueTypeId: '10029',
                            name: 'Task',
                            description: 'A small, distinct piece of work.',
                            avatar: {
                                __typename: 'JiraAvatar',
                                small: 'https://suniti.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10557?size=small',
                                medium: 'https://suniti.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10557?size=medium',
                                large: 'https://suniti.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10557'
                            },
                            avatarId: '10557',
                            hierarchy: {
                                level: 0,
                                name: 'Story'
                            }
                        },
                        {
                            issueTypeId: '10006',
                            name: 'Epic',
                            avatar: {
                                medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                            }
                        },
                        {
                            issueTypeId: '10004',
                            name: 'Story',
                            avatar: {
                                medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                            }
                        }
                    ]
                }
            }
        }
    }
};

});

parcelRegister("111iJ", function(module, exports) {
$parcel$export(module.exports, "reporterFilterOptions", () => $1bfad4e211e34bc7$export$79e2d3699b379f83);
const $1bfad4e211e34bc7$export$79e2d3699b379f83 = {
    data: {
        node: {
            getArchivedIssuesFilterOptions: {
                projectId: 'ari:cloud:jira:TEST--e16459ae-437f-4e97-8a64-3eec474df71b:project/10001',
                reporters: {
                    edges: [
                        {
                            accountId: '7456224230842',
                            name: 'a1',
                            picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                        },
                        {
                            accountId: '8456225230842',
                            name: 'a2',
                            picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                        },
                        {
                            accountId: '2456224230840',
                            name: 'a3',
                            picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                        },
                        {
                            accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                            picture: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                            name: 'Rohit Kumar'
                        }
                    ]
                }
            }
        }
    }
};

});


parcelRegister("gTqmu", function(module, exports) {
$parcel$export(module.exports, "MenuContent", () => $0a3a19323ed1c61d$export$479f0f2f71193efe);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $eikN5 = parcelRequire("eikN5");

var $gSqcF = parcelRequire("gSqcF");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0a3a19323ed1c61d$var$LazyMenuContent = (0, $eikN5.lazy)(()=>(parcelRequire("eZyAW")), {
    moduleId: "./src/packages/issue-archival/archives/src/ui/filter/menu-content/main.tsx"
});
const $0a3a19323ed1c61d$export$479f0f2f71193efe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gSqcF.DropdownWrapper), {
        "data-testid": "issue-archival-archives.ui.filter.menu-content.menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a3a19323ed1c61d$var$LazyMenuContent, props)));

});
parcelRegister("gSqcF", function(module, exports) {
$parcel$export(module.exports, "DropdownWrapper", () => $4ae8610b37e0036f$export$5f7211d21bfdae05);
$parcel$export(module.exports, "DropdownHeaderWrapper", () => $4ae8610b37e0036f$export$e23294aded7a8a49);
$parcel$export(module.exports, "DropdownHeaderButtons", () => $4ae8610b37e0036f$export$53ca7a3701b98335);
$parcel$export(module.exports, "FiltersListWrapper", () => $4ae8610b37e0036f$export$a5a9080bd2c85987);
$parcel$export(module.exports, "Section", () => $4ae8610b37e0036f$export$6e2c8f0811a474ce);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $4ae8610b37e0036f$var$POPUP_WIDTH = 360;
const $4ae8610b37e0036f$var$DEFAULT_POPUP_OFFSET_TOP = 215;
const $4ae8610b37e0036f$var$DROPDOWN_HEADER_HEIGHT = 52;
const $4ae8610b37e0036f$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
const $4ae8610b37e0036f$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul91gwv",
            __cmplp.className
        ])
    });
});
const $4ae8610b37e0036f$export$6c560fdadeb11d78 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1by48d2": (0, $awdRS.default)(`calc(${__cmplp.offsetTop && __cmplp.offsetTop > $4ae8610b37e0036f$var$DEFAULT_POPUP_OFFSET_TOP ? '95vh' : '85vh'} - ${// dynamically calculating offsetTop on popup mount
            (__cmplp.offsetTop ?? $4ae8610b37e0036f$var$DEFAULT_POPUP_OFFSET_TOP) + $4ae8610b37e0036f$var$DROPDOWN_HEADER_HEIGHT}px)`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _ln19p27b _c71l16u6",
            __cmplp.className
        ])
    });
});
const $4ae8610b37e0036f$export$e23294aded7a8a49 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q71bhr _2rkofajl _1yt4jd10 _11c8dcr7 _16qsglyw _1pbykb7n _kqswh2mm _1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4ae8610b37e0036f$export$53ca7a3701b98335 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $4ae8610b37e0036f$export$1a67069896d998b9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _19pku2gc _2hwxpxbi _otyr1ejb _18u0pxbi",
            __cmplp.className
        ])
    });
});
const $4ae8610b37e0036f$export$a5a9080bd2c85987 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1gwv",
            __cmplp.className
        ])
    });
});
const $4ae8610b37e0036f$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1ejb _1e0c1txw _2lx21bp4 _n3td1ejb",
            __cmplp.className
        ])
    });
});
const $4ae8610b37e0036f$export$1faf3c7558df435 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $4ae8610b37e0036f$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpidpf _n3tdidpf",
            __cmplp.className
        ])
    });
});
const $4ae8610b37e0036f$export$c5e20d5e200edfe2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eZyAW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("acZnJ"),
    $ewTvA("htu6Z"),
    $ewTvA("eq9Jp"),
    $ewTvA("7ykvR")
]).then(()=>parcelRequire('h7j9y'));

});


parcelRegister("6qkqX", function(module, exports) {
$parcel$export(module.exports, "Trigger", () => $a0e3ba1a8d027b71$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $48ZTT = parcelRequire("48ZTT");

var $2TVbc = parcelRequire("2TVbc");

var $lRq8t = parcelRequire("lRq8t");

var $12Fgt = parcelRequire("12Fgt");
const $a0e3ba1a8d027b71$var$FILTER_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2TVbc))), {
    label: "",
    LEGACY_size: "small"
});
const $a0e3ba1a8d027b71$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, isDisabled: isDisabled, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const filterMessage = (0, $eJOHy.useMemo)(()=>{
        if (count > 0) return formatMessage((0, $12Fgt.default).filtersCount, {
            filters: count
        });
        if (hasFiltersApplied) return formatMessage((0, $12Fgt.default).buttonWithFilters);
        return formatMessage((0, $12Fgt.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48ZTT.default), {
        ...otherProps,
        ref: ref,
        testId: "issue-archival-archives.ui.filter.trigger.button-wrapper",
        iconBefore: $a0e3ba1a8d027b71$var$FILTER_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a0e3ba1a8d027b71$var$ButtonContents, null, filterMessage));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0e3ba1a8d027b71$var$ButtonContents = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("12Fgt", function(module, exports) {
$parcel$export(module.exports, "default", () => $1417a639d8f1dc4e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1417a639d8f1dc4e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    filtersCount: {
        "id": "issue-archival-archives.filter.trigger.filters-count",
        "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
    },
    filterButton: {
        "id": "issue-archival-archives.filter.trigger.filter-button",
        "defaultMessage": "Filter"
    },
    buttonWithFilters: {
        "id": "issue-archival-archives.filter.trigger.button-with-filters",
        "defaultMessage": "Filters applied"
    },
    newLozenge: {
        "id": "issue-archival-archives.filter.trigger.new-lozenge",
        "defaultMessage": "New"
    },
    newLozengeTooltip: {
        "id": "issue-archival-archives.filter.trigger.new-lozenge-tooltip",
        "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
    }
});

});



parcelRegister("c85dS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2099bfa68247db8e$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $gHI4w = parcelRequire("gHI4w");

var $lRq8t = parcelRequire("lRq8t");

var $dSUfj = parcelRequire("dSUfj");

var $cHtIB = parcelRequire("cHtIB");

var $gCY1z = parcelRequire("gCY1z");

var $4cTDP = parcelRequire("4cTDP");

var $dbNka = parcelRequire("dbNka");

var $5sdWI = parcelRequire("5sdWI");
const $2099bfa68247db8e$var$ArchiveIssuePageHeader = ({ bottomBar: bottomBar })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const projectKey = match.params.projectKey || '';
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $dSUfj.default));
    (0, $eJOHy.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2099bfa68247db8e$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
        breadcrumbs: queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dbNka.ArchiveIssueBreadcrumbs), {
            queryReference: queryReference,
            projectKey: projectKey
        }),
        bottomBar: bottomBar
    }, (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $5sdWI.default).issueArchiveTitleIssueTermRefresh) : formatMessage((0, $5sdWI.default).issueArchiveTitle)));
};
var $2099bfa68247db8e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $2099bfa68247db8e$var$ArchiveIssuePageHeader;
const $2099bfa68247db8e$var$HeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f31jfw _n3tdidpf _19bv1jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dSUfj", function(module, exports) {
$parcel$export(module.exports, "default", () => $7007a838df84950d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<433437f8984db1f87e99e6534db6f2d7>>
 * @relayHash 1d3ac54d7ee746155eab3922887ae845
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 63145884bb9041214fe3460df121f3c176229f55baa620e32e723f8283d86dee
const $7007a838df84950d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "projectKey"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jiraProjectByKey",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainArcivedIssuesProjectNameQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainArcivedIssuesProjectNameQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "63145884bb9041214fe3460df121f3c176229f55baa620e32e723f8283d86dee",
            "metadata": {},
            "name": "mainArcivedIssuesProjectNameQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7007a838df84950d$var$node.hash = "7697dc80c1c8d6b9f572e8750cb6c130";
var $7007a838df84950d$export$2e2bcd8739ae039 = $7007a838df84950d$var$node;

});

parcelRegister("dbNka", function(module, exports) {
$parcel$export(module.exports, "ArchiveIssueBreadcrumbs", () => $5991a2c71c2e2580$export$613314e61200a8e8);

var $dSUfj = parcelRequire("dSUfj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $h6slU = parcelRequire("h6slU");

var $gFB4g = parcelRequire("gFB4g");

var $ch9En = parcelRequire("ch9En");

var $h4JbH = parcelRequire("h4JbH");
const $5991a2c71c2e2580$export$613314e61200a8e8 = ({ projectKey: projectKey, queryReference: queryReference })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-archive-breadcrumbs",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5991a2c71c2e2580$var$BreadcrumbFallback, {
            projectKey: projectKey,
            projectName: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5991a2c71c2e2580$var$ProjectBreadcrumbWithData, {
        queryReference: queryReference,
        projectKey: projectKey
    }));
const $5991a2c71c2e2580$var$ProjectBreadcrumbWithData = ({ queryReference: queryReference, projectKey: projectKey })=>{
    const data = (0, $j4oe4.usePreloadedQuery)((0, $dSUfj.default), queryReference);
    const projectName = data?.jira?.jiraProjectByKey?.name ?? '';
    const projectId = data?.jira?.jiraProjectByKey?.id ?? '';
    const { setProjectId: setProjectId } = (0, $h4JbH.useArchiveIssueActions)();
    (0, $eJOHy.useEffect)(()=>{
        if (projectId) setProjectId(projectId);
    }, [
        projectId,
        setProjectId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gFB4g.default), {
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null)));
};
const $5991a2c71c2e2580$var$BreadcrumbFallback = ({ projectKey: projectKey, projectName: projectName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gFB4g.default), {
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null));

});

parcelRegister("5sdWI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e39cbacbd2cb53b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0e39cbacbd2cb53b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issueArchiveTitle: {
        "id": "issue-archival-archives.header.issue-archive-title",
        "defaultMessage": "Archived issues"
    },
    issueArchiveTitleIssueTermRefresh: {
        "id": "issue-archival-archives.header.issue-archive-title-issue-term-refresh",
        "defaultMessage": "Archived work items"
    }
});

});


parcelRegister("4AXtr", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d826e31631b8cb9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ch9En = parcelRequire("ch9En");

var $7bMFE = parcelRequire("7bMFE");

var $coBPg = parcelRequire("coBPg");

var $cHtIB = parcelRequire("cHtIB");

var $2FqDG = parcelRequire("2FqDG");

var $2rPWc = parcelRequire("2rPWc");

var $h4JbH = parcelRequire("h4JbH");

var $6eQho = parcelRequire("6eQho");

var $duaMk = parcelRequire("duaMk");
const $4d826e31631b8cb9$var$Archives = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $7bMFE.default));
    const [projectKey] = (0, $2FqDG.usePathParam)('projectKey');
    const { filters: filters, currentPage: currentPage, searchBy: searchBy, refetchArchivesIssuesData: refetchArchivesIssuesData } = (0, $6eQho.useArchiveIssueStates)();
    const { setRefetchArchivesIssuesData: setRefetchArchivesIssuesData } = (0, $h4JbH.useArchiveIssueActions)();
    const selectedIssueTypes = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filters?.issueType?.map((issueType)=>({
                issueTypeId: issueType?.id || ''
            })) || [], [
        filters
    ]);
    const selectedReporters = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filters?.reporter?.map((reporter)=>`ari:cloud:identity::user/${reporter.value}`) || [], [
        filters
    ]);
    const selectedArchivedBy = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filters?.archivedBy?.map((archivedBy)=>`ari:cloud:identity::user/${archivedBy.value}`) || [], [
        filters
    ]);
    const archivalDateRange = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>filters?.archivedDate?.value || {}, [
        filters
    ]);
    const first = currentPage * (0, $2rPWc.NUMBER_OF_ISSUES_PER_PAGE);
    const last = (0, $2rPWc.NUMBER_OF_ISSUES_PER_PAGE);
    const fetchData = (0, $eJOHy.useCallback)(()=>{
        if (projectKey && cloudId) loadQuery({
            projectKey: projectKey,
            cloudId: cloudId,
            selectedIssueTypes: selectedIssueTypes,
            selectedArchivedBy: selectedArchivedBy,
            selectedReporters: selectedReporters,
            archivalDateRange: archivalDateRange,
            first: first,
            last: last,
            searchBy: searchBy
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        archivalDateRange,
        cloudId,
        first,
        last,
        loadQuery,
        projectKey,
        searchBy,
        selectedArchivedBy,
        selectedIssueTypes,
        selectedReporters
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (refetchArchivesIssuesData) setRefetchArchivesIssuesData(false);
        fetchData();
    }, [
        fetchData,
        refetchArchivesIssuesData,
        setRefetchArchivesIssuesData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "archives-main",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coBPg.NativeIssueTableSkeleton), null)
    }, queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $duaMk.ArchivesTable), {
        queryReference: queryReference
    }));
};
var $4d826e31631b8cb9$export$2e2bcd8739ae039 = $4d826e31631b8cb9$var$Archives;

});
parcelRegister("7bMFE", function(module, exports) {
$parcel$export(module.exports, "default", () => $d05ed06c43e33ef8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d04b69fa580799bc0c89db111f16e429>>
 * @relayHash 0e776853fefa159d816e2c024912cbe1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2cdf282128aedbae37919f8086e582b2f8228a0c742a9c35de5a5b789174c666
const $d05ed06c43e33ef8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "archivalDateRange"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchBy"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "selectedArchivedBy"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "selectedIssueTypes"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "selectedReporters"
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = [
        v9 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "byArchivalDateRange",
                    "variableName": "archivalDateRange"
                },
                {
                    "kind": "Variable",
                    "name": "byArchivedBy",
                    "variableName": "selectedArchivedBy"
                },
                {
                    "kind": "Variable",
                    "name": "byIssueType",
                    "variableName": "selectedIssueTypes"
                },
                {
                    "kind": "Variable",
                    "name": "byProject",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "byReporter",
                    "variableName": "selectedReporters"
                }
            ],
            "kind": "ObjectValue",
            "name": "filterBy"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "searchBy",
            "variableName": "searchBy"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v12 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "medium"
            }
        ]
    }, v16 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v19 = [
        {
            "kind": "Literal",
            "name": "ids",
            "value": [
                "reporter"
            ]
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "archivedOn"
    }, v21 = {
        "kind": "ScalarField",
        "name": "text"
    }, v22 = {
        "alias": "unarchiveIssuePermission",
        "args": [
            v9 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "permission",
                "value": "UNARCHIVE_ISSUES"
            },
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "hasProjectPermission"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_getArchivedIssuesForProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "getArchivedIssuesForProject",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "archivedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": v19 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        v14 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"reporter\"])"
                                                },
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSingleLineTextField",
                                                    "kind": "LinkedField",
                                                    "name": "summaryField",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_getArchivedIssuesForProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "getArchivedIssuesForProject",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "archivedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": v19 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        v17 /*: any*/ ,
                                                                                        v14 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                        },
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"reporter\"])"
                                                },
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSingleLineTextField",
                                                    "kind": "LinkedField",
                                                    "name": "summaryField",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "2cdf282128aedbae37919f8086e582b2f8228a0c742a9c35de5a5b789174c666",
            "metadata": {},
            "name": "main_getArchivedIssuesForProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d05ed06c43e33ef8$var$node.hash = "057ef912015668de758a06351fea8bcf";
var $d05ed06c43e33ef8$export$2e2bcd8739ae039 = $d05ed06c43e33ef8$var$node;

});

parcelRegister("coBPg", function(module, exports) {
$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $f004264ba9491c9c$export$309a6db85e3f2aaa);
/* NativeIssueTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $HE9R3 = parcelRequire("HE9R3");
const $f004264ba9491c9c$var$customCssStyles = null;
const $f004264ba9491c9c$var$containerStyles = {
    height: '448px'
};
const $f004264ba9491c9c$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($HE9R3))),
        containerStyles: $f004264ba9491c9c$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("HE9R3", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});


parcelRegister("duaMk", function(module, exports) {
$parcel$export(module.exports, "ArchivesTable", () => $a4f34f3619f87864$export$a7e6298ee2d38c94);

var $7bMFE = parcelRequire("7bMFE");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $b77xX = parcelRequire("b77xX");

var $lRrud = parcelRequire("lRrud");
var $e7uOb = parcelRequire("e7uOb");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $16sa1 = parcelRequire("16sa1");

var $2rPWc = parcelRequire("2rPWc");

var $h4JbH = parcelRequire("h4JbH");

var $6eQho = parcelRequire("6eQho");

var $i0YXt = parcelRequire("i0YXt");

var $3kkEl = parcelRequire("3kkEl");

var $5RoI6 = parcelRequire("5RoI6");

var $8uxOY = parcelRequire("8uxOY");

var $jacMC = parcelRequire("jacMC");

var $5kRGj = parcelRequire("5kRGj");

var $8nPX3 = parcelRequire("8nPX3");

var $fLLr9 = parcelRequire("fLLr9");

var $kccqY = parcelRequire("kccqY");

var $2UhUW = parcelRequire("2UhUW");
const $a4f34f3619f87864$export$a7e6298ee2d38c94 = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const state = (0, $6eQho.useArchiveIssueStates)();
    const { setIssuesInCurrentPage: setIssuesInCurrentPage, setArchivesIssueDataPresent: setArchivesIssueDataPresent, updateIssueDetails: updateIssueDetails } = (0, $h4JbH.useArchiveIssueActions)();
    const isLoading = (0, $6eQho.getLoadingState)({
        state: state
    });
    const currentPage = (0, $6eQho.getCurrentPage)({
        state: state
    });
    const data = (0, $j4oe4.usePreloadedQuery)((0, $7bMFE.default), queryReference);
    const unarchiveIssuePermission = data?.jira?.unarchiveIssuePermission || false;
    const head = (0, $5RoI6.default)(unarchiveIssuePermission);
    const rows = data?.jira?.getArchivedIssuesForProject?.edges?.map((issueNode)=>{
        const issue = issueNode?.node;
        const issueId = issue?.issueId?.toString() ?? '';
        const reporter = issue?.fieldsById?.edges?.[0]?.node?.user;
        const shouldHighlightRow = (0, $6eQho.isIssueSelected)({
            state: state,
            pageNumber: currentPage,
            issueId: issueId
        });
        const issueTypeName = issue?.issueTypeField?.issueType?.name ?? '';
        const hierarchyLevel = issue?.issueTypeField?.issueType?.hierarchy?.level ?? 0;
        const selectCell = unarchiveIssuePermission && [
            {
                key: `select-${issueId}`,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nPX3.SelectCell), {
                    isChecked: shouldHighlightRow,
                    isDisabled: hierarchyLevel === -1,
                    issueId: issueId ?? '',
                    pageNumber: currentPage,
                    issueKey: issue?.key ?? ''
                })
            }
        ] || [];
        return {
            key: issueId,
            cells: [
                ...selectCell,
                {
                    key: `type-${issueId}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kccqY.TypeCell), {
                        iconUrl: issue?.issueTypeField?.issueType?.avatar?.medium ?? '',
                        name: issueTypeName
                    })
                },
                {
                    key: `key-${issueId}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kRGj.KeyCell), {
                        issueKey: issue?.key ?? ''
                    })
                },
                {
                    key: `summary-${issueId}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fLLr9.TextCell), {
                        text: issue?.summaryField?.text ?? ''
                    })
                },
                {
                    key: `reporter-${issueId}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UhUW.UserCell), {
                        user: {
                            id: reporter?.id || '',
                            name: reporter?.name || '',
                            avatarUrl: reporter?.picture || ''
                        }
                    })
                },
                {
                    key: `archivedDate-${issueId}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jacMC.default), {
                        archivedDate: issue?.archivedOn ?? ''
                    })
                },
                {
                    key: `archviedBy-${issueId}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UhUW.UserCell), {
                        user: {
                            id: issue?.archivedBy?.id || '',
                            name: issue?.archivedBy?.name || '',
                            avatarUrl: issue?.archivedBy?.picture || ''
                        }
                    })
                }
            ],
            testId: `issue-archival-archives.archives-table.row-${issueId}`
        };
    }) || [];
    (0, $eJOHy.useEffect)(()=>{
        // Update store with fetched issues data:
        const issuesInCurrentPage = [];
        const issuesDetails = {};
        data?.jira?.getArchivedIssuesForProject?.edges?.forEach((issueNode)=>{
            const issue = issueNode?.node;
            const issueId = issueNode?.node?.issueId?.toString() ?? '';
            const issueKey = issue?.key?.toString() ?? '';
            const hierarchyLevel = issue?.issueTypeField?.issueType?.hierarchy?.level ?? 0;
            if (hierarchyLevel !== -1) issuesInCurrentPage.push(issueId);
            issuesDetails[issueId] = {
                issueId: issueId,
                issueKey: issueKey,
                hierarchyLevel: hierarchyLevel
            };
        });
        if (issuesInCurrentPage.length > 0) {
            setIssuesInCurrentPage(issuesInCurrentPage);
            updateIssueDetails(issuesDetails);
        }
    }, [
        setIssuesInCurrentPage,
        updateIssueDetails,
        data
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!state.refetchArchivesIssuesData && rows?.length === 0 && Object.keys(state.filters).length === 0 && state.searchBy === '') setArchivesIssueDataPresent(false);
    }, [
        rows?.length,
        setArchivesIssueDataPresent,
        state.filters,
        state.refetchArchivesIssuesData,
        state.searchBy
    ]);
    const totalIssueCount = data?.jira?.getArchivedIssuesForProject?.totalCount ?? 0;
    const firstIssuePosition = totalIssueCount ? 1 + (0, $2rPWc.NUMBER_OF_ISSUES_PER_PAGE) * (currentPage - 1) : totalIssueCount;
    const lastIssuePosition = (0, $2rPWc.NUMBER_OF_ISSUES_PER_PAGE) * currentPage > totalIssueCount ? totalIssueCount : (0, $2rPWc.NUMBER_OF_ISSUES_PER_PAGE) * currentPage;
    const countRendererData = {
        issueNavigatorPageInfo: {
            firstIssuePosition: firstIssuePosition,
            lastIssuePosition: lastIssuePosition
        },
        totalIssueSearchResultCount: totalIssueCount
    };
    const totalPages = Math.ceil(totalIssueCount / (0, $2rPWc.NUMBER_OF_ISSUES_PER_PAGE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-view-archived-issues-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "issue.issue-view.activity.archived-issues-table",
        packageName: "jiraArchivedIssues",
        teamName: "kenji",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a4f34f3619f87864$var$BorderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _189ee4h9 _1dqonqa1 _1h6dmuej _1reo1wug _18m91wug _c71ln9zg _13liu2gc _qrwqu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), {
        xcss: $a4f34f3619f87864$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b77xX.default), {
        isLoading: isLoading,
        head: head,
        rows: rows,
        isFixedSize: true,
        label: formatMessage((0, $8uxOY.default).archivesTableLabel),
        loadingLabel: formatMessage((0, $8uxOY.default).loadingArchivesTableLabel),
        testId: (0, $2rPWc.ARCHIVES_TABLE_TEST_ID)
    })), !rows || rows.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0YXt.ArchivesTableEmptyState), null) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3kkEl.FooterRenderer), {
        currentPage: currentPage,
        totalPages: totalPages,
        countRendererData: countRendererData
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a4f34f3619f87864$var$BorderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _cnoh2smr _ye9xglyw _gstti7a9 _1j52i8ux _1fr812x7 _1160u2gc _lxpr12x7 _il49u2gc _2b5e1m6u _126a1m6u _yb6gnqa1 _jyzrnqa1 _1c2jmuej _1ppimuej _1rg5cfaq _1l74cfaq _8k75nkob _10wbnkob _1akgglyw _1lmscfaq _1ik0glyw _15r0glyw _im2gglyw _823bu2gc _1td7u2gc _1ydjglyw _i38zglyw _8o61u2gc _mgodu2gc _fw9p1if8 _7oeaidpf _1h3evuon _1qlckb7n _19zku2gc _ihu1u2gc",
            __cmplp.className
        ])
    });
});
const $a4f34f3619f87864$var$overflowStyles = null;
const $a4f34f3619f87864$var$wrapperStyles = (0, $e7uOb.xcss)({
    maxHeight: '75vh',
    width: '100%',
    minWidth: '1120px',
    marginBottom: 'space.negative.300'
});

});
parcelRegister("b77xX", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd5cd3fe79138d02$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jAvsa = parcelRequire("jAvsa");

var $2XurI = parcelRequire("2XurI");

var $7XlIW = parcelRequire("7XlIW");
class $cd5cd3fe79138d02$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $jAvsa.default),
            onSort: (0, $jAvsa.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7XlIW.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $2XurI.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("2XurI", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $9108a57c9c029d34$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $9108a57c9c029d34$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $9108a57c9c029d34$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $9108a57c9c029d34$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $9108a57c9c029d34$export$c476bbe5da59992d);
const $9108a57c9c029d34$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $9108a57c9c029d34$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $9108a57c9c029d34$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $9108a57c9c029d34$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $9108a57c9c029d34$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $9108a57c9c029d34$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $9108a57c9c029d34$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $9108a57c9c029d34$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("7XlIW", function(module, exports) {
$parcel$export(module.exports, "default", () => $131f271ff9ab9b71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gfwtz = parcelRequire("gfwtz");

var $jAvsa = parcelRequire("jAvsa");


var $2XurI = parcelRequire("2XurI");

var $lVcy6 = parcelRequire("lVcy6");

var $84Uk6 = parcelRequire("84Uk6");

var $4c5tI = parcelRequire("4c5tI");

var $j5FGT = parcelRequire("j5FGT");

var $9gO5j = parcelRequire("9gO5j");

var $cCDAg = parcelRequire("cCDAg");

var $7vEky = parcelRequire("7vEky");

var $3E3Uc = parcelRequire("3E3Uc");
function $131f271ff9ab9b71$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $180c9910c3a22bd2$export$b6abcf7fa1d94f65:
            return 0, $180c9910c3a22bd2$export$1dee026a19752d6b;
        case 0, $180c9910c3a22bd2$export$1dee026a19752d6b:
            return 0, $180c9910c3a22bd2$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $131f271ff9ab9b71$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $jAvsa.default), onSort: providedOnSort = (0, $jAvsa.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $jAvsa.default), onRankEnd: providedOnRankEnd = (0, $jAvsa.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eJOHy.useState)(false);
    const tableBodyRef = (0, $eJOHy.useRef)(null);
    const onSort = (0, $gfwtz.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $gfwtz.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eJOHy.useEffect)(()=>{
        (0, $2XurI.validateSortKey)(sortKey, head);
        (0, $2XurI.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $180c9910c3a22bd2$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $180c9910c3a22bd2$export$1dee026a19752d6b) : $131f271ff9ab9b71$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $2XurI.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $180c9910c3a22bd2$export$7b93a10c0fefe3e3) : (0, $180c9910c3a22bd2$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84Uk6.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84Uk6.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cCDAg.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lVcy6.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lVcy6.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3E3Uc.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $gt9Am.jsx)($131f271ff9ab9b71$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lVcy6.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7vEky.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9gO5j.default), {
                isLoading: isLoading,
                spinnerSize: (0, $180c9910c3a22bd2$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $131f271ff9ab9b71$var$RankableTableBody = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("53wtL")));
const $131f271ff9ab9b71$var$TableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4c5tI.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j5FGT.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($131f271ff9ab9b71$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$131f271ff9ab9b71$export$2e2bcd8739ae039 = $131f271ff9ab9b71$var$DynamicTable;

});
const $180c9910c3a22bd2$export$1dee026a19752d6b = 'ASC';
const $180c9910c3a22bd2$export$b6abcf7fa1d94f65 = 'DESC';
const $180c9910c3a22bd2$export$71dd4c8ecd45e95f = 'small';
const $180c9910c3a22bd2$export$7b93a10c0fefe3e3 = 'large';
const $180c9910c3a22bd2$export$3843c586a90b9cbf = 0.22;

parcelRegister("lVcy6", function(module, exports) {
$parcel$export(module.exports, "Table", () => $74c94480b616ac07$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $74c94480b616ac07$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $74c94480b616ac07$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $74c94480b616ac07$var$fixedSizeTableStyles = null;
const $74c94480b616ac07$var$tableStyles = null;
const $74c94480b616ac07$var$bodyBorder = null;
const $74c94480b616ac07$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CCE0FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #388BFF)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $hcewu.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r187z"
        ]),
        children: children
    });
});
const $74c94480b616ac07$var$captionStyles = null;
const $74c94480b616ac07$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("caption", {
        className: (0, $hcewu.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $74c94480b616ac07$var$paginationWrapperStyles = null;
const $74c94480b616ac07$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("84Uk6", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $b2de1bbb8a9bd0ef$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $b2de1bbb8a9bd0ef$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b2de1bbb8a9bd0ef$var$fixedHeightStyles = null;
const $b2de1bbb8a9bd0ef$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $hcewu.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $b2de1bbb8a9bd0ef$var$emptyViewContainerStyles = null;
const $b2de1bbb8a9bd0ef$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $hcewu.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("4c5tI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e35eb84ead0f19d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bB3lL = parcelRequire("bB3lL");

var $f3Y9F = parcelRequire("f3Y9F");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $4e35eb84ead0f19d$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $f3Y9F.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $4e35eb84ead0f19d$var$Body = (0, $bB3lL.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4e35eb84ead0f19d$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4e35eb84ead0f19d$export$2e2bcd8739ae039 = $4e35eb84ead0f19d$var$Body;

});
parcelRegister("bB3lL", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a92af113ce2bd88$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $2XurI = parcelRequire("2XurI");
const $8a92af113ce2bd88$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $8a92af113ce2bd88$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $180c9910c3a22bd2$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $8a92af113ce2bd88$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $8a92af113ce2bd88$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $8a92af113ce2bd88$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $2XurI.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $8a92af113ce2bd88$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $2XurI.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("f3Y9F", function(module, exports) {
$parcel$export(module.exports, "default", () => $97d45a7066f4f45e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8Enim = parcelRequire("8Enim");

var $hMaHG = parcelRequire("hMaHG");
const $97d45a7066f4f45e$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hMaHG.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $8Enim.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$97d45a7066f4f45e$export$2e2bcd8739ae039 = $97d45a7066f4f45e$var$Row;

});
parcelRegister("8Enim", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $f52ad0c348d21b0d$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7vb1u = parcelRequire("7vb1u");
const $f52ad0c348d21b0d$var$fixedSizeTruncateStyles = null;
const $f52ad0c348d21b0d$var$overflowTruncateStyles = null;
const $f52ad0c348d21b0d$var$truncationWidthStyles = null;
const $f52ad0c348d21b0d$var$cellStyles = null;
const $f52ad0c348d21b0d$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $7vb1u.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("7vb1u", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $6a99f42e7a2db536$export$5e6497a652ae30b5);
const $6a99f42e7a2db536$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $6a99f42e7a2db536$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$6a99f42e7a2db536$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("hMaHG", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $0fc2a697c5436d3f$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $0fc2a697c5436d3f$var$rowStyles = null;
const $0fc2a697c5436d3f$var$rowBackgroundStyles = null;
const $0fc2a697c5436d3f$var$rowHighlightedBackgroundStyles = null;
const $0fc2a697c5436d3f$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_bfhk1w7a _1ygbsglb _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("j5FGT", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $1b0b54dcaaabbede$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $1b0b54dcaaabbede$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("9gO5j", function(module, exports) {
$parcel$export(module.exports, "default", () => $ead16625ff2449cc$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $IuHzu = parcelRequire("IuHzu");


var $9X894 = parcelRequire("9X894");
class $ead16625ff2449cc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $180c9910c3a22bd2$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $180c9910c3a22bd2$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9X894.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9X894.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9X894.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $IuHzu.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("9X894", function(module, exports) {
$parcel$export(module.exports, "Container", () => $d5c433ee8ecb4f95$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $d5c433ee8ecb4f95$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $d5c433ee8ecb4f95$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $d5c433ee8ecb4f95$export$c335a80381ec61f5 = '--contents-opacity';
const $d5c433ee8ecb4f95$var$containerStyles = null;
const $d5c433ee8ecb4f95$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $d5c433ee8ecb4f95$var$contentsContainerStyles = null;
const $d5c433ee8ecb4f95$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$d5c433ee8ecb4f95$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $hcewu.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $d5c433ee8ecb4f95$var$spinnerContainerStyles = null;
const $d5c433ee8ecb4f95$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("cCDAg", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6cbe7b82bcd975c$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $IuHzu = parcelRequire("IuHzu");


var $hGAS8 = parcelRequire("hGAS8");
class $d6cbe7b82bcd975c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $180c9910c3a22bd2$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $180c9910c3a22bd2$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hGAS8.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGAS8.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGAS8.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $IuHzu.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("hGAS8", function(module, exports) {
$parcel$export(module.exports, "Container", () => $edca7466d01beae0$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $edca7466d01beae0$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $edca7466d01beae0$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $edca7466d01beae0$var$containerStyles = null;
const $edca7466d01beae0$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $edca7466d01beae0$var$spinnerBackdropStyles = null;
const $edca7466d01beae0$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $edca7466d01beae0$var$spinnerContainerStyles = null;
const $edca7466d01beae0$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("7vEky", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d8bfb3e1590ace1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8PbUo = parcelRequire("8PbUo");
class $4d8bfb3e1590ace1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8PbUo.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("8PbUo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7581583b7ec320ce$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gfwtz = parcelRequire("gfwtz");

var $jAvsa = parcelRequire("jAvsa");

var $4KsTk = parcelRequire("4KsTk");

var $j8wvR = parcelRequire("j8wvR");

var $8EWQq = parcelRequire("8EWQq");

var $9x9ko = parcelRequire("9x9ko");
var $2ecQp = parcelRequire("2ecQp");

var $9rxvK = parcelRequire("9rxvK");

var $5mO4w = parcelRequire("5mO4w");

var $afn4y = parcelRequire("afn4y");

var $lUzlH = parcelRequire("lUzlH");

var $gOdiR = parcelRequire("gOdiR");
const $7581583b7ec320ce$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $7581583b7ec320ce$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $7581583b7ec320ce$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($j8wvR))) : (0, (/*@__PURE__*/$parcel$interopDefault($8EWQq)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9x9ko.default), {
        as: "span",
        xcss: $7581583b7ec320ce$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $7581583b7ec320ce$var$InnerPagination({ components: components = (0, $lUzlH.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $lUzlH.emptyObject), max: max = 7, onChange: onChange = (0, $jAvsa.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $afn4y.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $4KsTk.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $gfwtz.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$7581583b7ec320ce$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2ecQp.default), {
            as: "li",
            xcss: $7581583b7ec320ce$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5mO4w.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9x9ko.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2ecQp.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9rxvK.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($7581583b7ec320ce$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2ecQp.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $7581583b7ec320ce$var$styles.paginationMenu,
                    children: (0, $gOdiR.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9rxvK.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($7581583b7ec320ce$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $7581583b7ec320ce$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($7581583b7ec320ce$var$InnerPagination));
var $7581583b7ec320ce$export$2e2bcd8739ae039 = $7581583b7ec320ce$var$Pagination;

});
parcelRegister("j8wvR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e8ea817ec2fe685ddbf301b825d4978>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dee7fc0f649d7b1c$var$_react = $dee7fc0f649d7b1c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $dee7fc0f649d7b1c$var$_chevronLeft = $dee7fc0f649d7b1c$var$_interopRequireDefault((parcelRequire("qjgUc")));

var $dee7fc0f649d7b1c$var$_chevronLeftLarge = $dee7fc0f649d7b1c$var$_interopRequireDefault((parcelRequire("7B6RU")));
function $dee7fc0f649d7b1c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dee7fc0f649d7b1c$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $dee7fc0f649d7b1c$var$_react.default.createElement($dee7fc0f649d7b1c$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $dee7fc0f649d7b1c$var$_chevronLeftLarge.default
    }, props));
$dee7fc0f649d7b1c$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $dee7fc0f649d7b1c$var$_default = module.exports.default = $dee7fc0f649d7b1c$var$ChevronLeftIcon;

});
parcelRegister("qjgUc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04f160c62ffc64ae$var$_react = $04f160c62ffc64ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $04f160c62ffc64ae$var$_baseNew = $04f160c62ffc64ae$var$_interopRequireDefault((parcelRequire("qZpIR")));
function $04f160c62ffc64ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04f160c62ffc64ae$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $04f160c62ffc64ae$var$_react.default.createElement($04f160c62ffc64ae$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$04f160c62ffc64ae$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $04f160c62ffc64ae$var$_default = module.exports.default = $04f160c62ffc64ae$var$ChevronLeftIcon;

});

parcelRegister("7B6RU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5881510b0c710779$var$_react = $5881510b0c710779$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4PsdO = parcelRequire("4PsdO");
function $5881510b0c710779$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5881510b0c710779$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $5881510b0c710779$var$_react.default.createElement($4PsdO.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props));
$5881510b0c710779$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $5881510b0c710779$var$_default = module.exports.default = $5881510b0c710779$var$ChevronLeftLargeIcon;

});


parcelRegister("9rxvK", function(module, exports) {
$parcel$export(module.exports, "default", () => $4db252987f839d29$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $48ZTT = parcelRequire("48ZTT");
function $4db252987f839d29$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48ZTT.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("5mO4w", function(module, exports) {
$parcel$export(module.exports, "default", () => $d35859e94ae5f2ff$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $48ZTT = parcelRequire("48ZTT");
function $d35859e94ae5f2ff$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48ZTT.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("afn4y", function(module, exports) {
$parcel$export(module.exports, "default", () => $744f4a8518a64905$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9x9ko = parcelRequire("9x9ko");
var $1hnCR = parcelRequire("1hnCR");

var $guWvZ = parcelRequire("guWvZ");
const $744f4a8518a64905$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $744f4a8518a64905$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9x9ko.default), {
        as: "li",
        testId: testId,
        xcss: $744f4a8518a64905$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1hnCR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $guWvZ.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("lUzlH", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $42b526a3b27c81db$export$3f860eba1218f8d3);
const $42b526a3b27c81db$export$3f860eba1218f8d3 = {};

});

parcelRegister("gOdiR", function(module, exports) {
$parcel$export(module.exports, "default", () => $771141511b7aa1f5$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $771141511b7aa1f5$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $771141511b7aa1f5$export$2e2bcd8739ae039 = $771141511b7aa1f5$var$collapseRange;

});



parcelRegister("3E3Uc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e07f27b02dcf7be4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2XurI = parcelRequire("2XurI");

var $gRD2n = parcelRequire("gRD2n");

var $jTfYA = parcelRequire("jTfYA");

var $j1iuA = parcelRequire("j1iuA");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e07f27b02dcf7be4$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $2XurI.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $2XurI.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $jTfYA.default) : (0, $j1iuA.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gRD2n.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $gt9Am.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e07f27b02dcf7be4$export$2e2bcd8739ae039 = $e07f27b02dcf7be4$var$TableHead;

});
parcelRegister("gRD2n", function(module, exports) {
$parcel$export(module.exports, "Head", () => $526ce07df73c2167$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $526ce07df73c2167$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $7vb1u = parcelRequire("7vb1u");
const $526ce07df73c2167$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $526ce07df73c2167$var$rankingStyles = null;
const $526ce07df73c2167$var$headStyles = null;
const $526ce07df73c2167$var$overflowTruncateStyles = null;
const $526ce07df73c2167$var$truncationWidthStyles = null;
const $526ce07df73c2167$var$fixedSizeTruncateStyles = null;
const $526ce07df73c2167$var$cellStyles = null;
const $526ce07df73c2167$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $hcewu.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $526ce07df73c2167$var$headCellBaseStyles = null;
const $526ce07df73c2167$export$4e8024263ace498b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $7vb1u.getTruncationStyleVars)({
            width: width
        }),
        [$526ce07df73c2167$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #626F86)"
    };
    const isASC = sortOrder === (0, $180c9910c3a22bd2$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $180c9910c3a22bd2$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $hcewu.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8dcr7 _179r187z _mqm2glyw _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbi3bv",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});

});

parcelRegister("jTfYA", function(module, exports) {
$parcel$export(module.exports, "default", () => $919b27f1acf520e0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $af6E5 = parcelRequire("af6E5");

var $2XurI = parcelRequire("2XurI");

var $j1iuA = parcelRequire("j1iuA");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $919b27f1acf520e0$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $2XurI.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j1iuA.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $919b27f1acf520e0$var$RankableTableHeadCell = (0, $af6E5.default)($919b27f1acf520e0$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$919b27f1acf520e0$export$2e2bcd8739ae039 = $919b27f1acf520e0$var$RankableTableHeadCell;

});
parcelRegister("af6E5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c0a3df32969280a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $1c0a3df32969280a$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("j1iuA", function(module, exports) {
$parcel$export(module.exports, "default", () => $241b5872ed1ce115$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eqPpu = parcelRequire("eqPpu");

var $50Ojd = parcelRequire("50Ojd");

var $9x9ko = parcelRequire("9x9ko");
var $29oZU = parcelRequire("29oZU");
var $bBvvQ = parcelRequire("bBvvQ");

var $aFF42 = parcelRequire("aFF42");


var $gRD2n = parcelRequire("gRD2n");
const $241b5872ed1ce115$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $241b5872ed1ce115$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syaz1gjq _k48pmoej"
};
const $241b5872ed1ce115$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9x9ko.default), {
        xcss: $241b5872ed1ce115$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aFF42.default), {
            content: sortOrder === (0, $180c9910c3a22bd2$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bBvvQ.default), {
                onClick: onClick,
                xcss: $241b5872ed1ce115$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $29oZU.default), {
                        xcss: isVisibleIconOnlyHeader ? $241b5872ed1ce115$var$styles.hideIconHeaderWrapper : $241b5872ed1ce115$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            className: (0, $hcewu.default)([
                                $241b5872ed1ce115$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $29oZU.default), {
                        xcss: isSortIconVisible ? $241b5872ed1ce115$var$styles.sortIconVisibleWrapper : $241b5872ed1ce115$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $180c9910c3a22bd2$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($50Ojd))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eqPpu))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gRD2n.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$241b5872ed1ce115$export$2e2bcd8739ae039 = $241b5872ed1ce115$var$TableHeadCell;

});
parcelRegister("eqPpu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a81b5f5ed97bbaad$var$_react = $a81b5f5ed97bbaad$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a81b5f5ed97bbaad$var$_baseNew = $a81b5f5ed97bbaad$var$_interopRequireDefault((parcelRequire("qZpIR")));
function $a81b5f5ed97bbaad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a81b5f5ed97bbaad$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $a81b5f5ed97bbaad$var$_react.default.createElement($a81b5f5ed97bbaad$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$a81b5f5ed97bbaad$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $a81b5f5ed97bbaad$var$_default = module.exports.default = $a81b5f5ed97bbaad$var$ArrowDownIcon;

});

parcelRegister("50Ojd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a63fa2124991094$var$_react = $3a63fa2124991094$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3a63fa2124991094$var$_baseNew = $3a63fa2124991094$var$_interopRequireDefault((parcelRequire("qZpIR")));
function $3a63fa2124991094$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a63fa2124991094$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $3a63fa2124991094$var$_react.default.createElement($3a63fa2124991094$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$3a63fa2124991094$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $3a63fa2124991094$var$_default = module.exports.default = $3a63fa2124991094$var$ArrowUpIcon;

});




parcelRegister("53wtL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("k9tXG"),
    $ewTvA("1PRCI"),
    $ewTvA("lLfmV")
]).then(()=>parcelRequire('bA2vL'));

});



parcelRegister("3kkEl", function(module, exports) {
$parcel$export(module.exports, "FooterRenderer", () => $dde889b9f3154aaa$export$806a4619165e1410);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dzaoZ = parcelRequire("dzaoZ");

var $bbmku = parcelRequire("bbmku");
const $dde889b9f3154aaa$export$806a4619165e1410 = ({ currentPage: currentPage, totalPages: totalPages, countRendererData: countRendererData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dde889b9f3154aaa$var$FooterContainer, {
        "data-testid": "issue-archival-archives.ui.archives-table.footer-renderer.footer-container"
    }, $dde889b9f3154aaa$var$SpacerElement, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzaoZ.default), {
        issueNavigatorPageInfo: countRendererData.issueNavigatorPageInfo,
        totalIssueSearchResultCount: countRendererData.totalIssueSearchResultCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bbmku.PaginationControls), {
        currentPage: currentPage,
        totalPages: totalPages
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dde889b9f3154aaa$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189ee4h9 _1dqonqa1 _1h6dmuej _x3doglyw _1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _mrkbu2gc _1o0zu2gc",
            __cmplp.className
        ])
    });
});
const $dde889b9f3154aaa$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $dde889b9f3154aaa$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dde889b9f3154aaa$export$d7a54cba636a8cd6, null);

});
parcelRegister("dzaoZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ea3bd648a9bd876$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hlwdY = parcelRequire("hlwdY");
const $3ea3bd648a9bd876$var$IssueCountRenderer = ({ issueNavigatorPageInfo: issueNavigatorPageInfo, totalIssueSearchResultCount: totalIssueSearchResultCount })=>{
    const startIssueRange = issueNavigatorPageInfo?.firstIssuePosition ?? 0; // TODO: counrRendererData will be fetched thorugh relay framents
    const endIssueRange = issueNavigatorPageInfo?.lastIssuePosition ?? 0;
    const total = totalIssueSearchResultCount ?? 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hlwdY.IssueCount), {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        total: total
    });
};
var $3ea3bd648a9bd876$export$2e2bcd8739ae039 = $3ea3bd648a9bd876$var$IssueCountRenderer;

});
parcelRegister("hlwdY", function(module, exports) {
$parcel$export(module.exports, "IssueCount", () => $aecfa174ad569c0f$export$542fba90cc9c1bd1);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bPWpj = parcelRequire("bPWpj");
const $aecfa174ad569c0f$export$542fba90cc9c1bd1 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, total: total })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "issue-archival-archives.ui.archives-table.footer-renderer.issue-count-renderer.issue-count.issue-count",
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, total <= 0 ? formatMessage((0, $bPWpj.default).issueRangeUnknown, {
        startIssueRange: 0,
        endIssueRange: 0
    }) : formatMessage((0, $bPWpj.default).issueRangeKnown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange,
        totalNumberIssues: total
    }));
};
const $aecfa174ad569c0f$var$issueCountContainerStyles = null;

});
parcelRegister("bPWpj", function(module, exports) {
$parcel$export(module.exports, "default", () => $877813e96842f249$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $877813e96842f249$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issueRangeKnown: {
        "id": "issue-archival-archives.archives-table.footer-renderer.issue-count-renderer.issue-count.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "issue-archival-archives.archives-table.footer-renderer.issue-count-renderer.issue-count.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});

});



parcelRegister("bbmku", function(module, exports) {
$parcel$export(module.exports, "PaginationControls", () => $9d2016743b28fcd0$export$ff17519edeb6015d);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8PbUo = parcelRequire("8PbUo");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $16sa1 = parcelRequire("16sa1");

var $h4JbH = parcelRequire("h4JbH");

var $l3GFi = parcelRequire("l3GFi");
const $9d2016743b28fcd0$export$ff17519edeb6015d = ({ currentPage: currentPage, totalPages: totalPages })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { setCurrentPage: setCurrentPage, clearIssuesInCurrentPage: clearIssuesInCurrentPage } = (0, $h4JbH.useArchiveIssueActions)();
    const pages = (0, $eJOHy.useMemo)(()=>{
        const firstPage = 1;
        const lastPage = totalPages ?? 1;
        return Array(lastPage - firstPage + 1).fill(undefined).map((_, i)=>firstPage + i);
    }, [
        totalPages
    ]);
    const onChange = (0, $eJOHy.useCallback)((_, page)=>{
        if (page === currentPage) return;
        setCurrentPage(page);
        clearIssuesInCurrentPage();
    }, [
        clearIssuesInCurrentPage,
        currentPage,
        setCurrentPage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-view-archived-issues-paginated-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "issue.issue-view.activity.archived-issues-paginated-table",
        packageName: "jiraArchivedIssues",
        teamName: "kenji",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9d2016743b28fcd0$var$PaginationContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8PbUo.default), {
        testId: "issue-archival-archives.ui.archives-table.footer-renderer.pagination-controls.pagination-controls",
        pages: pages,
        onChange: onChange,
        selectedIndex: currentPage - 1,
        max: 7,
        nextLabel: formatMessage((0, $l3GFi.default).nextButton),
        previousLabel: formatMessage((0, $l3GFi.default).prevButton)
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9d2016743b28fcd0$var$PaginationContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l3GFi", function(module, exports) {
$parcel$export(module.exports, "default", () => $3827ffc6355fead4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3827ffc6355fead4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    nextButton: {
        "id": "issue-archival-archives.archives-table.footer-renderer.pagination-controls.next-button",
        "defaultMessage": "Next page"
    },
    prevButton: {
        "id": "issue-archival-archives.archives-table.footer-renderer.pagination-controls.prev-button",
        "defaultMessage": "Previous page"
    },
    pageButtonPrefix: {
        "id": "issue-archival-archives.archives-table.footer-renderer.pagination-controls.page-button-prefix",
        "defaultMessage": "Page {page}"
    }
});

});



parcelRegister("5RoI6", function(module, exports) {
$parcel$export(module.exports, "default", () => $b430dfa128dbaa27$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $2rPWc = parcelRequire("2rPWc");

var $ajlfN = parcelRequire("ajlfN");

var $5Woxa = parcelRequire("5Woxa");
const $b430dfa128dbaa27$var$useTableHeadCells = (unarchiveIssuePermission)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const checkboxHeader = unarchiveIssuePermission && [
        {
            key: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_KEYS).SELECT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Woxa.SelectCell), null),
            width: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_WIDTHS).SELECT
        }
    ] || [];
    const headCells = {
        cells: [
            ...checkboxHeader,
            {
                key: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_KEYS).TYPE,
                content: formatMessage((0, $ajlfN.default).issueTypeColumnHeaderText),
                width: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_WIDTHS).TYPE
            },
            {
                key: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_KEYS).KEY,
                content: formatMessage((0, $ajlfN.default).issueKeyColumnHeaderText),
                width: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_WIDTHS).KEY
            },
            {
                key: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_KEYS).SUMMARY,
                content: formatMessage((0, $ajlfN.default).summaryColumnHeaderText),
                width: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_WIDTHS).SUMMARY
            },
            {
                key: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_KEYS).REPORTER,
                content: formatMessage((0, $ajlfN.default).reporterColumnHeaderText),
                width: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_WIDTHS).REPORTER
            },
            {
                key: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_KEYS).ARCHIVED_DATE,
                content: formatMessage((0, $ajlfN.default).archivedDateColumnHeaderText),
                width: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_WIDTHS).ARCHIVED_DATE
            },
            {
                key: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_KEYS).ARCHIVED_BY,
                content: formatMessage((0, $ajlfN.default).archivedByColumnHeaderText),
                width: (0, $2rPWc.ARCHIVE_TABLE_COLUMN_WIDTHS).ARCHIVED_BY
            }
        ]
    };
    return headCells;
};
var $b430dfa128dbaa27$export$2e2bcd8739ae039 = $b430dfa128dbaa27$var$useTableHeadCells;

});
parcelRegister("ajlfN", function(module, exports) {
$parcel$export(module.exports, "default", () => $df2963a92f88017a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $df2963a92f88017a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issueKeyColumnHeaderText: {
        "id": "issue-archival-archives.archives-table.head.issue-key-column-header-text",
        "defaultMessage": "Key"
    },
    issueTypeColumnHeaderText: {
        "id": "issue-archival-archives.archives-table.head.issue-type-column-header-text",
        "defaultMessage": "Type"
    },
    summaryColumnHeaderText: {
        "id": "issue-archival-archives.archives-table.head.summary-column-header-text",
        "defaultMessage": "Summary"
    },
    reporterColumnHeaderText: {
        "id": "issue-archival-archives.archives-table.head.reporter-column-header-text",
        "defaultMessage": "Reporter"
    },
    archivedByColumnHeaderText: {
        "id": "issue-archival-archives.archives-table.head.archived-by-column-header-text",
        "defaultMessage": "Archived by"
    },
    archivedDateColumnHeaderText: {
        "id": "issue-archival-archives.archives-table.head.archived-date-column-header-text",
        "defaultMessage": "Date archived"
    },
    selectAllCheckboxLabelText: {
        "id": "issue-archival-archives.archives-table.head.select-cell.select-all-checkbox-label-text",
        "defaultMessage": "Select all archived issues"
    },
    selectAllCheckboxLabelTextIssueTermRefresh: {
        "id": "issue-archival-archives.archives-table.head.select-cell.select-all-checkbox-label-text-issue-term-refresh",
        "defaultMessage": "Select all archived work items"
    }
});

});

parcelRegister("5Woxa", function(module, exports) {
$parcel$export(module.exports, "SelectCell", () => $f63063aed7d8a0b7$export$9bd5f7aae57b2fd6);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hD6Pb = parcelRequire("hD6Pb");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $h4JbH = parcelRequire("h4JbH");

var $6eQho = parcelRequire("6eQho");

var $ajlfN = parcelRequire("ajlfN");
const $f63063aed7d8a0b7$export$9bd5f7aae57b2fd6 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const [isChecked, setIsChecked] = (0, $eJOHy.useState)(false);
    const [isIndeterminate, setIsIndeterminate] = (0, $eJOHy.useState)(false);
    const state = (0, $6eQho.useArchiveIssueStates)();
    const pageNumber = (0, $6eQho.getCurrentPage)({
        state: state
    });
    const numberOfIssuesInPage = (0, $6eQho.getNumberOfIssuesForCurrentPage)({
        state: state
    });
    (0, $eJOHy.useEffect)(()=>{
        const numberOfSelectedIssues = (0, $6eQho.getNumberOfSelectedIssuesForPage)({
            state: state,
            pageNumber: pageNumber
        });
        setIsIndeterminate(numberOfSelectedIssues > 0 && numberOfSelectedIssues < numberOfIssuesInPage);
        setIsChecked(numberOfSelectedIssues > 0);
    }, [
        numberOfIssuesInPage,
        pageNumber,
        state
    ]);
    const { selectAllIssuesInCurrentPage: selectAllIssuesInCurrentPage, clearSelectionsInCurrentPage: clearSelectionsInCurrentPage } = (0, $h4JbH.useArchiveIssueActions)();
    const onChange = (0, $eJOHy.useCallback)(()=>{
        if (!isChecked) {
            selectAllIssuesInCurrentPage();
            setIsChecked(true);
        } else {
            clearSelectionsInCurrentPage();
            setIsChecked(false);
        }
    }, [
        clearSelectionsInCurrentPage,
        isChecked,
        selectAllIssuesInCurrentPage
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testId": "archives-checkbox",
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hD6Pb.default), {
        isChecked: isChecked,
        onChange: onChange,
        isIndeterminate: isIndeterminate,
        value: "Archives table checkbox",
        name: "archives-table-checkbox",
        "aria-label": formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $ajlfN.default).selectAllCheckboxLabelTextIssueTermRefresh : (0, $ajlfN.default).selectAllCheckboxLabelText)
    }));
});
const $f63063aed7d8a0b7$var$selectCellStyles = null;

});
parcelRegister("hD6Pb", function(module, exports) {
$parcel$export(module.exports, "default", () => $59e730bf6dfbbc90$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gfwtz = parcelRequire("gfwtz");

var $ccIjX = parcelRequire("ccIjX");

var $9kUgq = parcelRequire("9kUgq");
var $61Vxn = parcelRequire("61Vxn");
var $fqErZ = parcelRequire("fqErZ");
var $jg99T = parcelRequire("jg99T");
const $59e730bf6dfbbc90$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzg1nfn _1dk71nfn _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $59e730bf6dfbbc90$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gfwtz.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $ccIjX.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $61Vxn.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $59e730bf6dfbbc90$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9kUgq.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fqErZ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jg99T.default), {})
                ]
            })
        ]
    });
}));
$59e730bf6dfbbc90$var$Checkbox.displayName = 'Checkbox';
var $59e730bf6dfbbc90$export$2e2bcd8739ae039 = $59e730bf6dfbbc90$var$Checkbox;

});
parcelRegister("9kUgq", function(module, exports) {
$parcel$export(module.exports, "default", () => $62f23a3e92f62a36$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ja43d = parcelRequire("ja43d");

var $fFMqJ = parcelRequire("fFMqJ");
function $62f23a3e92f62a36$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $fFMqJ.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $fFMqJ.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $62f23a3e92f62a36$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$62f23a3e92f62a36$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ja43d.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $fFMqJ.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    }));
});
var $62f23a3e92f62a36$export$2e2bcd8739ae039 = $62f23a3e92f62a36$var$CheckboxIcon;

});

parcelRegister("61Vxn", function(module, exports) {
$parcel$export(module.exports, "default", () => $56741871405b5f6c$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $56741871405b5f6c$var$baseStyles = null;
const $56741871405b5f6c$var$textLabelLayoutStyles = null;
const $56741871405b5f6c$var$disabledStyles = null;
const $56741871405b5f6c$var$labelStyles = null;
function $56741871405b5f6c$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("fqErZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c71a15988d60bf21$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c71a15988d60bf21$var$labelTextStyles = null;
function $c71a15988d60bf21$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("jg99T", function(module, exports) {
$parcel$export(module.exports, "default", () => $68f714b06ea57b2c$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $68f714b06ea57b2c$var$requiredIndicatorStyles = null;
function $68f714b06ea57b2c$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});




parcelRegister("8uxOY", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc1167c70d029e6d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fc1167c70d029e6d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    archivesTableLabel: {
        "id": "issue-archival-archives.archives-table.archives-table-label",
        "defaultMessage": "Archives Table"
    },
    loadingArchivesTableLabel: {
        "id": "issue-archival-archives.archives-table.loading-archives-table-label",
        "defaultMessage": "Loading archives Table"
    }
});

});

parcelRegister("jacMC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0e35ba33a67539d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5rhbE = parcelRequire("5rhbE");

var $lRq8t = parcelRequire("lRq8t");

var $fSCkM = parcelRequire("fSCkM");

var $4cTDP = parcelRequire("4cTDP");
const $e0e35ba33a67539d$var$DATE_FORMAT_OPTIONS = {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
};
const $e0e35ba33a67539d$var$DateCell = /*#__PURE__*/ (0, $eJOHy.memo)(({ archivedDate: archivedDate })=>{
    const { formatDate: formatDateIntl } = (0, $lRq8t.default)();
    const formatDate = (0, $eJOHy.useCallback)((date)=>date ? formatDateIntl(date.toLocalDate(), $e0e35ba33a67539d$var$DATE_FORMAT_OPTIONS) : '', [
        formatDateIntl
    ]);
    const dateOnlyInstance = archivedDate.split('T')[0];
    const previousValue = (0, $eJOHy.useMemo)(()=>formatDate(dateOnlyInstance !== null ? (0, $fSCkM.DateOnly).fromISODateString(dateOnlyInstance) : null), [
        dateOnlyInstance,
        formatDate
    ]);
    const newValue = (0, $eJOHy.useMemo)(()=>formatDate(archivedDate !== null ? (0, $fSCkM.DateOnly).fromDateAccordingToLocalTime(new Date(archivedDate)) : null), [
        archivedDate,
        formatDate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5rhbE.default), {
        text: (0, $4cTDP.fg)('issue_archival_timestamp_ken_2458') ? newValue : previousValue,
        color: "standard"
    });
});
var $e0e35ba33a67539d$export$2e2bcd8739ae039 = $e0e35ba33a67539d$var$DateCell;

});
parcelRegister("5rhbE", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ccb71b87ca0a405$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $oaJVg = parcelRequire("oaJVg");

var $69Mo3 = parcelRequire("69Mo3");

var $7RNly = parcelRequire("7RNly");
const $3ccb71b87ca0a405$var$SimpleTagComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7RNly.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $oaJVg.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $69Mo3.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $3ccb71b87ca0a405$var$SimpleTag = /*#__PURE__*/ (0, $eJOHy.memo)($3ccb71b87ca0a405$var$SimpleTagComponent);
var $3ccb71b87ca0a405$export$2e2bcd8739ae039 = $3ccb71b87ca0a405$var$SimpleTag;

});
parcelRegister("oaJVg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fa0f7917c12c369$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
const $8fa0f7917c12c369$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
const $8fa0f7917c12c369$var$baseStyles = null;
const $8fa0f7917c12c369$var$interactiveStyles = null;
const $8fa0f7917c12c369$var$focusRingStyles = null;
const $8fa0f7917c12c369$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad",
            isInteractive && "_1e381q03 _7glxv77o",
            isLink && "_irr3166n _1di61dty",
            $8fa0f7917c12c369$var$borderColors[color],
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fa0f7917c12c369$export$2e2bcd8739ae039 = $8fa0f7917c12c369$var$BaseTag;

});

parcelRegister("69Mo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a506053354047ac2$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $a506053354047ac2$var$beforeElementStyles = null;
const $a506053354047ac2$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a506053354047ac2$export$2e2bcd8739ae039 = $a506053354047ac2$var$Before;

});

parcelRegister("7RNly", function(module, exports) {
$parcel$export(module.exports, "default", () => $adef5eca4f0bc72d$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $adef5eca4f0bc72d$var$baseStyles = null;
const $adef5eca4f0bc72d$var$linkStyles = null;
const $adef5eca4f0bc72d$var$hasAfterStyles = null;
const $adef5eca4f0bc72d$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c",
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$adef5eca4f0bc72d$export$2e2bcd8739ae039 = $adef5eca4f0bc72d$var$Content;

});


parcelRegister("fSCkM", function(module, exports) {
$parcel$export(module.exports, "DateOnly", () => $f890d9b837113be1$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $f890d9b837113be1$export$b0961ad8aee63b8b);
const $f890d9b837113be1$export$9cda9b56d134780f = 'Invalid date or date format';
const $f890d9b837113be1$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $f890d9b837113be1$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $f890d9b837113be1$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $f890d9b837113be1$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $f890d9b837113be1$var$isLeapYear(year) ? 29 : $f890d9b837113be1$var$daysInMonth[month - 1])) return false;
    return true;
};
const $f890d9b837113be1$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $f890d9b837113be1$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $f890d9b837113be1$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $f890d9b837113be1$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $f890d9b837113be1$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($f890d9b837113be1$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $f890d9b837113be1$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $f890d9b837113be1$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $f890d9b837113be1$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$f890d9b837113be1$var$isDateValid(year, month, day)) throw new Error($f890d9b837113be1$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $f890d9b837113be1$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $f890d9b837113be1$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $f890d9b837113be1$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $f890d9b837113be1$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});


parcelRegister("5kRGj", function(module, exports) {
$parcel$export(module.exports, "KeyCell", () => $9260cffb734f3120$export$4d17c2f4d9bbf823);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $ckDd8 = parcelRequire("ckDd8");
const $9260cffb734f3120$export$4d17c2f4d9bbf823 = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_syaz1fxt _o5721q9c _k48p1pd9 _4bfu1fxt _43ds1fxt _oxk41fxt _1cay1fxt _1o7v1fxt _59381fxt _rfqo1fxt _qfs11fxt _1udh1fxt"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ckDd8.default), {
        appearance: "subtle",
        href: `/browse/${issueKey}`
    }, issueKey)));
const $9260cffb734f3120$var$nowrapStyle = null;

});

parcelRegister("8nPX3", function(module, exports) {
$parcel$export(module.exports, "SelectCell", () => $ee8144b639d899ac$export$9bd5f7aae57b2fd6);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hD6Pb = parcelRequire("hD6Pb");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $h4JbH = parcelRequire("h4JbH");

var $kMIVV = parcelRequire("kMIVV");
const $ee8144b639d899ac$export$9bd5f7aae57b2fd6 = /*#__PURE__*/ (0, $eJOHy.memo)(({ isChecked: isChecked, issueId: issueId, pageNumber: pageNumber, isDisabled: isDisabled, issueKey: issueKey })=>{
    const { selectIssue: selectIssue, deselectIssue: deselectIssue } = (0, $h4JbH.useArchiveIssueActions)();
    const onChange = ()=>{
        if (!isChecked) selectIssue({
            issueId: issueId,
            pageNumber: pageNumber
        });
        else deselectIssue({
            issueId: issueId,
            pageNumber: pageNumber
        });
    };
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hD6Pb.default), {
        isChecked: isChecked,
        onChange: onChange,
        value: "Archives table checkbox",
        name: "archives-table-checkbox",
        isDisabled: isDisabled,
        "aria-label": formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $kMIVV.default).selectCheckboxMessageIssueTermRefresh : (0, $kMIVV.default).selectCheckboxMessage, {
            issueKey: issueKey
        })
    }));
});
const $ee8144b639d899ac$var$selectCellStyles = null;

});
parcelRegister("kMIVV", function(module, exports) {
$parcel$export(module.exports, "default", () => $19449f16e9dabf49$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $19449f16e9dabf49$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    selectCheckboxMessage: {
        "id": "archives.table.select-cell.labelMessage",
        "defaultMessage": "Select issue {issueKey}"
    },
    selectCheckboxMessageIssueTermRefresh: {
        "id": "archives.table.select-cell.labelMessage-issue-term-refresh",
        "defaultMessage": "Select work item {issueKey}"
    }
});

});


parcelRegister("fLLr9", function(module, exports) {
$parcel$export(module.exports, "TextCell", () => $1af0192bbf50d8e5$export$765aced31cc89655);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $1af0192bbf50d8e5$export$765aced31cc89655 = /*#__PURE__*/ (0, $eJOHy.memo)(({ text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq"
        ])
    }, text));
const $1af0192bbf50d8e5$var$textCellStyles = null;

});

parcelRegister("kccqY", function(module, exports) {
$parcel$export(module.exports, "TypeCell", () => $2e43506de2f9b928$export$1034b01824b6a80);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bQyn2 = parcelRequire("bQyn2");
const $2e43506de2f9b928$export$1034b01824b6a80 = /*#__PURE__*/ (0, $eJOHy.memo)(({ iconUrl: iconUrl, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
        url: iconUrl,
        alt: name
    })));
const $2e43506de2f9b928$var$typeCellStyles = null;

});
parcelRegister("bQyn2", function(module, exports) {
$parcel$export(module.exports, "default", () => $69a57831c94bcd51$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $69a57831c94bcd51$var$defaultIconSize = 16;
/* Represents an asynchronous icon loader that handles loading of icons from URLs with error handling.
 * It displays the icon fetched from the provided URL. In case of an error or if the URL is undefined,
 * a fallback UI component or placeholder is displayed.
 * This component accepts various props like URL, title, alt text, dimensions, and a fallback component
 * to customize the behavior and presentation of the loaded or placeholder icon.
 * The component also includes functionality to prevent the icon from being draggable.
 */ const $69a57831c94bcd51$var$AsyncIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, title: title, alt: alt, width: width, height: height, fallback: fallback })=>{
    const [isBroken, setIsBroken] = (0, $eJOHy.useState)(false);
    const onError = (0, $eJOHy.useCallback)(()=>{
        setIsBroken(true);
    }, []);
    const convertSize = (0, $eJOHy.useCallback)((size)=>size ? `${size}px` : '0', []);
    if (isBroken && fallback) return fallback();
    const convertedWidth = convertSize(width ?? $69a57831c94bcd51$var$defaultIconSize);
    const convertedHeight = convertSize(height ?? $69a57831c94bcd51$var$defaultIconSize);
    if (url) return /*#__PURE__*/ $eJOHy.createElement($69a57831c94bcd51$var$Image, {
        src: url,
        width: convertedWidth,
        height: convertedHeight,
        title: title ?? undefined,
        alt: alt ?? '',
        onError: onError,
        /**
     * Disabling dragging so drags happen on the parent instead of this icon.
     */ draggable: false,
        "data-vc": "common-components-async-icon"
    });
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: convertedHeight,
            width: convertedWidth
        },
        "data-testid": "common-components-async-icon.placeholder",
        className: (0, $hcewu.default)([
            "_2rkofajl _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _bfhk1d5g"
        ])
    });
});
const $69a57831c94bcd51$var$placeholderStyles = null;
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69a57831c94bcd51$var$Image = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
$69a57831c94bcd51$var$AsyncIcon.displayName = 'AsyncIcon';
var $69a57831c94bcd51$export$2e2bcd8739ae039 = $69a57831c94bcd51$var$AsyncIcon;

});


parcelRegister("2UhUW", function(module, exports) {
$parcel$export(module.exports, "UserCell", () => $de3f126f90be26e8$export$dc0ef711c0db7c30);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fyCw1 = parcelRequire("fyCw1");

var $lRrud = parcelRequire("lRrud");
var $e7uOb = parcelRequire("e7uOb");
const $de3f126f90be26e8$export$dc0ef711c0db7c30 = /*#__PURE__*/ (0, $eJOHy.memo)(({ user: user })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($de3f126f90be26e8$var$NameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($de3f126f90be26e8$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fyCw1.default), {
        name: user.name,
        src: user.avatarUrl,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "issue-archival-archives.ui.archives-table.rows.user-cell.user-name"
    }, user.name)));
const $de3f126f90be26e8$var$NameWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($de3f126f90be26e8$var$NameWrapperStyles, null, children);
const $de3f126f90be26e8$var$AvatarWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), {
        xcss: $de3f126f90be26e8$var$avatarWrapperStyles
    }, children);
const $de3f126f90be26e8$var$avatarWrapperStyles = (0, $e7uOb.xcss)({
    marginInlineEnd: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $de3f126f90be26e8$var$NameWrapperStyles = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});



parcelRegister("c4YZw", function(module, exports) {
$parcel$export(module.exports, "IssueManageBar", () => $e0ba8165e7e68186$export$ddd77f66a6f50d43);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $48ZTT = parcelRequire("48ZTT");

var $2r2f0 = parcelRequire("2r2f0");

var $lRq8t = parcelRequire("lRq8t");

var $apXQz = parcelRequire("apXQz");

var $h4JbH = parcelRequire("h4JbH");

var $6eQho = parcelRequire("6eQho");

var $laX72 = parcelRequire("laX72");

var $33HhI = parcelRequire("33HhI");
const $e0ba8165e7e68186$export$ddd77f66a6f50d43 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const fullscreen = (0, $apXQz.useFullscreenQueryParameter)();
    const state = (0, $6eQho.useArchiveIssueStates)();
    const selectedIssueCount = (0, $6eQho.getNumberOfSelectedIssues)({
        state: state
    });
    const { clearAllSelections: clearAllSelections } = (0, $h4JbH.useArchiveIssueActions)();
    if (selectedIssueCount === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "issue-archival-archives.ui.manage-bars.issue-manage-bar",
        className: (0, $hcewu.default)([
            "_kqsw1n9t _94n51jfw _1pby11wp _1ltv1mfg _1bsb1osq _p12f10k2 _1e0c1txw _1bah1h6o",
            fullscreen && "_1ltvidpf _p12f1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_2rko1mok _kqswstnw _94n5idpf _bfhk1b6k _16qs1cd0 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _syaz15cr _1e0c1txw _4cvr1fhb _d32v1gfe _4pkp1gfe _6pup1bsc _1sfy1gfe _1nqccdhy _t8d3pf9b"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _u5f3u2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48ZTT.default), {
        appearance: "subtle",
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2r2f0))), {
            label: formatMessage((0, $laX72.messages).closeButtonLabel),
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: ()=>clearAllSelections()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_11c8140y _u5f3pxbi"
        ])
    }, formatMessage((0, $laX72.messages).label, {
        count: selectedIssueCount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1n261g80 _19bvu2gc _u5f3u2gc _kqswh2mm _1kt9b3bt _1auk1l7b _1cs8stnw _19wo1l7b _1mp4t94y _qnecidpf _1rusz9xs"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $33HhI.default), null))));
};
const $e0ba8165e7e68186$var$controlsButtonContainerBaseStyles = null;
const $e0ba8165e7e68186$var$controlsButtonContainerFullScreenStyles = null;
const $e0ba8165e7e68186$var$ControlsButtonContent = null;
const $e0ba8165e7e68186$var$ButtonsWrapper = null;
const $e0ba8165e7e68186$var$LabelContainer = null;
const $e0ba8165e7e68186$var$Label = null;

});
parcelRegister("2r2f0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18cd44b40ff8809efea24ae850576bc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c5fd76da2feabda$var$_react = $1c5fd76da2feabda$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1c5fd76da2feabda$var$_cross = $1c5fd76da2feabda$var$_interopRequireDefault((parcelRequire("aadxn")));

var $1c5fd76da2feabda$var$_close = $1c5fd76da2feabda$var$_interopRequireDefault((parcelRequire("dI076")));
function $1c5fd76da2feabda$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c5fd76da2feabda$var$CrossIcon = (props)=>/*#__PURE__*/ $1c5fd76da2feabda$var$_react.default.createElement($1c5fd76da2feabda$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $1c5fd76da2feabda$var$_close.default
    }, props));
$1c5fd76da2feabda$var$CrossIcon.displayName = 'CrossIconMigration';
var $1c5fd76da2feabda$var$_default = module.exports.default = $1c5fd76da2feabda$var$CrossIcon;

});
parcelRegister("dI076", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9faf78fb55c89e79$var$_react = $9faf78fb55c89e79$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4PsdO = parcelRequire("4PsdO");
function $9faf78fb55c89e79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9faf78fb55c89e79$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $9faf78fb55c89e79$var$_react.default.createElement($4PsdO.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props));
$9faf78fb55c89e79$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $9faf78fb55c89e79$var$_default = module.exports.default = $9faf78fb55c89e79$var$EditorCloseIcon;

});


parcelRegister("apXQz", function(module, exports) {
$parcel$export(module.exports, "PolarisRouteContainer", () => $d05b4c167eb4b83e$export$835836449342021c);
$parcel$export(module.exports, "usePolarisQuery", () => $d05b4c167eb4b83e$export$a0561749ea6366a9);
$parcel$export(module.exports, "useFullscreenQueryParameter", () => $d05b4c167eb4b83e$export$c3af6aa037072338);
$parcel$export(module.exports, "useSidebarQueryParameter", () => $d05b4c167eb4b83e$export$3d7c7b8ad6e012db);
$parcel$export(module.exports, "useIssueTypeIdQueryParameter", () => $d05b4c167eb4b83e$export$e153bdcdf29670a1);
$parcel$export(module.exports, "useRoadmapQueryParameter", () => $d05b4c167eb4b83e$export$6d8407e4a22e5eb3);
$parcel$export(module.exports, "useSelectedIssueQueryParameter", () => $d05b4c167eb4b83e$export$567c36d062d58de4);
$parcel$export(module.exports, "useIsIssueOpenInFullscreen", () => $d05b4c167eb4b83e$export$605125b912bc3cb9);
$parcel$export(module.exports, "useIsIssueOpenInSidebar", () => $d05b4c167eb4b83e$export$d889138060b442eb);
$parcel$export(module.exports, "useIssueViewLayout", () => $d05b4c167eb4b83e$export$8ae00b4e58626e94);
$parcel$export(module.exports, "useCreateFormIssueTypeId", () => $d05b4c167eb4b83e$export$d3350656f816c218);
$parcel$export(module.exports, "useIssueViewSection", () => $d05b4c167eb4b83e$export$711cefe410e03ef5);
$parcel$export(module.exports, "useCurrentPolarisRoute", () => $d05b4c167eb4b83e$export$fd6cdb023846ec7a);
$parcel$export(module.exports, "useCurrentPolarisRouteSection", () => $d05b4c167eb4b83e$export$144b5fe3cd41790c);
$parcel$export(module.exports, "usePolarisRouter", () => $d05b4c167eb4b83e$export$b98a36d9fd4e7222);

var $eJOHy = parcelRequire("eJOHy");

var $YvHeB = parcelRequire("YvHeB");

var $jxALV = parcelRequire("jxALV");

var $gCY1z = parcelRequire("gCY1z");
var $83DiZ = parcelRequire("83DiZ");

var $5xmeX = parcelRequire("5xmeX");

var $g150O = parcelRequire("g150O");

var $kTmHj = parcelRequire("kTmHj");
var $8rYUw = parcelRequire("8rYUw");
var $gbYTG = parcelRequire("gbYTG");

var $3EGZm = parcelRequire("3EGZm");

var $e6XlU = parcelRequire("e6XlU");

var $7a8xH = parcelRequire("7a8xH");
const $d05b4c167eb4b83e$var$initialState = {
    containerProps: undefined
};
const $d05b4c167eb4b83e$export$feb26c1e73b87394 = (0, $jxALV.createPolarisStore)({
    initialState: $d05b4c167eb4b83e$var$initialState,
    actions: $kTmHj,
    name: 'PolarisRouteStore'
});
const { Container: $d05b4c167eb4b83e$var$Container, useActions: $d05b4c167eb4b83e$var$useActions, createHook: $d05b4c167eb4b83e$var$createHook } = (0, $YvHeB.createJpdContainer)($d05b4c167eb4b83e$export$feb26c1e73b87394, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch($8rYUw.init());
            dispatch($gbYTG.updateDebouncedRouterActions());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch($gbYTG.updateDebouncedRouterActions());
        }
});
const $d05b4c167eb4b83e$export$835836449342021c = (props)=>{
    const [{ query: query }] = (0, $gCY1z.useRouter)();
    const section = (0, $7a8xH.useUrlSection)();
    const resource = (0, $7a8xH.useUrlResource)();
    const { push: push, replace: replace } = (0, $83DiZ.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d05b4c167eb4b83e$var$Container, {
        ...props,
        query: query,
        section: section,
        resource: resource,
        useNativePushMethod: push,
        useNativeReplaceMethod: replace
    }, props.children);
};
const $d05b4c167eb4b83e$export$a0561749ea6366a9 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getPolarisQuerySelector));
const $d05b4c167eb4b83e$export$c3af6aa037072338 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getFullscreenQueryParameter));
const $d05b4c167eb4b83e$export$3d7c7b8ad6e012db = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getSidebarQueryParameter));
const $d05b4c167eb4b83e$export$e153bdcdf29670a1 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getIssueTypeIdQueryParameter));
const $d05b4c167eb4b83e$export$6d8407e4a22e5eb3 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getRoadmapQueryParameter));
const $d05b4c167eb4b83e$export$567c36d062d58de4 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getSelectedIssueQueryParameter));
const $d05b4c167eb4b83e$export$605125b912bc3cb9 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getIsIssueOpenInFullscreen));
const $d05b4c167eb4b83e$export$d889138060b442eb = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getIsIssueOpenInSidebar));
const $d05b4c167eb4b83e$export$8ae00b4e58626e94 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getIssueViewLayout));
const $d05b4c167eb4b83e$export$885b67caee31103a = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getIssueViewSection));
const $d05b4c167eb4b83e$export$d3350656f816c218 = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getCreateFormIssueTypeId));
const $d05b4c167eb4b83e$export$711cefe410e03ef5 = ()=>{
    const issueViewSection = $d05b4c167eb4b83e$export$885b67caee31103a();
    const isSharedView = (0, $5xmeX.useIsSharedView)();
    const sharingSettings = (0, $g150O.useCurrentViewSharingSettings)();
    if (!isSharedView) return issueViewSection;
    if (!sharingSettings?.showIdeaComments && issueViewSection === 'comments' || !sharingSettings?.showIdeaInsights && issueViewSection === 'capture') return 0, $e6XlU.DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR;
    return issueViewSection;
};
const $d05b4c167eb4b83e$export$fd6cdb023846ec7a = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getCurrentRouteSelector));
const $d05b4c167eb4b83e$export$144b5fe3cd41790c = $d05b4c167eb4b83e$var$createHook((0, $3EGZm.getCurrentRouteSectionSelector));
const $d05b4c167eb4b83e$export$b98a36d9fd4e7222 = ()=>{
    const { routeTo: routeTo, setQuery: setQuery, closeIssueView: closeIssueView, openIssueView: openIssueView } = $d05b4c167eb4b83e$var$useActions();
    return (0, $eJOHy.useMemo)(()=>({
            routeTo: routeTo,
            setQuery: setQuery,
            closeIssueView: closeIssueView,
            openIssueView: openIssueView
        }), [
        routeTo,
        setQuery,
        closeIssueView,
        openIssueView
    ]);
};

});
parcelRegister("jxALV", function(module, exports) {
$parcel$export(module.exports, "createPolarisStore", () => $ebab0452a2995ce1$export$425650453fa3c52a);

var $huH03 = parcelRequire("huH03");

var $GtRbT = parcelRequire("GtRbT");
const $ebab0452a2995ce1$export$425650453fa3c52a = ({ initialState: initialState, actions: actions, name: name })=>{
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const wrappedActions = (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(actions, (actionCreator)=>(...args)=>{
            try {
                const actionFct = actionCreator(...args);
                return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
                storeAction, props)=>{
                    try {
                        return actionFct(storeAction, props);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        props.onActionFailed(error);
                        throw error;
                    }
                };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
                storeAction, props)=>{
                    props.onActionFailed(error);
                    throw error;
                };
            }
        });
    return (0, $GtRbT.createStore)({
        initialState: initialState,
        actions: wrappedActions,
        name: name
    });
};

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});


parcelRegister("g150O", function(module, exports) {
$parcel$export(module.exports, "useIsCurrentViewSharingSettingsInitialLoading", () => $a2efd1795594c28c$export$24d19581f52b2bac);
$parcel$export(module.exports, "useCurrentViewSharingSettings", () => $a2efd1795594c28c$export$e010169e1bebed20);
$parcel$export(module.exports, "useCurrentViewSharingStakeholders", () => $a2efd1795594c28c$export$8afacc6445a9f29d);
$parcel$export(module.exports, "usePublicSharingControls", () => $a2efd1795594c28c$export$f5e51b1e513c7a19);
$parcel$export(module.exports, "useIdeaDescriptionFieldKey", () => $a2efd1795594c28c$export$a95feff8ba9c77d2);
$parcel$export(module.exports, "useHasCurrentViewSharingSettingsError", () => $a2efd1795594c28c$export$a4c4a7f472c1449a);
$parcel$export(module.exports, "useHasCurrentViewSharingError", () => $a2efd1795594c28c$export$ed37db0f58966dec);
$parcel$export(module.exports, "useIsSharingOnSiteEnabled", () => $a2efd1795594c28c$export$5603541acb0905d);
$parcel$export(module.exports, "useIsSharingSiteConfigLoading", () => $a2efd1795594c28c$export$cd795923d8f612d5);
$parcel$export(module.exports, "useProjectAccessLevel", () => $a2efd1795594c28c$export$e262f937bd216199);
$parcel$export(module.exports, "useIsPublishDialogContentLoading", () => $a2efd1795594c28c$export$4a54198358826b6b);
$parcel$export(module.exports, "useIsSitePublicSharingLoading", () => $a2efd1795594c28c$export$f1d239607895ab30);
$parcel$export(module.exports, "useIsCurrentViewPublicSharingEnabled", () => $a2efd1795594c28c$export$9e4ecc370892bc0b);
$parcel$export(module.exports, "useIsSitePublicSharingEnabled", () => $a2efd1795594c28c$export$c2bf49dff0e5754f);

var $fVyje = parcelRequire("fVyje");

var $7BzKB = parcelRequire("7BzKB");
const $a2efd1795594c28c$export$24d19581f52b2bac = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsCurrentViewSharingSettingsInitialLoading));
const $a2efd1795594c28c$export$e060903268c10657 = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsCurrentViewSharingInitialLoading));
const $a2efd1795594c28c$export$e010169e1bebed20 = (0, $fVyje.createSharingHook)((0, $7BzKB.getCurrentViewSharingSettings));
const $a2efd1795594c28c$export$8afacc6445a9f29d = (0, $fVyje.createSharingHook)((0, $7BzKB.getCurrentViewSharingStakeholders));
const $a2efd1795594c28c$export$f5e51b1e513c7a19 = (0, $fVyje.createSharingHook)((0, $7BzKB.getPublicSharingControls));
const $a2efd1795594c28c$export$a95feff8ba9c77d2 = (0, $fVyje.createSharingHook)((0, $7BzKB.getIdeaDescriptionFieldKey));
const $a2efd1795594c28c$export$a4c4a7f472c1449a = (0, $fVyje.createSharingHook)((0, $7BzKB.hasCurrentViewSharingSettingsError));
const $a2efd1795594c28c$export$ed37db0f58966dec = (0, $fVyje.createSharingHook)((0, $7BzKB.hasCurrentViewSharingError));
const $a2efd1795594c28c$export$5603541acb0905d = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsSharingOnSiteEnabled));
const $a2efd1795594c28c$export$cd795923d8f612d5 = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsSharingSiteConfigLoading));
const $a2efd1795594c28c$export$e262f937bd216199 = (0, $fVyje.createSharingHook)((0, $7BzKB.getProjectAccessLevel));
const $a2efd1795594c28c$export$4a54198358826b6b = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsPublishDialogContentLoading));
const $a2efd1795594c28c$export$f1d239607895ab30 = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsSitePublicSharingLoading));
const $a2efd1795594c28c$export$9e4ecc370892bc0b = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsCurrentViewPublicSharingEnabled));
const $a2efd1795594c28c$export$c2bf49dff0e5754f = (0, $fVyje.createSharingHook)((0, $7BzKB.getIsSitePublicSharingEnabled));

});
parcelRegister("fVyje", function(module, exports) {
$parcel$export(module.exports, "Container", () => $1a2420d855163030$export$42a852a2b6b56249);
$parcel$export(module.exports, "createSharingHook", () => $1a2420d855163030$export$80a8f4ec77855db9);
$parcel$export(module.exports, "useSharingActions", () => $1a2420d855163030$export$45260f05810c82ae);

var $YvHeB = parcelRequire("YvHeB");

var $jxALV = parcelRequire("jxALV");

var $42uL4 = parcelRequire("42uL4");

var $ij0Yh = parcelRequire("ij0Yh");
var $3Z0eD = parcelRequire("3Z0eD");
var $1bMxm = parcelRequire("1bMxm");
const $1a2420d855163030$export$d4c72bab9d6cc13a = Object.freeze({
    sharingSettings: {},
    sharingStakeholders: {},
    siteConfig: {
        isEnabled: false,
        isLoading: false,
        error: undefined
    },
    sitePublicSharingConfig: {
        isEnabled: false,
        isLoading: false,
        error: undefined
    },
    projectAccessLevel: undefined,
    containerProps: undefined,
    prevContainerProps: undefined
});
const $1a2420d855163030$var$SharingStore = (0, $jxALV.createPolarisStore)({
    initialState: $1a2420d855163030$export$d4c72bab9d6cc13a,
    actions: (0, $1bMxm.publicActions),
    name: 'SharingStore'
});
const $1a2420d855163030$var$onInit = ()=>({ dispatch: dispatch, setState: setState }, { edition: edition, permissions: permissions })=>{
        if ((0, $42uL4.publishFeatureDisabled)(edition)) return;
        dispatch($3Z0eD.loadSharingSiteConfig());
        setState({
            permissions: permissions
        });
        dispatch((0, $1bMxm.privateActions).loadSitePublicSharingConfig());
        dispatch($ij0Yh.loadProjectAccessLevel());
    };
const $1a2420d855163030$var$onUpdate = ()=>({ setState: setState }, { permissions: permissions })=>{
        // In case permissions are not yet loaded onInit
        setState({
            permissions: permissions
        });
    };
const { Container: $1a2420d855163030$export$42a852a2b6b56249, createHook: $1a2420d855163030$var$createHook, useActions: $1a2420d855163030$var$useActions } = (0, $YvHeB.createJpdContainer)($1a2420d855163030$var$SharingStore, {
    onInit: $1a2420d855163030$var$onInit,
    onUpdate: $1a2420d855163030$var$onUpdate
});
const $1a2420d855163030$export$80a8f4ec77855db9 = $1a2420d855163030$var$createHook;
const $1a2420d855163030$export$45260f05810c82ae = $1a2420d855163030$var$useActions;

});
parcelRegister("42uL4", function(module, exports) {
$parcel$export(module.exports, "publishFeatureDisabled", () => $90dfe72160b05a84$export$941f8069ccf8e337);

var $cblKs = parcelRequire("cblKs");
const $90dfe72160b05a84$export$941f8069ccf8e337 = (edition)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    edition && [
        (0, $cblKs.UNLICENSED),
        (0, $cblKs.FREE_EDITION)
    ].includes(edition);

});

parcelRegister("ij0Yh", function(module, exports) {
$parcel$export(module.exports, "loadProjectAccessLevel", () => $5638963ba7414485$export$16808681673565f0);
$parcel$export(module.exports, "setProjectAccessLevel", () => $5638963ba7414485$export$89aeb751af3ee244);

var $eKTQH = parcelRequire("eKTQH");

var $7e8wG = parcelRequire("7e8wG");

var $eqs4m = parcelRequire("eqs4m");
const $5638963ba7414485$export$16808681673565f0 = ()=>async ({ setState: setState }, { isSharedView: isSharedView, projectId: projectId })=>{
        if (isSharedView || !projectId) return;
        try {
            const level = await (0, $eqs4m.fetchProjectAccessLevel)(projectId);
            setState({
                projectAccessLevel: level?.type
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eKTQH.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.load-project-access-level', error));
        }
    };
const $5638963ba7414485$export$89aeb751af3ee244 = (projectAccessLevel)=>({ setState: setState })=>{
        setState({
            projectAccessLevel: projectAccessLevel
        });
    };

});
parcelRegister("eqs4m", function(module, exports) {
$parcel$export(module.exports, "fetchProjectAccessLevel", () => $78eac8f1d70b3bae$export$c1e51f4f79456e2e);

var $hgi0g = parcelRequire("hgi0g");
const $78eac8f1d70b3bae$var$transformType = (value)=>value === 'OPEN' || value === 'LIMITED' || value === 'PRIVATE' || value === 'FREE' ? value : 'UNKNOWN';
const $78eac8f1d70b3bae$var$transform = (response)=>{
    if (response.accessLevel === undefined) return undefined;
    return {
        type: $78eac8f1d70b3bae$var$transformType(response.accessLevel.value),
        label: response.accessLevel.displayName,
        description: response.accessLevel.description,
        iconName: response.accessLevel.iconName
    };
};
const $78eac8f1d70b3bae$export$c1e51f4f79456e2e = (projectId)=>(0, $hgi0g.default)(`/rest/internal/simplified/1.0/projects/${projectId}/summary`, {
        method: 'GET'
    }).then($78eac8f1d70b3bae$var$transform);

});


parcelRegister("3Z0eD", function(module, exports) {
$parcel$export(module.exports, "loadSharingSiteConfig", () => $d7a5358050919049$export$85c251450f7886f9);

var $eKTQH = parcelRequire("eKTQH");

var $b5oGV = parcelRequire("b5oGV");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $dylkx = parcelRequire("dylkx");

var $dMM78 = parcelRequire("dMM78");
const $d7a5358050919049$export$85c251450f7886f9 = ()=>async ({ setState: setState }, { isSharedView: isSharedView })=>{
        if (isSharedView) {
            setState({
                siteConfig: {
                    isEnabled: true,
                    isLoading: false,
                    error: undefined
                }
            });
            return;
        }
        setState({
            siteConfig: {
                isEnabled: false,
                isLoading: true,
                error: undefined
            }
        });
        try {
            (0, $b5oGV.experience).sharing.loadSiteConfig.start();
            const { enabled: enabled } = await (0, $dylkx.fetchSiteSharingConfig)();
            setState({
                siteConfig: {
                    isEnabled: enabled,
                    isLoading: false,
                    error: undefined
                }
            });
            (0, $b5oGV.experience).sharing.loadSiteConfig.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                siteConfig: {
                    isEnabled: false,
                    isLoading: false,
                    error: error
                }
            });
            if ((0, $fVlmn.isPermissionError)(error) || (0, $fVlmn.isNotFoundError)(error) || (0, $dMM78.isClientFetchError)(error)) (0, $b5oGV.experience).sharing.loadSiteConfig.abort(error);
            else (0, $b5oGV.experience).sharing.loadSiteConfig.failure(error);
            (0, $eKTQH.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.load-sharing-site-config-action', error));
        }
    };

});
parcelRegister("b5oGV", function(module, exports) {
$parcel$export(module.exports, "experience", () => $8f97456e719527e2$export$45794d16c9d83fe2);

var $5F7lp = parcelRequire("5F7lp");

var $5hijW = parcelRequire("5hijW");

var $dxu1o = parcelRequire("dxu1o");

var $dNeB5 = parcelRequire("dNeB5");

var $j5OkA = parcelRequire("j5OkA");

var $kzS1T = parcelRequire("kzS1T");

var $dzKqr = parcelRequire("dzKqr");

var $5HKXk = parcelRequire("5HKXk");

var $2nJkH = parcelRequire("2nJkH");

var $ZQxd9 = parcelRequire("ZQxd9");

var $4q2vI = parcelRequire("4q2vI");

var $1aCfx = parcelRequire("1aCfx");

var $arGNf = parcelRequire("arGNf");

var $9y6V7 = parcelRequire("9y6V7");

var $dRhKl = parcelRequire("dRhKl");

var $1OdQL = parcelRequire("1OdQL");

var $cYJdB = parcelRequire("cYJdB");

var $4FxxH = parcelRequire("4FxxH");

var $caQ0a = parcelRequire("caQ0a");

var $aE5Um = parcelRequire("aE5Um");

var $jGUrD = parcelRequire("jGUrD");

var $kjiOd = parcelRequire("kjiOd");

var $jRmYD = parcelRequire("jRmYD");

var $67QfL = parcelRequire("67QfL");

var $6Q8mY = parcelRequire("6Q8mY");
const $8f97456e719527e2$export$45794d16c9d83fe2 = {
    listView: $1aCfx,
    formulaField: $kzS1T,
    headerView: $5HKXk,
    boardView: $5F7lp,
    ideaView: $ZQxd9,
    ideaViewBentoSidebar: $2nJkH,
    matrixView: $arGNf,
    navBar: $9y6V7,
    project: $cYJdB,
    timelineView: $caQ0a,
    fieldsSidebar: $j5OkA,
    issues: $4q2vI,
    deliveryItems: $dNeB5,
    sharing: $4FxxH,
    globalFieldsAdministration: $dzKqr,
    playSidepanel: $1OdQL,
    noViewsScreen: $dRhKl,
    view: $jGUrD,
    viewPermissions: $aE5Um,
    collections: $5hijW,
    copyProjectConfiguration: $dxu1o,
    connections: $kjiOd,
    issueTypes: $jRmYD,
    projectTemplateCreationAsync: $67QfL,
    notification: $6Q8mY
};

});
parcelRegister("5F7lp", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $8b01a26415d8b0ec$export$94114666844d5f66);
$parcel$export(module.exports, "scrollPerformance", () => $8b01a26415d8b0ec$export$390e7f040546632b);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $8b01a26415d8b0ec$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.board-view', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $8b01a26415d8b0ec$export$390e7f040546632b = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.board-view.scroll-performance', {
    type: (0, $k024h.ExperienceTypes).Operation,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).Custom
}));

});
parcelRegister("8XCY1", function(module, exports) {
$parcel$export(module.exports, "createMarkedJpdExperience", () => $20b9c80b1c31e99d$export$bffa5dc83c7b8f85);
$parcel$export(module.exports, "createJpdExperience", () => $20b9c80b1c31e99d$export$2510480a5584184);
$parcel$export(module.exports, "wrapPromiseWithExperience", () => $20b9c80b1c31e99d$export$745ef3600a4acb32);
$parcel$export(module.exports, "wrapWithExperience", () => $20b9c80b1c31e99d$export$9527dfc663dbb238);
$parcel$export(module.exports, "createExperienceWithMetaType", () => $20b9c80b1c31e99d$export$e3ba910cdcb797bc);

var $l5Z0K = parcelRequire("l5Z0K");

var $eKTQH = parcelRequire("eKTQH");

var $14RSn = parcelRequire("14RSn");

var $dMM78 = parcelRequire("dMM78");
const $20b9c80b1c31e99d$export$bffa5dc83c7b8f85 = (ufoExperience, marks)=>({
        ...$20b9c80b1c31e99d$export$2510480a5584184(ufoExperience),
        marks: marks
    });
const $20b9c80b1c31e99d$export$a6d727308d53fe0e = (handler, error)=>{
    if (error === undefined) {
        handler();
        return;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($l5Z0K)))(error)) {
        handler({
            metadata: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error
            }
        });
        return;
    }
    if (typeof error === 'object' && error !== null) {
        const errorStatus = 'statusCode' in error && error.statusCode ? `[${error.statusCode}] ` : '';
        const errorName = 'name' in error && error.name ? `${error.name}` : '';
        const errorMessage = 'message' in error ? ` - ${error.message}` : '';
        const errorString = `${errorStatus}${errorName}${errorMessage}`; // example: "[404] FetchError  - Not Found"
        const traceId = typeof error === 'object' && 'traceId' in error ? error.traceId : undefined;
        if (!errorName && !errorStatus && !errorMessage) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return handler(error);
        return handler({
            metadata: {
                error: errorString,
                errors: 'errors' in error && Array.isArray(error.errors) ? error.errors.map((err)=>{
                    if (typeof err === 'string') return err;
                    if (typeof err === 'object' && err !== null && 'error' in err) return err.error;
                    return '';
                }).join(', ') : undefined,
                traceId: traceId
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    handler(error);
};
const $20b9c80b1c31e99d$export$2510480a5584184 = (ufoExperience)=>({
        ufoExperience: ufoExperience,
        start: (startTime)=>{
            ufoExperience.start();
            // hack to set custom start time
            if (startTime !== undefined) Object.assign(ufoExperience.metrics, {
                ...ufoExperience.metrics,
                startTime: startTime
            });
        },
        mark: (mark)=>{
            ufoExperience.mark(mark);
        },
        success: (meta, endTime)=>{
            ufoExperience.success(meta);
            // hack to set custom end time
            if (endTime !== undefined) Object.assign(ufoExperience.metrics, {
                ...ufoExperience.metrics,
                endTime: endTime
            });
        },
        successWithReason: (reason)=>{
            $20b9c80b1c31e99d$export$a6d727308d53fe0e((meta)=>ufoExperience.success(meta), reason);
        },
        failure: (reason)=>{
            $20b9c80b1c31e99d$export$a6d727308d53fe0e((meta)=>ufoExperience.failure(meta), reason);
        },
        abort: (reason)=>{
            $20b9c80b1c31e99d$export$a6d727308d53fe0e((meta)=>ufoExperience.abort(meta), reason);
        }
    });
const $20b9c80b1c31e99d$export$745ef3600a4acb32 = (promise, experience, errorAnalyticsId, isExperienceErrorAborted)=>{
    experience.start();
    return promise.then((response)=>{
        experience.success();
        return response;
    }).catch((error)=>{
        if (errorAnalyticsId) (0, $eKTQH.default)({
            meta: {
                id: errorAnalyticsId,
                teamName: 'polaris'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        if ((0, $dMM78.isClientFetchError)(error)) {
            experience.abort(error);
            throw error;
        }
        if ((0, $14RSn.isValidationError)(error)) {
            experience.abort(error);
            throw error;
        }
        if (isExperienceErrorAborted && isExperienceErrorAborted(error)) {
            experience.abort(error);
            throw error;
        }
        experience.failure(error);
        throw error;
    });
};
const $20b9c80b1c31e99d$export$9527dfc663dbb238 = (experience, callback)=>{
    experience.start();
    return callback().then((result)=>{
        experience.success();
        return result;
    }).catch((error)=>{
        if ((0, $dMM78.isClientFetchError)(error)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            experience.abort(error);
            throw error;
        }
        if (error instanceof Error) experience.failure(error);
        throw error;
    });
};
const $20b9c80b1c31e99d$export$e3ba910cdcb797bc = (experience, metaType, parseMetadataError)=>({
        ufoExperience: experience.ufoExperience,
        start: experience.start,
        mark: experience.mark,
        success: (meta, endTime)=>{
            experience.success({
                metadata: {
                    type: metaType
                },
                ...meta
            }, endTime);
        },
        successWithReason: (error)=>{
            experience.successWithReason({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        },
        failure: (error)=>{
            if (error && (0, $dMM78.isClientFetchError)(error)) experience.abort({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
            else experience.failure({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        },
        abort: (error)=>{
            experience.abort({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        }
    });

});


parcelRegister("5hijW", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $85ffd4fe8a4eb652$export$791d520f7e8058a5);
$parcel$export(module.exports, "create", () => $85ffd4fe8a4eb652$export$185802fd694ee1f5);
$parcel$export(module.exports, "loadCollections", () => $85ffd4fe8a4eb652$export$569b2ddb07e9ef58);
$parcel$export(module.exports, "loadViewCount", () => $85ffd4fe8a4eb652$export$136390ba2bb25e0b);
$parcel$export(module.exports, "loadUsers", () => $85ffd4fe8a4eb652$export$2c3a8e05396a78be);
$parcel$export(module.exports, "loadProjects", () => $85ffd4fe8a4eb652$export$14ec9adb679a31a1);
$parcel$export(module.exports, "createCollection", () => $85ffd4fe8a4eb652$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "copyCollection", () => $85ffd4fe8a4eb652$export$36928e43600c4b00);
$parcel$export(module.exports, "deleteCollection", () => $85ffd4fe8a4eb652$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $85ffd4fe8a4eb652$export$c0683150b517c317);
$parcel$export(module.exports, "loadCollection", () => $85ffd4fe8a4eb652$export$1f19ddbd9e78c2f5);
$parcel$export(module.exports, "loadCollectionViews", () => $85ffd4fe8a4eb652$export$a86e9e8b7168d682);
$parcel$export(module.exports, "loadCollectionDescription", () => $85ffd4fe8a4eb652$export$da25d48c64ab9a24);
$parcel$export(module.exports, "updateCollectionDescription", () => $85ffd4fe8a4eb652$export$95146d83152efba8);
$parcel$export(module.exports, "createView", () => $85ffd4fe8a4eb652$export$d7febe7b891e79f0);
$parcel$export(module.exports, "deleteView", () => $85ffd4fe8a4eb652$export$443d89549b135c95);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $85ffd4fe8a4eb652$export$791d520f7e8058a5 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageLoad
}));
const $85ffd4fe8a4eb652$export$185802fd694ee1f5 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$569b2ddb07e9ef58 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.load-collections', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$136390ba2bb25e0b = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.load-view-count', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$2c3a8e05396a78be = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.load-users', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$14ec9adb679a31a1 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.load-projects', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$c74125a8e3af6bb2 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.create-collection', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$36928e43600c4b00 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.copy-collection', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$3d16e031f6551662 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.delete-collection', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$c0683150b517c317 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.update-collection', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$1f19ddbd9e78c2f5 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.load-collection', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$a86e9e8b7168d682 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.load-collection-views', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$da25d48c64ab9a24 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.load-collection-description', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$95146d83152efba8 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.update-collection-description', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$d7febe7b891e79f0 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.create-view', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$443d89549b135c95 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.collections.delete-view', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("dxu1o", function(module, exports) {
$parcel$export(module.exports, "copy", () => $bc46650526d1059f$export$784d13d8ee351f07);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $bc46650526d1059f$export$784d13d8ee351f07 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.copy-project-configuration', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("dNeB5", function(module, exports) {
$parcel$export(module.exports, "loadChildIssues", () => $c5c675cc1b53a78c$export$df5c5945eb51ab10);
$parcel$export(module.exports, "loadAggregatedDeliveryProgressBasedOnProjectId", () => $c5c675cc1b53a78c$export$531ec6120f223bb8);
$parcel$export(module.exports, "loadAggregatedDeliveryProgress", () => $c5c675cc1b53a78c$export$12a1609f29cbb864);
$parcel$export(module.exports, "loadLinkedDeliveryTickets", () => $c5c675cc1b53a78c$export$a88d267f7658a3dc);
$parcel$export(module.exports, "loadTransitiveChildrenArjHierarchy", () => $c5c675cc1b53a78c$export$ffdb9dea53e75ee5);
$parcel$export(module.exports, "loadTransitiveChildrenInTwoLevelCoreHierarchy", () => $c5c675cc1b53a78c$export$f9f3d52ff0f7a0b8);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $c5c675cc1b53a78c$export$df5c5945eb51ab10 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.delivery-items.load.childIssues', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c5c675cc1b53a78c$export$531ec6120f223bb8 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgressBasedOnProjectId', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c5c675cc1b53a78c$export$12a1609f29cbb864 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgress', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c5c675cc1b53a78c$export$a88d267f7658a3dc = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.delivery-items.load.linkedDeliveryTickets', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c5c675cc1b53a78c$export$ffdb9dea53e75ee5 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.delivery-items.load.transitiveChildrenArjHierarchy', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c5c675cc1b53a78c$export$f9f3d52ff0f7a0b8 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.delivery-items.load.transitiveChildrenInTwoLevelCoreHierarchy', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("j5OkA", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $8c3ef38c4f350aec$export$94114666844d5f66);
$parcel$export(module.exports, "fieldToggle", () => $8c3ef38c4f350aec$export$76f0d602d0733e6d);
$parcel$export(module.exports, "fieldHide", () => $8c3ef38c4f350aec$export$413c667806d09e8e);
$parcel$export(module.exports, "fieldDelete", () => $8c3ef38c4f350aec$export$b246cee4a79b9379);
$parcel$export(module.exports, "fieldRegularCreate", () => $8c3ef38c4f350aec$export$9df4f5b7e476ce84);
$parcel$export(module.exports, "fieldFormulaCreate", () => $8c3ef38c4f350aec$export$27b3440b11d7d826);
$parcel$export(module.exports, "fieldPlayCreate", () => $8c3ef38c4f350aec$export$f2ca0d7a70f0d4fa);
$parcel$export(module.exports, "fieldConfigurationUpdate", () => $8c3ef38c4f350aec$export$bb265be09cbcf6b4);
$parcel$export(module.exports, "fieldOptionUpdate", () => $8c3ef38c4f350aec$export$dd81c54ce99ca034);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $8c3ef38c4f350aec$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.fields-sidebar.load', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $8c3ef38c4f350aec$export$76f0d602d0733e6d = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.fields-sidebar.field-toggle', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$413c667806d09e8e = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.fields-sidebar.field-hide', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$b246cee4a79b9379 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.fields-sidebar.field-delete', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$9df4f5b7e476ce84 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.fields-sidebar.field-regular-create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$27b3440b11d7d826 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.fields-sidebar.field-formula-create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$f2ca0d7a70f0d4fa = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.fields-sidebar.field-play-create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$bb265be09cbcf6b4 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.fields-sidebar.field-configuration-update', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$dd81c54ce99ca034 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.fields-sidebar.field-option-update', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("kzS1T", function(module, exports) {
$parcel$export(module.exports, "precalculateFormulaFieldAllValuesSelector", () => $63aff75064371c7a$export$a228cb9f5622e166);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $63aff75064371c7a$export$a228cb9f5622e166 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.formula-field.precalculate-all-values-selector', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("dzKqr", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $8714cc93eb6f9050$export$791d520f7e8058a5);
$parcel$export(module.exports, "globalFieldCreate", () => $8714cc93eb6f9050$export$b03352737479563);
$parcel$export(module.exports, "globalFieldDelete", () => $8714cc93eb6f9050$export$84497cb573c7d17);
$parcel$export(module.exports, "globalFieldAssociate", () => $8714cc93eb6f9050$export$65839e13cd248f9e);
$parcel$export(module.exports, "globalFieldUnassociate", () => $8714cc93eb6f9050$export$29a31286f27d1a2e);
$parcel$export(module.exports, "globalFieldCheckViewsUsage", () => $8714cc93eb6f9050$export$8b1a216a358cdd80);
$parcel$export(module.exports, "globalFieldUpdate", () => $8714cc93eb6f9050$export$62c234d94572bba2);
$parcel$export(module.exports, "globalFieldUpdateConfig", () => $8714cc93eb6f9050$export$a17a8741bdd2acf);
$parcel$export(module.exports, "globalFieldCheckProjectUsage", () => $8714cc93eb6f9050$export$d30c8e3ea8a9aa57);
$parcel$export(module.exports, "loadGlobalFields", () => $8714cc93eb6f9050$export$f71db070ee14476f);
$parcel$export(module.exports, "loadGlobalLabels", () => $8714cc93eb6f9050$export$c6682f53b5f48ef8);
$parcel$export(module.exports, "loadJpdProjects", () => $8714cc93eb6f9050$export$85d7e1fdff0f01b4);
$parcel$export(module.exports, "loadProjectsWithField", () => $8714cc93eb6f9050$export$867e6f0888bf4bd);
$parcel$export(module.exports, "fieldAddOptions", () => $8714cc93eb6f9050$export$317ab3380fbbaacc);
$parcel$export(module.exports, "fieldDeleteOption", () => $8714cc93eb6f9050$export$d55856fb0a38bf13);
$parcel$export(module.exports, "fieldRenameOption", () => $8714cc93eb6f9050$export$12e095e9d4e2e327);
$parcel$export(module.exports, "fieldMoveOptions", () => $8714cc93eb6f9050$export$ba026a86e3a2a2ee);
$parcel$export(module.exports, "copyValues", () => $8714cc93eb6f9050$export$2b4b550f6684d934);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $8714cc93eb6f9050$export$791d520f7e8058a5 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageLoad
}));
const $8714cc93eb6f9050$export$b03352737479563 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$84497cb573c7d17 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-delete', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$65839e13cd248f9e = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-associate', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$29a31286f27d1a2e = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-unassociate', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$8b1a216a358cdd80 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-check-views-usage', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$62c234d94572bba2 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-update', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$a17a8741bdd2acf = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-update-config', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$d30c8e3ea8a9aa57 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-check-project-usage', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$f71db070ee14476f = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.load-fields', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$c6682f53b5f48ef8 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.load-global-labels', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$85d7e1fdff0f01b4 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.load-jpd-projects', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$867e6f0888bf4bd = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.load-projects-with-field', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$317ab3380fbbaacc = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-add-options', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$d55856fb0a38bf13 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-delete-option', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$12e095e9d4e2e327 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-rename-option', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$ba026a86e3a2a2ee = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.field-move-options', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$2b4b550f6684d934 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global-fields-administration.copy-values', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("5HKXk", function(module, exports) {
$parcel$export(module.exports, "updateViewDescription", () => $35297c286530b4de$export$16660b9e64c03042);
$parcel$export(module.exports, "viewGroupBy", () => $35297c286530b4de$export$5537a4a396822165);
$parcel$export(module.exports, "viewSort", () => $35297c286530b4de$export$f29ab69847cb95c0);
$parcel$export(module.exports, "viewFilter", () => $35297c286530b4de$export$7a7ebd5529ec7d46);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $35297c286530b4de$export$16660b9e64c03042 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.header-view.update-view-description', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $35297c286530b4de$export$5537a4a396822165 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.header-view.view-group-by', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $35297c286530b4de$export$f29ab69847cb95c0 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.header-view.view-sort', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $35297c286530b4de$export$7a7ebd5529ec7d46 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.header-view.view-filter', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("2nJkH", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $60f7e7d615582df4$export$94114666844d5f66);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $60f7e7d615582df4$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view-bento-sidebar', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));

});

parcelRegister("ZQxd9", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $d83d8a16960e36f4$export$94114666844d5f66);
$parcel$export(module.exports, "directPageSegmentLoad", () => $d83d8a16960e36f4$export$ee08e8134696f146);
$parcel$export(module.exports, "summaryUpdate", () => $d83d8a16960e36f4$export$5622e807234df3bb);
$parcel$export(module.exports, "descriptionUpdate", () => $d83d8a16960e36f4$export$f8fe5931289a9815);
$parcel$export(module.exports, "deliveryTicketCreate", () => $d83d8a16960e36f4$export$a84a662b970b5ae);
$parcel$export(module.exports, "commentCreate", () => $d83d8a16960e36f4$export$18cd8f3c0240b0a7);
$parcel$export(module.exports, "insightCreate", () => $d83d8a16960e36f4$export$5fb856565362db95);
$parcel$export(module.exports, "insightUpdate", () => $d83d8a16960e36f4$export$db3376d543b8f2f0);
$parcel$export(module.exports, "insightDelete", () => $d83d8a16960e36f4$export$5cf5d5fb5df27ce4);
$parcel$export(module.exports, "issueLinkCreate", () => $d83d8a16960e36f4$export$c88b0a5d9f4319fc);
$parcel$export(module.exports, "commentsSegmentLoad", () => $d83d8a16960e36f4$export$c9255b3c7ce3b238);
$parcel$export(module.exports, "insightsSegmentLoad", () => $d83d8a16960e36f4$export$31d3301eb443a690);
$parcel$export(module.exports, "fileAttach", () => $d83d8a16960e36f4$export$97a2bd48ad08a74b);
$parcel$export(module.exports, "connectionsSegmentLoad", () => $d83d8a16960e36f4$export$ea0be4743e48989b);
$parcel$export(module.exports, "makeFieldUpdate", () => $d83d8a16960e36f4$export$c9a3588491d4a10b);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $d83d8a16960e36f4$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d83d8a16960e36f4$export$ee08e8134696f146 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view-direct', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d83d8a16960e36f4$export$5622e807234df3bb = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.summary-update', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$f8fe5931289a9815 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.description-update', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$a84a662b970b5ae = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.delivery-ticket-create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$18cd8f3c0240b0a7 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.comment-create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$5fb856565362db95 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.insight-create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$db3376d543b8f2f0 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.insight-update', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$5cf5d5fb5df27ce4 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.insight-delete', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$c88b0a5d9f4319fc = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.issue-link-create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$c9255b3c7ce3b238 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.comments', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d83d8a16960e36f4$export$31d3301eb443a690 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.insights', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d83d8a16960e36f4$export$97a2bd48ad08a74b = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.attach-file', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$ea0be4743e48989b = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.connections-tab', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d83d8a16960e36f4$export$c9a3588491d4a10b = ()=>(0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.idea-view.field-update', {
        type: (0, $k024h.ExperienceTypes).Experience,
        performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
    }));

});

parcelRegister("4q2vI", function(module, exports) {
$parcel$export(module.exports, "loadIssuesRestBatched", () => $3ad241a988f9ee65$export$b4c4374bf531f011);
$parcel$export(module.exports, "loadIssueRest", () => $3ad241a988f9ee65$export$f1cca26704284332);
$parcel$export(module.exports, "loadIssuesJpdApi", () => $3ad241a988f9ee65$export$edc886929f100d7e);
$parcel$export(module.exports, "loadIssueJpdApi", () => $3ad241a988f9ee65$export$21e6ded5e5c7786);
$parcel$export(module.exports, "loadIssuesRanksRestBatched", () => $3ad241a988f9ee65$export$7605559f436ef08a);
$parcel$export(module.exports, "loadIssuesRanksJpdApi", () => $3ad241a988f9ee65$export$173ed5a278c1732b);
$parcel$export(module.exports, "rankIssue", () => $3ad241a988f9ee65$export$dbff149eb80fd116);
$parcel$export(module.exports, "loadIssuePickerIssuesRest", () => $3ad241a988f9ee65$export$23a6e22f367c9283);
$parcel$export(module.exports, "globalJpdIssueCreate", () => $3ad241a988f9ee65$export$792186e7b1057ce9);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $3ad241a988f9ee65$export$b4c4374bf531f011 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issues.load.rest-batched', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$f1cca26704284332 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue.load.rest', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$edc886929f100d7e = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issues.load.jpd-api', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$21e6ded5e5c7786 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue.load.jpd-api', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$7605559f436ef08a = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issues.ranks.load.rest-batched', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$173ed5a278c1732b = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issues.ranks.load.jpd-api', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$dbff149eb80fd116 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue.rank', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$23a6e22f367c9283 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue-picker.load', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$792186e7b1057ce9 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.global.jpd.create-issue', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("1aCfx", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $d75571d30db1d607$export$94114666844d5f66);
$parcel$export(module.exports, "createIdeaInline", () => $d75571d30db1d607$export$5ea76ff12d204976);
$parcel$export(module.exports, "createIdeaInlineBulk", () => $d75571d30db1d607$export$47ee03b76831577c);
$parcel$export(module.exports, "createIdeaInlineClickResponse", () => $d75571d30db1d607$export$f9ccaf2135e3de7d);
$parcel$export(module.exports, "changeViewName", () => $d75571d30db1d607$export$1375b601692f3137);
$parcel$export(module.exports, "listScrollPerformance", () => $d75571d30db1d607$export$98edb0fcdfb46224);
$parcel$export(module.exports, "makeFieldUpdate", () => $d75571d30db1d607$export$c9a3588491d4a10b);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $d75571d30db1d607$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.list-view', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d75571d30db1d607$export$5ea76ff12d204976 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.list-view.create-idea-inline', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d75571d30db1d607$export$47ee03b76831577c = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.list-view.create-idea-inline-bulk', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d75571d30db1d607$export$f9ccaf2135e3de7d = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.list-view.create-idea-inline-button-click', {
    type: (0, $k024h.ExperienceTypes).Operation,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).Custom
}));
const $d75571d30db1d607$export$1375b601692f3137 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.list-view.change-view-name', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $d75571d30db1d607$export$98edb0fcdfb46224 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.list-view.scroll-performance', {
    type: (0, $k024h.ExperienceTypes).Operation,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).Custom
}));
const $d75571d30db1d607$export$c9a3588491d4a10b = ()=>(0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.list-view.field-update', {
        type: (0, $k024h.ExperienceTypes).Experience,
        performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult,
        timings: [
            {
                key: 'internal_state',
                endMark: 'backend_request_start'
            },
            {
                key: 'backend_request',
                startMark: 'backend_request_start'
            }
        ]
    }));

});

parcelRegister("arGNf", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $8b1bd80fa2396b91$export$94114666844d5f66);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $8b1bd80fa2396b91$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.matrix-view', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));

});

parcelRegister("9y6V7", function(module, exports) {
$parcel$export(module.exports, "changeViewName", () => $61fb22fffcc35495$export$1375b601692f3137);
$parcel$export(module.exports, "changeViewRank", () => $61fb22fffcc35495$export$52abe324a1859929);
$parcel$export(module.exports, "createView", () => $61fb22fffcc35495$export$d7febe7b891e79f0);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $61fb22fffcc35495$export$1375b601692f3137 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.nav-bar.change-view-name', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $61fb22fffcc35495$export$52abe324a1859929 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.nav-bar.change-view-rank', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $61fb22fffcc35495$export$d7febe7b891e79f0 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.nav-bar.create-view', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("dRhKl", function(module, exports) {
$parcel$export(module.exports, "createView", () => $938b0208b41d52dc$export$d7febe7b891e79f0);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $938b0208b41d52dc$export$d7febe7b891e79f0 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.no-views-screen.create-view', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("1OdQL", function(module, exports) {
$parcel$export(module.exports, "updatePlayField", () => $502df02e68126e64$export$870e1a1a0d62147f);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $502df02e68126e64$export$870e1a1a0d62147f = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.play-sidepanel.field-update', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("cYJdB", function(module, exports) {
$parcel$export(module.exports, "applyTemplateMarks", () => $943be4925de62373$export$e7702071f99306f0);
$parcel$export(module.exports, "pageLoad", () => $943be4925de62373$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageLoadWithRateLimit", () => $943be4925de62373$export$5102ef8e92249e0d);
$parcel$export(module.exports, "applyTemplate", () => $943be4925de62373$export$f78a296632f66e69);
$parcel$export(module.exports, "create", () => $943be4925de62373$export$185802fd694ee1f5);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $943be4925de62373$export$e7702071f99306f0 = {
    APPLY_TEMPLATE_POLLING_START_MARK: 'apply_template_polling_start',
    APPLY_TEMPLATE_POLLING_STOP_MARK: 'apply_template_polling_stop'
};
const $943be4925de62373$export$791d520f7e8058a5 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.project', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageLoad
}));
const $943be4925de62373$export$5102ef8e92249e0d = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.project.rate-limit', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageLoad
}));
const $943be4925de62373$export$f78a296632f66e69 = (0, $8XCY1.createMarkedJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.project.apply-template', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'apply_template_polling',
            startMark: $943be4925de62373$export$e7702071f99306f0.APPLY_TEMPLATE_POLLING_START_MARK,
            endMark: $943be4925de62373$export$e7702071f99306f0.APPLY_TEMPLATE_POLLING_STOP_MARK
        }
    ]
}), $943be4925de62373$export$e7702071f99306f0);
const $943be4925de62373$export$185802fd694ee1f5 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.project.create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("4FxxH", function(module, exports) {
$parcel$export(module.exports, "dialogLoad", () => $c6e3a5461601706c$export$f9bf6b7b75be4461);
$parcel$export(module.exports, "loadStakeholders", () => $c6e3a5461601706c$export$da3bab182f5666a9);
$parcel$export(module.exports, "addStakeholders", () => $c6e3a5461601706c$export$39dc8a3bc2974ed6);
$parcel$export(module.exports, "removeStakeholders", () => $c6e3a5461601706c$export$e7a3e16d74b6c142);
$parcel$export(module.exports, "loadSettings", () => $c6e3a5461601706c$export$54453bb1ffd2fd71);
$parcel$export(module.exports, "updateSettings", () => $c6e3a5461601706c$export$f558026a994b6051);
$parcel$export(module.exports, "loadSiteConfig", () => $c6e3a5461601706c$export$b2e18be8354b8d72);
$parcel$export(module.exports, "loadSitePublicSharingConfig", () => $c6e3a5461601706c$export$85d654471364d5f1);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $c6e3a5461601706c$export$f9bf6b7b75be4461 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.shared.control-dialog-load', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $c6e3a5461601706c$export$da3bab182f5666a9 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.shared.load-stakeholders', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$39dc8a3bc2974ed6 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.shared.add-stakeholders', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$e7a3e16d74b6c142 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.shared.remove-stakeholders', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$54453bb1ffd2fd71 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.shared.load-settings', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$f558026a994b6051 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.shared.update-settings', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$b2e18be8354b8d72 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.shared.load-site-config', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$85d654471364d5f1 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.shared.load-site-public-sharing-config', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("caQ0a", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoad", () => $c8552630708d233d$export$94114666844d5f66);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $c8552630708d233d$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.timeline-view', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));

});

parcelRegister("aE5Um", function(module, exports) {
$parcel$export(module.exports, "openDialog", () => $6f224f4fb313fb78$export$45f11db5513b93db);
$parcel$export(module.exports, "loadViewAccess", () => $6f224f4fb313fb78$export$7894161c427d5a42);
$parcel$export(module.exports, "updateViewAccess", () => $6f224f4fb313fb78$export$710acb0a8739a684);
$parcel$export(module.exports, "updatePrincipals", () => $6f224f4fb313fb78$export$a9ab5c1920acd4f5);
$parcel$export(module.exports, "loadCurrentUserViewPermissions", () => $6f224f4fb313fb78$export$b3a1f4fc3f38595c);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $6f224f4fb313fb78$export$45f11db5513b93db = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.view-permissions.open-dialog', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $6f224f4fb313fb78$export$7894161c427d5a42 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.view-permissions.load-view-access', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $6f224f4fb313fb78$export$710acb0a8739a684 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.view-permissions.update-view-access', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $6f224f4fb313fb78$export$a9ab5c1920acd4f5 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.view-permissions.update-principals', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $6f224f4fb313fb78$export$b3a1f4fc3f38595c = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.view-permissions.load-current-user-view-permissions', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("jGUrD", function(module, exports) {
$parcel$export(module.exports, "getView", () => $0bde8ed84e69df14$export$513f42987b822fd7);
$parcel$export(module.exports, "updateView", () => $0bde8ed84e69df14$export$827a6c17a85f6d1a);
$parcel$export(module.exports, "deleteView", () => $0bde8ed84e69df14$export$443d89549b135c95);
$parcel$export(module.exports, "makeGenericIssueFieldUpdate", () => $0bde8ed84e69df14$export$951d66f9bcb4c7fc);
$parcel$export(module.exports, "updateIssueFields", () => $0bde8ed84e69df14$export$fb24ad07bc5a0153);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $0bde8ed84e69df14$export$513f42987b822fd7 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.view.get-view', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $0bde8ed84e69df14$export$827a6c17a85f6d1a = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.view.update-view', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $0bde8ed84e69df14$export$443d89549b135c95 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.view.delete-view', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $0bde8ed84e69df14$export$951d66f9bcb4c7fc = ()=>(0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue-update.field', {
        type: (0, $k024h.ExperienceTypes).Experience,
        performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult,
        timings: [
            {
                key: 'internal_state',
                endMark: 'backend_request_start'
            },
            {
                key: 'backend_request',
                startMark: 'backend_request_start'
            }
        ]
    }));
const $0bde8ed84e69df14$export$fb24ad07bc5a0153 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue-update.fields', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult,
    timings: [
        {
            key: 'internal_state',
            endMark: 'backend_request_start'
        },
        {
            key: 'backend_request',
            startMark: 'backend_request_start'
        }
    ]
}));

});

parcelRegister("kjiOd", function(module, exports) {
$parcel$export(module.exports, "issueConnectionFieldValueUpdate", () => $022e60bffba67a55$export$f339c49235963d2a);
$parcel$export(module.exports, "issueConnectionFieldsValuesUpdateBulk", () => $022e60bffba67a55$export$6fd69dd8cdad62db);
$parcel$export(module.exports, "connectionBetaConfigToggleChange", () => $022e60bffba67a55$export$f6f1d9ce01ba0990);
$parcel$export(module.exports, "connectionBetaConfigLoad", () => $022e60bffba67a55$export$dd51d033a6bac611);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $022e60bffba67a55$export$f339c49235963d2a = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue-update.connection-field', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $022e60bffba67a55$export$6fd69dd8cdad62db = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue-update-bulk.connection-field', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $022e60bffba67a55$export$f6f1d9ce01ba0990 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.connection-beta-config.toggle-change', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $022e60bffba67a55$export$dd51d033a6bac611 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.connection-beta-config.load', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("jRmYD", function(module, exports) {
$parcel$export(module.exports, "issueTypesForProjectsLoad", () => $e3c849bf2de5a562$export$b6a12305b3088569);
$parcel$export(module.exports, "issueTypeCreate", () => $e3c849bf2de5a562$export$8eabdcbb38a006a1);
$parcel$export(module.exports, "issueTypeDelete", () => $e3c849bf2de5a562$export$e68e92297750053b);
$parcel$export(module.exports, "issueTypeUpdate", () => $e3c849bf2de5a562$export$539ed317ca253756);
$parcel$export(module.exports, "issueTypePinnedFieldsUpdate", () => $e3c849bf2de5a562$export$82779cf6bc40edd8);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $e3c849bf2de5a562$export$b6a12305b3088569 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue-types.load-all', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $e3c849bf2de5a562$export$8eabdcbb38a006a1 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue-types.create', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $e3c849bf2de5a562$export$e68e92297750053b = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue-types.delete', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $e3c849bf2de5a562$export$539ed317ca253756 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue-types.update', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));
const $e3c849bf2de5a562$export$82779cf6bc40edd8 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.issue-types.pinned-fields.update', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("67QfL", function(module, exports) {
$parcel$export(module.exports, "projectCreationPollingMarks", () => $c4b70b8f25495d7b$export$39a123f63b4818b1);
$parcel$export(module.exports, "apply", () => $c4b70b8f25495d7b$export$5635d7ef4b8fee1c);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $c4b70b8f25495d7b$export$39a123f63b4818b1 = {
    PROJECT_CREATION_POLLING_START_MARK: 'project_creation_polling_start',
    PROJECT_CREATION_POLLING_STOP_MARK: 'project_creation_polling_stop'
};
const $c4b70b8f25495d7b$export$5635d7ef4b8fee1c = (0, $8XCY1.createMarkedJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.project-template-creation-async', {
    type: (0, $k024h.ExperienceTypes).Experience,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'project_creation_polling',
            startMark: $c4b70b8f25495d7b$export$39a123f63b4818b1.PROJECT_CREATION_POLLING_START_MARK,
            endMark: $c4b70b8f25495d7b$export$39a123f63b4818b1.PROJECT_CREATION_POLLING_STOP_MARK
        }
    ]
}), $c4b70b8f25495d7b$export$39a123f63b4818b1);

});

parcelRegister("6Q8mY", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $90cd712f0dcae3ae$export$791d520f7e8058a5);

var $k024h = parcelRequire("k024h");
var $1NSf5 = parcelRequire("1NSf5");

var $8XCY1 = parcelRequire("8XCY1");
const $90cd712f0dcae3ae$export$791d520f7e8058a5 = (0, $8XCY1.createJpdExperience)(new (0, $1NSf5.UFOExperience)('jpd.notification-settings', {
    type: (0, $k024h.ExperienceTypes).Load,
    performanceType: (0, $k024h.ExperiencePerformanceTypes).PageLoad
}));

});


parcelRegister("dylkx", function(module, exports) {
$parcel$export(module.exports, "fetchSiteSharingConfig", () => $cd0566e434528c1f$export$28c58aa760b45b2f);
$parcel$export(module.exports, "enableSharingOnSite", () => $cd0566e434528c1f$export$9a5ce37e4cd6948a);
$parcel$export(module.exports, "disableSharingOnSite", () => $cd0566e434528c1f$export$20b3e963cde336ea);
$parcel$export(module.exports, "fetchSitePublicSharingConfig", () => $cd0566e434528c1f$export$d88e9e9de94a1689);
$parcel$export(module.exports, "enablePublicSharingOnSite", () => $cd0566e434528c1f$export$a39f2019d2db95d2);
$parcel$export(module.exports, "disablePublicSharingOnSite", () => $cd0566e434528c1f$export$5c0263c3f0e2deff);

var $hgi0g = parcelRequire("hgi0g");

var $3ugTQ = parcelRequire("3ugTQ");

var $68Jjc = parcelRequire("68Jjc");
const $cd0566e434528c1f$export$28c58aa760b45b2f = ()=>(0, $hgi0g.default)((0, $68Jjc.SITE_SHARING_CONFIG_URL));
const $cd0566e434528c1f$export$9a5ce37e4cd6948a = ()=>(0, $3ugTQ.performPutRequest)(`${(0, $68Jjc.SITE_SHARING_CONFIG_URL)}/enable`);
const $cd0566e434528c1f$export$20b3e963cde336ea = ()=>(0, $3ugTQ.performPutRequest)(`${(0, $68Jjc.SITE_SHARING_CONFIG_URL)}/disable`);
const $cd0566e434528c1f$export$d88e9e9de94a1689 = ()=>(0, $hgi0g.default)(`${(0, $68Jjc.SITE_SHARING_CONFIG_URL)}/public`);
const $cd0566e434528c1f$export$a39f2019d2db95d2 = ()=>(0, $3ugTQ.performPutRequest)(`${(0, $68Jjc.SITE_SHARING_CONFIG_URL)}/public/enable`);
const $cd0566e434528c1f$export$5c0263c3f0e2deff = ()=>(0, $3ugTQ.performPutRequest)(`${(0, $68Jjc.SITE_SHARING_CONFIG_URL)}/public/disable`);

});
parcelRegister("68Jjc", function(module, exports) {
$parcel$export(module.exports, "SITE_SHARING_CONFIG_URL", () => $8c1414213ff5f65c$export$f27e6cd6ae0b6f49);
const $8c1414213ff5f65c$export$d3c2b1c9aa071f82 = {
    ANYONE: 'ANYONE',
    ORGANIZATION: 'ORGANIZATION'
};
const $8c1414213ff5f65c$export$f27e6cd6ae0b6f49 = '/rest/polaris/views/sharing/config';

});



parcelRegister("1bMxm", function(module, exports) {
$parcel$export(module.exports, "privateActions", () => $6e020bf52bf3739a$export$3f1be494d407b77a);
$parcel$export(module.exports, "publicActions", () => $6e020bf52bf3739a$export$8705b583fa097d24);

var $fa62R = parcelRequire("fa62R");

var $ij0Yh = parcelRequire("ij0Yh");

var $03d5M = parcelRequire("03d5M");

var $3Z0eD = parcelRequire("3Z0eD");

var $54qZO = parcelRequire("54qZO");

var $fJgAQ = parcelRequire("fJgAQ");



var $3Z0eD = parcelRequire("3Z0eD");

var $ij0Yh = parcelRequire("ij0Yh");

const $6e020bf52bf3739a$export$3f1be494d407b77a = {
    loadSitePublicSharingConfig: $fa62R.loadSitePublicSharingConfig
};
const $6e020bf52bf3739a$export$8705b583fa097d24 = {
    loadSharingSettings: $03d5M.loadSharingSettings,
    updateSharingSettings: $03d5M.updateSharingSettings,
    addSharingStakeholders: $54qZO.addSharingStakeholders,
    loadSharingStakeholders: $54qZO.loadSharingStakeholders,
    removeSharingStakeholders: $54qZO.removeSharingStakeholders,
    loadSharingSiteConfig: $3Z0eD.loadSharingSiteConfig,
    setProjectAccessLevel: $ij0Yh.setProjectAccessLevel,
    loadProjectAccessLevel: $ij0Yh.loadProjectAccessLevel,
    deletePublishedView: $fJgAQ.deletePublishedView
};

});
parcelRegister("fa62R", function(module, exports) {
$parcel$export(module.exports, "loadSitePublicSharingConfig", () => $7d2a8f518a193145$export$85d654471364d5f1);

var $eKTQH = parcelRequire("eKTQH");

var $b5oGV = parcelRequire("b5oGV");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $dylkx = parcelRequire("dylkx");

var $dMM78 = parcelRequire("dMM78");
const $7d2a8f518a193145$export$85d654471364d5f1 = ()=>async ({ setState: setState })=>{
        setState({
            sitePublicSharingConfig: {
                isEnabled: false,
                isLoading: true,
                error: undefined
            }
        });
        try {
            (0, $b5oGV.experience).sharing.loadSitePublicSharingConfig.start();
            const { enabled: enabled } = await (0, $dylkx.fetchSitePublicSharingConfig)();
            setState({
                sitePublicSharingConfig: {
                    isEnabled: enabled,
                    isLoading: false,
                    error: undefined
                }
            });
            (0, $b5oGV.experience).sharing.loadSitePublicSharingConfig.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                sitePublicSharingConfig: {
                    isEnabled: false,
                    isLoading: false,
                    error: error
                }
            });
            if ((0, $fVlmn.isPermissionError)(error) || (0, $fVlmn.isNotFoundError)(error) || (0, $dMM78.isClientFetchError)(error)) (0, $b5oGV.experience).sharing.loadSitePublicSharingConfig.abort(error);
            else (0, $b5oGV.experience).sharing.loadSitePublicSharingConfig.failure(error);
            (0, $eKTQH.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.load-site-public-sharing-config-action', error));
        }
    };

});

parcelRegister("03d5M", function(module, exports) {
$parcel$export(module.exports, "updateSharingSettings", () => $7e01f113dcba2650$export$69a9d91d9040f402);
$parcel$export(module.exports, "loadSharingSettings", () => $7e01f113dcba2650$export$38e4cff581c355ad);

var $cSmYj = parcelRequire("cSmYj");

var $eKTQH = parcelRequire("eKTQH");

var $b5oGV = parcelRequire("b5oGV");

var $3Ku0X = parcelRequire("3Ku0X");

var $7e8wG = parcelRequire("7e8wG");

var $fVlmn = parcelRequire("fVlmn");

var $kRgKj = parcelRequire("kRgKj");

var $dMM78 = parcelRequire("dMM78");

var $14RSn = parcelRequire("14RSn");

var $7BzKB = parcelRequire("7BzKB");

var $2fKlW = parcelRequire("2fKlW");
// this logic is needed when custom description field was removed,
// in such case we don't want to send this value to jpd-views-service to avoid 400 error
const $7e01f113dcba2650$var$sanitizeSettings = (settings, fields)=>{
    if (settings.ideaDescription.fieldKey) {
        const descriptionFieldExists = fields.some(({ key: key })=>key === settings.ideaDescription.fieldKey);
        if (!descriptionFieldExists) {
            const { ideaDescription: ideaDescription, ...rest } = settings;
            return rest;
        }
    }
    return settings;
};
// Rationale for this helper:
// We use a single endpoint for fetching the settings but two distinct ones
// to update them. Since updateSharingSettings action processes combined
// settings object we need to figure out which services to call based on
// the settings object properties diff.
const $7e01f113dcba2650$var$callSharingSettingsServices = async (viewRemote, viewUUID, newSettings, oldSettings)=>{
    const { publicSharingEnabled: newValueOfPublicSharingEnabled, ...incomingSettings } = newSettings;
    const { publicSharingEnabled: oldValueOfPublicSharingEnabled, ...existingSettings } = oldSettings ?? {};
    const requestPromises = [];
    const result = {
        publicAccessChanged: false,
        publishedChanged: false
    };
    if (newValueOfPublicSharingEnabled !== undefined && newValueOfPublicSharingEnabled !== oldValueOfPublicSharingEnabled) {
        requestPromises.push(viewRemote.updatePublicSharingSettings(viewUUID, {
            enabled: newValueOfPublicSharingEnabled
        }));
        result.publicAccessChanged = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(incomingSettings, existingSettings)) {
        requestPromises.push(viewRemote.updateSharingSettings(viewUUID, newSettings));
        result.publishedChanged = true;
    }
    await Promise.all(requestPromises);
    return result;
};
/**
 * Since public sharing is not an atomic action (we need to check 2 independent settings to establish if the view
 * is being shared publicly with the link) this function single reponsibility is to compare previous and next settings
 * on update and see if the view is becoming public, stops being public or the settings change does not impact
 * the view public sharing status.
 */ const $7e01f113dcba2650$var$getSettingsUpdateOutcome = async (prevSettings, newSettings)=>{
    const wasSharedPublicly = prevSettings?.publicSharingEnabled === true && prevSettings?.sharingLinkEnabled === true;
    if (wasSharedPublicly) {
        const willStopBeingShared = newSettings.publicSharingEnabled === false || newSettings?.sharingLinkEnabled === false;
        if (willStopBeingShared) return 'PUBLIC_SHARING_DISABLED';
    } else {
        const combinedPublicSharingSettings = {
            publicSharingEnabled: newSettings.publicSharingEnabled ?? prevSettings?.publicSharingEnabled ?? false,
            sharingLinkEnabled: newSettings.sharingLinkEnabled ?? prevSettings?.sharingLinkEnabled ?? false
        };
        const willBecomeSharedPublicly = combinedPublicSharingSettings.publicSharingEnabled === true && combinedPublicSharingSettings.sharingLinkEnabled === true;
        if (willBecomeSharedPublicly) return 'PUBLIC_SHARING_ENABLED';
    }
    return 'PUBLIC_SHARING_UNCHANGED';
};
const $7e01f113dcba2650$export$69a9d91d9040f402 = (viewUUID, settings)=>async ({ dispatch: dispatch, getState: getState }, { viewRemote: viewRemote, onActionFailed: onActionFailed, fields: fields = [], createAnalyticsEvent: createAnalyticsEvent })=>{
        const prevSettings = (0, $7BzKB.getCurrentViewSharingSettings)(getState());
        const newSettings = $7e01f113dcba2650$var$sanitizeSettings(settings, fields);
        try {
            (0, $b5oGV.experience).sharing.updateSettings.start();
            // Optimistic update
            dispatch((0, $2fKlW.setSharingSettingsForView)(viewUUID, {
                settings: settings
            }));
            const { publicAccessChanged: publicAccessChanged, publishedChanged: publishedChanged } = await $7e01f113dcba2650$var$callSharingSettingsServices(viewRemote, viewUUID, newSettings, prevSettings);
            const isPublic = newSettings.publicSharingEnabled === true;
            const isPublished = newSettings.sharingLinkEnabled === true;
            if (publicAccessChanged) {
                const eventName = isPublic ? 'view becomesPublic' : 'view becomesNotPublic';
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), eventName, {
                    isPublished: isPublished
                });
                (0, $3Ku0X.sendPendoTrackEvent)({
                    actionSubjectAndAction: eventName,
                    attributes: {
                        isPublished: isPublished
                    }
                });
            }
            if (publishedChanged) {
                const eventName = isPublished ? 'view published' : 'view unpublished';
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), eventName, {
                    isPublic: isPublic
                });
                (0, $3Ku0X.sendPendoTrackEvent)({
                    actionSubjectAndAction: eventName,
                    attributes: {
                        isPublic: isPublic
                    }
                });
            }
            (0, $b5oGV.experience).sharing.updateSettings.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // Bringing back the old settings
            dispatch((0, $2fKlW.setSharingSettingsForView)(viewUUID, {
                settings: prevSettings
            }));
            if ((0, $dMM78.isClientFetchError)(error) || (0, $fVlmn.isPermissionError)(error) || (0, $fVlmn.isNotFoundError)(error) || (0, $14RSn.isValidationError)(error)) (0, $b5oGV.experience).sharing.updateSettings.abort(error);
            else (0, $b5oGV.experience).sharing.updateSettings.failure(error);
            (0, $eKTQH.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.update-settings-action', error));
            onActionFailed(error);
        }
        const publicSharingControls = (0, $7BzKB.getPublicSharingControls)(getState());
        const isPublicSharingDisabledByGlobalConfig = publicSharingControls.status === 'disabled' && publicSharingControls.reason === 'global-configuration';
        if (!isPublicSharingDisabledByGlobalConfig) return {
            publicSharingStatus: await $7e01f113dcba2650$var$getSettingsUpdateOutcome(prevSettings, settings)
        };
    };
const $7e01f113dcba2650$export$38e4cff581c355ad = (viewUUID)=>async ({ getState: getState, dispatch: dispatch }, { isSharedView: isSharedView, onLoadFailed: onLoadFailed, onLoadViewComments: onLoadViewComments, viewRemote: viewRemote })=>{
        const isSharingSettingsInitialLoading = (0, $7BzKB.getIsCurrentViewSharingSettingsInitialLoading)(getState());
        const isSharingSettingsLoading = (0, $7BzKB.getIsCurrentViewSharingSettingLoading)(getState());
        if (!isSharingSettingsInitialLoading && isSharingSettingsLoading) return;
        dispatch((0, $2fKlW.setSharingSettingsForView)(viewUUID, {
            isLoading: true
        }));
        try {
            (0, $b5oGV.experience).sharing.loadSettings.start();
            const settings = await viewRemote.fetchSharingSettings(viewUUID);
            dispatch((0, $2fKlW.setSharingSettingsForView)(viewUUID, {
                settings: settings
            }));
            (0, $b5oGV.experience).sharing.loadSettings.success();
            if (isSharedView && settings.showViewComments) onLoadViewComments?.();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if ((0, $fVlmn.isNotFoundError)(error) || (0, $fVlmn.isClientClosedError)(error) || (0, $dMM78.isClientFetchError)(error) || (0, $fVlmn.isPermissionError)(error)) (0, $b5oGV.experience).sharing.loadSettings.abort(error);
            else (0, $b5oGV.experience).sharing.loadSettings.failure(error);
            (0, $eKTQH.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.load-settings-action', error));
            dispatch((0, $2fKlW.setSharingSettingsForView)(viewUUID, {
                settings: undefined,
                error: error
            }));
            if (isSharedView) onLoadFailed(error);
        }
    };

});
parcelRegister("3Ku0X", function(module, exports) {
$parcel$export(module.exports, "sendPendoTrackEvent", () => $bf10dcacb821430c$export$c6da4636619f7369);
$parcel$export(module.exports, "updatePendoVisitorOptions", () => $bf10dcacb821430c$export$862313c5bc1d6788);

var $87WyO = parcelRequire("87WyO");
const $bf10dcacb821430c$var$QUEUE_LIMIT = 50;
let $bf10dcacb821430c$var$queue = [];
const $bf10dcacb821430c$var$waitForPendoReadiness = ()=>{
    // This code should not execute on the server.
    if (false) return;
    const interval = setInterval(()=>{
        if ((0, $87WyO.isPendoReady)()) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            $bf10dcacb821430c$var$queue.forEach(([event, attributes])=>window?.pendo?.track(event, attributes));
            $bf10dcacb821430c$var$queue = [];
            clearInterval(interval);
        }
    }, 1000);
};
function $bf10dcacb821430c$export$c6da4636619f7369(event, properties) {
    let pendoEvent;
    let attributes;
    if (typeof event === 'string') {
        pendoEvent = event;
        attributes = properties;
    } else {
        const fullEvent = [
            event.source,
            event.actionSubjectAndAction,
            event.actionSubjectId
        ].filter((part)=>part !== undefined).join(' - ');
        pendoEvent = fullEvent;
        attributes = event.attributes;
    }
    try {
        if ((0, $87WyO.isPendoReady)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.pendo.track(pendoEvent, attributes);
        else {
            $bf10dcacb821430c$var$queue.length < $bf10dcacb821430c$var$QUEUE_LIMIT && $bf10dcacb821430c$var$queue.push([
                pendoEvent,
                attributes
            ]);
            $bf10dcacb821430c$var$waitForPendoReadiness();
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $87WyO.logError)('pendoTrackEvent', err);
    }
}
const $bf10dcacb821430c$export$862313c5bc1d6788 = (metadata)=>{
    try {
        if ((0, $87WyO.isPendoReady)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.pendo.updateOptions(metadata);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $87WyO.logError)('pendoUpdateOptions', err);
    }
};

});
parcelRegister("87WyO", function(module, exports) {
$parcel$export(module.exports, "logError", () => $7c614b2352d1dc75$export$58da9968c3170cb1);
$parcel$export(module.exports, "isPendoReady", () => $7c614b2352d1dc75$export$3f386d356f8c718f);

var $eKTQH = parcelRequire("eKTQH");

var $6Yd06 = parcelRequire("6Yd06");
const $7c614b2352d1dc75$export$58da9968c3170cb1 = (errorSubject, error)=>{
    const ERROR_ID = 'polaris-error';
    (0, $eKTQH.default)({
        meta: {
            id: ERROR_ID,
            teamName: 'polaris'
        },
        attributes: {
            subject: errorSubject
        },
        error: error
    });
    (0, $6Yd06.logSafeErrorWithoutCustomerDataWrapper)(`${ERROR_ID}.${errorSubject}`, error.message, error);
};
const $7c614b2352d1dc75$export$3f386d356f8c718f = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.pendo?.isReady && typeof window.pendo.isReady === 'function' && window.pendo.isReady();

});


parcelRegister("7BzKB", function(module, exports) {
$parcel$export(module.exports, "getIsSharingSiteConfigLoading", () => $954f2b654593806d$export$c9bef8b7e68b15aa);
$parcel$export(module.exports, "getIsSitePublicSharingLoading", () => $954f2b654593806d$export$e6d8b7b929ecf8e8);
$parcel$export(module.exports, "getIsSitePublicSharingEnabled", () => $954f2b654593806d$export$80cfe27fbdebd361);
$parcel$export(module.exports, "getIsCurrentViewPublicSharingEnabled", () => $954f2b654593806d$export$9da2ae248c7e3039);
$parcel$export(module.exports, "getProjectAccessLevel", () => $954f2b654593806d$export$f5f97c28ee230e06);
$parcel$export(module.exports, "getIsSharingOnSiteEnabled", () => $954f2b654593806d$export$2a292862c2d52f48);
$parcel$export(module.exports, "getCurrentViewSharingSettings", () => $954f2b654593806d$export$731dc0886ad97eeb);
$parcel$export(module.exports, "getPublicSharingControls", () => $954f2b654593806d$export$188eeb7105615837);
$parcel$export(module.exports, "getCurrentViewSharingStakeholders", () => $954f2b654593806d$export$65f25f8b5bc681f);
$parcel$export(module.exports, "getIsCurrentViewSharingSettingLoading", () => $954f2b654593806d$export$6f058b53c796dd7a);
$parcel$export(module.exports, "getIsCurrentViewSharingStakeholdersLoading", () => $954f2b654593806d$export$ff4eae65813c5f5e);
$parcel$export(module.exports, "getIsCurrentViewSharingSettingsInitialLoading", () => $954f2b654593806d$export$9fc5badc0a169630);
$parcel$export(module.exports, "getIsCurrentViewSharingStakeholdersInitialLoading", () => $954f2b654593806d$export$5b5786000e919f7);
$parcel$export(module.exports, "getIsCurrentViewSharingInitialLoading", () => $954f2b654593806d$export$787ffe6cfb2ef381);
$parcel$export(module.exports, "getIdeaDescriptionFieldKey", () => $954f2b654593806d$export$7b92127bf4e36b2d);
$parcel$export(module.exports, "getCurrentViewSharingLinkEnabled", () => $954f2b654593806d$export$3b2e0cd80d69f473);
$parcel$export(module.exports, "hasCurrentViewSharingSettingsError", () => $954f2b654593806d$export$57ba084aec18bf70);
$parcel$export(module.exports, "hasCurrentViewSharingError", () => $954f2b654593806d$export$a11d8d14f5a90504);
$parcel$export(module.exports, "getIsPublishDialogContentLoading", () => $954f2b654593806d$export$b74c50d75ffb3249);

var $ahm5r = parcelRequire("ahm5r");

const $954f2b654593806d$var$getCurrentViewUUID = (state)=>state.containerProps?.viewUUID;
const $954f2b654593806d$var$getViewsSharingSettings = (state)=>state.sharingSettings;
const $954f2b654593806d$var$getViewsSharingStakeholders = (state)=>state.sharingStakeholders;
const $954f2b654593806d$var$getPermissions = (state)=>state.permissions;
const $954f2b654593806d$var$getCurrentViewSettings = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewUUID, $954f2b654593806d$var$getViewsSharingSettings, (viewUUID, sharingSettings)=>viewUUID ? sharingSettings[viewUUID] : undefined);
const $954f2b654593806d$var$getCurrentViewStakeholders = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewUUID, $954f2b654593806d$var$getViewsSharingStakeholders, (viewUUID, sharingStakeholders)=>viewUUID ? sharingStakeholders[viewUUID] : undefined);
const $954f2b654593806d$var$getSharingSiteConfig = (state)=>state.siteConfig;
const $954f2b654593806d$export$c9bef8b7e68b15aa = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSharingSiteConfig, (config)=>config.isLoading);
const $954f2b654593806d$var$getSitePublicSharingConfig = (state)=>state.sitePublicSharingConfig;
const $954f2b654593806d$export$e6d8b7b929ecf8e8 = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSitePublicSharingConfig, ({ isLoading: isLoading })=>isLoading);
const $954f2b654593806d$export$80cfe27fbdebd361 = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSitePublicSharingConfig, ({ isEnabled: isEnabled })=>isEnabled);
const $954f2b654593806d$var$getSitePublicSharingError = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSitePublicSharingConfig, ({ error: error })=>error);
const $954f2b654593806d$export$9da2ae248c7e3039 = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewSettings, (sharing)=>sharing?.settings?.publicSharingEnabled === true);
const $954f2b654593806d$export$f5f97c28ee230e06 = (state)=>state.projectAccessLevel;
const $954f2b654593806d$var$getSharingSiteConfigError = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSharingSiteConfig, (config)=>config.error);
const $954f2b654593806d$export$2a292862c2d52f48 = (0, $ahm5r.createSelector)($954f2b654593806d$var$getSharingSiteConfig, (config)=>config.isEnabled);
const $954f2b654593806d$export$731dc0886ad97eeb = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewSettings, $954f2b654593806d$export$f5f97c28ee230e06, (sharing, projectAccessLevel)=>{
    if (!sharing?.settings) return;
    const { settings: settings } = sharing;
    const hasSiteAccessLevel = projectAccessLevel && [
        'OPEN',
        'LIMITED'
    ].includes(projectAccessLevel);
    return {
        ...settings,
        generalAccessLevel: hasSiteAccessLevel ? (0, $8152430c5d79e444$export$41147fc9605520e9) : settings.generalAccessLevel
    };
});
const $954f2b654593806d$export$188eeb7105615837 = (0, $ahm5r.createSelector)([
    $954f2b654593806d$export$80cfe27fbdebd361,
    $954f2b654593806d$var$getPermissions
], (isSitePublicSharingEnabled, permissions)=>{
    if (isSitePublicSharingEnabled === false) return {
        status: 'disabled',
        reason: 'global-configuration'
    };
    if (permissions?.canPublishPublicDiscoveryViews !== true) return {
        status: 'disabled',
        reason: 'missing-permissions'
    };
    return {
        status: 'enabled'
    };
});
const $954f2b654593806d$export$65f25f8b5bc681f = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewStakeholders, (sharing)=>sharing?.stakeholders);
const $954f2b654593806d$export$6f058b53c796dd7a = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewSettings, (sharingSettings)=>sharingSettings?.isLoading === true);
const $954f2b654593806d$export$ff4eae65813c5f5e = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewStakeholders, (sharingStakeholders)=>sharingStakeholders?.isLoading === true);
const $954f2b654593806d$export$9fc5badc0a169630 = (0, $ahm5r.createSelector)($954f2b654593806d$export$6f058b53c796dd7a, $954f2b654593806d$export$731dc0886ad97eeb, (isLoading, settings)=>isLoading && settings === undefined);
const $954f2b654593806d$export$5b5786000e919f7 = (0, $ahm5r.createSelector)($954f2b654593806d$export$ff4eae65813c5f5e, $954f2b654593806d$export$65f25f8b5bc681f, (isLoading, stakeholders)=>isLoading && stakeholders === undefined);
const $954f2b654593806d$export$787ffe6cfb2ef381 = (0, $ahm5r.createSelector)($954f2b654593806d$export$9fc5badc0a169630, $954f2b654593806d$export$5b5786000e919f7, (isSettingsInitialLoading, isStakeholdersInitialLoading)=>isSettingsInitialLoading || isStakeholdersInitialLoading);
const $954f2b654593806d$export$7b92127bf4e36b2d = (0, $ahm5r.createSelector)($954f2b654593806d$export$731dc0886ad97eeb, (settings)=>settings?.ideaDescription.fieldKey);
const $954f2b654593806d$export$3b2e0cd80d69f473 = (0, $ahm5r.createSelector)($954f2b654593806d$export$731dc0886ad97eeb, (settings)=>settings?.sharingLinkEnabled);
const $954f2b654593806d$export$57ba084aec18bf70 = (0, $ahm5r.createSelector)($954f2b654593806d$var$getCurrentViewSettings, $954f2b654593806d$var$getSharingSiteConfigError, $954f2b654593806d$var$getSitePublicSharingError, (sharingSettings, siteConfigError, sitePublicSharingError)=>sharingSettings?.error && sharingSettings.error.statusCode !== 404 || siteConfigError !== undefined || sitePublicSharingError !== undefined);
const $954f2b654593806d$export$a11d8d14f5a90504 = (0, $ahm5r.createSelector)($954f2b654593806d$export$57ba084aec18bf70, $954f2b654593806d$var$getCurrentViewStakeholders, (hasSettingsError, sharingStakeholders)=>sharingStakeholders?.error && sharingStakeholders.error.statusCode !== 404 || hasSettingsError);
const $954f2b654593806d$export$b74c50d75ffb3249 = (0, $ahm5r.createSelector)($954f2b654593806d$export$2a292862c2d52f48, $954f2b654593806d$export$80cfe27fbdebd361, $954f2b654593806d$export$787ffe6cfb2ef381, $954f2b654593806d$export$c9bef8b7e68b15aa, $954f2b654593806d$export$e6d8b7b929ecf8e8, (isSharingEnabledOnSite, isSitePublicSharingEnabled, isSharingInitialLoading, isSharingSiteConfigLoading, isSitePublicSharingLoading)=>isSharingEnabledOnSite && isSitePublicSharingEnabled && isSharingInitialLoading || isSharingSiteConfigLoading || isSitePublicSharingLoading);

});
const $8152430c5d79e444$export$41147fc9605520e9 = 'SITE';
const $8152430c5d79e444$export$137f231420cea7e9 = 'PROJECT';


parcelRegister("2fKlW", function(module, exports) {
$parcel$export(module.exports, "setSharingSettingsForView", () => $eb344f49a627d175$export$eb537ef0ff4cef7b);
$parcel$export(module.exports, "setSharingStakeholdersForView", () => $eb344f49a627d175$export$efe3b3704c70e658);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $eb344f49a627d175$export$eb537ef0ff4cef7b = (viewUUID, sharing = {})=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const viewSharingToUpdate = state.sharingSettings[viewUUID];
        setState({
            sharingSettings: {
                ...state.sharingSettings,
                [viewUUID]: {
                    isLoading: sharing.isLoading || false,
                    settings: sharing.settings || viewSharingToUpdate?.settings,
                    error: sharing.error
                }
            }
        });
    };
const $eb344f49a627d175$export$efe3b3704c70e658 = (viewUUID, sharing = {})=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const viewSharingToUpdate = state.sharingStakeholders[viewUUID];
        setState({
            sharingStakeholders: {
                ...state.sharingStakeholders,
                [viewUUID]: {
                    isLoading: sharing.isLoading || false,
                    stakeholders: sharing.stakeholders || viewSharingToUpdate?.stakeholders,
                    error: sharing.error
                }
            }
        });
    };

});


parcelRegister("54qZO", function(module, exports) {
$parcel$export(module.exports, "loadSharingStakeholders", () => $5f1576dc1cc9db81$export$98e678eadf48ced1);
$parcel$export(module.exports, "addSharingStakeholders", () => $5f1576dc1cc9db81$export$60473b7d5ed25db0);
$parcel$export(module.exports, "removeSharingStakeholders", () => $5f1576dc1cc9db81$export$4938ea46db8995e9);

var $eKTQH = parcelRequire("eKTQH");

var $b5oGV = parcelRequire("b5oGV");

var $3Ku0X = parcelRequire("3Ku0X");

var $7e8wG = parcelRequire("7e8wG");

var $kRgKj = parcelRequire("kRgKj");

var $dMM78 = parcelRequire("dMM78");

var $fVlmn = parcelRequire("fVlmn");

var $7BzKB = parcelRequire("7BzKB");

var $2fKlW = parcelRequire("2fKlW");
const $5f1576dc1cc9db81$export$98e678eadf48ced1 = (viewUUID, { viewAri: viewAri, viewKind: viewKind })=>async ({ getState: getState, dispatch: dispatch }, { viewRemote: viewRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
        const isSharingStakeholdersLoading = (0, $7BzKB.getIsCurrentViewSharingStakeholdersLoading)(getState());
        const isSharingStakeholdersInitialLoading = (0, $7BzKB.getIsCurrentViewSharingStakeholdersInitialLoading)(getState());
        if (!isSharingStakeholdersInitialLoading && isSharingStakeholdersLoading) return;
        dispatch((0, $2fKlW.setSharingStakeholdersForView)(viewUUID, {
            isLoading: true
        }));
        try {
            (0, $b5oGV.experience).sharing.loadStakeholders.start();
            const stakeholders = await viewRemote.fetchSharingStakeholders(viewUUID);
            dispatch((0, $2fKlW.setSharingStakeholdersForView)(viewUUID, {
                stakeholders: stakeholders
            }));
            const sharingLinkEnabled = (0, $7BzKB.getCurrentViewSharingLinkEnabled)(getState());
            const analyticsAttributes = {
                stakeholdersCount: stakeholders.users.length,
                groupsCount: stakeholders.groups.length,
                isPublished: sharingLinkEnabled === true
            };
            (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({
                containers: {
                    view: {
                        id: viewAri || '',
                        type: viewKind?.toLowerCase() || ''
                    }
                }
            }), 'stakeholdersList loaded', analyticsAttributes);
            (0, $3Ku0X.sendPendoTrackEvent)({
                actionSubjectAndAction: 'stakeholdersList loaded',
                attributes: analyticsAttributes
            });
            (0, $b5oGV.experience).sharing.loadStakeholders.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eKTQH.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.load-stakeholders-action', error));
            if ((0, $dMM78.isClientFetchError)(error) || (0, $fVlmn.isPermissionError)(error)) (0, $b5oGV.experience).sharing.loadStakeholders.abort(error);
            else (0, $b5oGV.experience).sharing.loadStakeholders.failure(error);
            dispatch((0, $2fKlW.setSharingStakeholdersForView)(viewUUID, {
                stakeholders: undefined,
                error: error
            }));
        }
    };
const $5f1576dc1cc9db81$export$60473b7d5ed25db0 = (viewUUID, { accountIds: accountIds, emails: emails, groupIds: groupIds }, viewAnalyticsData)=>async ({ dispatch: dispatch }, { viewRemote: viewRemote, onActionFailed: onActionFailed })=>{
        try {
            (0, $b5oGV.experience).sharing.addStakeholders.start();
            const { failures: failures } = await viewRemote.addSharingStakeholders(viewUUID, {
                accountIds: accountIds,
                emails: emails,
                groupIds: groupIds
            });
            await dispatch($5f1576dc1cc9db81$export$98e678eadf48ced1(viewUUID, viewAnalyticsData));
            (0, $b5oGV.experience).sharing.addStakeholders.success();
            return [
                ...failures?.accountIds || [],
                ...failures?.emails || []
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eKTQH.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.add-stakeholders-action', error));
            if ((0, $dMM78.isClientFetchError)(error) || (0, $fVlmn.isPermissionError)(error)) (0, $b5oGV.experience).sharing.addStakeholders.abort(error);
            else (0, $b5oGV.experience).sharing.addStakeholders.failure(error);
            onActionFailed(error);
            return [
                ...accountIds,
                ...emails,
                ...groupIds
            ];
        }
    };
const $5f1576dc1cc9db81$export$4938ea46db8995e9 = (viewUUID, { accountIds: accountIds, groupIds: groupIds })=>async ({ getState: getState, dispatch: dispatch }, { viewRemote: viewRemote, onActionFailed: onActionFailed })=>{
        const state = getState();
        const stakeholders = state.sharingStakeholders[viewUUID]?.stakeholders;
        if (!stakeholders) return;
        try {
            (0, $b5oGV.experience).sharing.removeStakeholders.start();
            await viewRemote.removeSharingStakeholders(viewUUID, {
                accountIds: accountIds,
                groupIds: groupIds
            });
            dispatch((0, $2fKlW.setSharingStakeholdersForView)(viewUUID, {
                stakeholders: {
                    users: stakeholders.users.filter(({ id: id })=>!accountIds.includes(id)),
                    groups: stakeholders.groups.filter(({ id: id })=>!groupIds.includes(id))
                }
            }));
            (0, $b5oGV.experience).sharing.removeStakeholders.success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eKTQH.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.remove-stakeholders-action', error));
            if ((0, $dMM78.isClientFetchError)(error) || (0, $fVlmn.isPermissionError)(error)) (0, $b5oGV.experience).sharing.removeStakeholders.abort(error);
            else (0, $b5oGV.experience).sharing.removeStakeholders.failure(error);
            onActionFailed(error);
        }
    };

});

parcelRegister("fJgAQ", function(module, exports) {
$parcel$export(module.exports, "deletePublishedView", () => $d8d7db15ba7c97d2$export$221f60f553707aa8);

var $eKTQH = parcelRequire("eKTQH");

var $7e8wG = parcelRequire("7e8wG");
const $d8d7db15ba7c97d2$export$221f60f553707aa8 = (viewUUID)=>async (_, { viewRemote: viewRemote })=>{
        try {
            viewUUID && await viewRemote.deleteView(viewUUID);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eKTQH.default)((0, $7e8wG.createErrorAnalytics)('polaris.view-sharing.delete-published-view-action', error));
        }
    };

});




parcelRegister("kTmHj", function(module, exports) {
$parcel$export(module.exports, "setQuery", () => (parcelRequire("aa1G1")).setQuery);
$parcel$export(module.exports, "routeTo", () => (parcelRequire("of4ZB")).routeTo);
$parcel$export(module.exports, "updateDebouncedRouterActions", () => (parcelRequire("gbYTG")).updateDebouncedRouterActions);
$parcel$export(module.exports, "init", () => (parcelRequire("8rYUw")).init);
$parcel$export(module.exports, "closeIssueView", () => (parcelRequire("dhnQW")).closeIssueView);
$parcel$export(module.exports, "openIssueView", () => (parcelRequire("6SHOe")).openIssueView);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $aa1G1 = parcelRequire("aa1G1");

var $of4ZB = parcelRequire("of4ZB");

var $gbYTG = parcelRequire("gbYTG");

var $8rYUw = parcelRequire("8rYUw");

var $dhnQW = parcelRequire("dhnQW");

var $6SHOe = parcelRequire("6SHOe");

});
parcelRegister("aa1G1", function(module, exports) {
$parcel$export(module.exports, "setQuery", () => $619f7d6a74740af8$export$f3b215b0b382f63b);

var $cSmYj = parcelRequire("cSmYj");

var $6dPbw = parcelRequire("6dPbw");

var $4lYQk = parcelRequire("4lYQk");

var $3EGZm = parcelRequire("3EGZm");

var $2DPPQ = parcelRequire("2DPPQ");
const $619f7d6a74740af8$export$f3b215b0b382f63b = (newQuery, updateMethod = 'push')=>({ getState: getState })=>{
        const currentQuery = (0, $3EGZm.getPolarisQuerySelector)(getState());
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))((0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))(currentQuery, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw)))), (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))(newQuery, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw)))))) return;
        const updatedQuery = newQuery === undefined ? {} : {
            ...currentQuery,
            ...newQuery
        };
        if (updateMethod === 'push') (0, $2DPPQ.default).push(null, updatedQuery);
        else if (updateMethod === 'replace') (0, $2DPPQ.default).replace(null, updatedQuery);
    };

});
parcelRegister("3EGZm", function(module, exports) {
$parcel$export(module.exports, "getCurrentRouteSelector", () => $301f6e82cd0b4e61$export$6ed54c4577135f20);
$parcel$export(module.exports, "getCurrentRouteSectionSelector", () => $301f6e82cd0b4e61$export$e89b8890e02ec45e);
$parcel$export(module.exports, "getPolarisQuerySelector", () => $301f6e82cd0b4e61$export$22f15478f7158013);
$parcel$export(module.exports, "getFullscreenQueryParameter", () => $301f6e82cd0b4e61$export$2f80254b69843b80);
$parcel$export(module.exports, "getSelectedIssueQueryParameter", () => $301f6e82cd0b4e61$export$98dec4fb5dc92495);
$parcel$export(module.exports, "getIssueTypeIdQueryParameter", () => $301f6e82cd0b4e61$export$24444cbecc766a00);
$parcel$export(module.exports, "getSidebarQueryParameter", () => $301f6e82cd0b4e61$export$4a1e7cde96b78c66);
$parcel$export(module.exports, "getRoadmapQueryParameter", () => $301f6e82cd0b4e61$export$ff036e0f4253074b);
$parcel$export(module.exports, "getIssueViewLayout", () => $301f6e82cd0b4e61$export$bef822310ccdf5ea);
$parcel$export(module.exports, "getIsIssueOpenInFullscreen", () => $301f6e82cd0b4e61$export$654211dcd797740);
$parcel$export(module.exports, "getIsIssueOpenInSidebar", () => $301f6e82cd0b4e61$export$2f14425c0214c341);
$parcel$export(module.exports, "getIssueViewSection", () => $301f6e82cd0b4e61$export$efd29462b8885d3b);
$parcel$export(module.exports, "getCreateFormIssueTypeId", () => $301f6e82cd0b4e61$export$2d11a185506453dc);

var $ahm5r = parcelRequire("ahm5r");

var $kF1zg = parcelRequire("kF1zg");


var $e6XlU = parcelRequire("e6XlU");
const $301f6e82cd0b4e61$export$52f9a505981b3b1a = (state)=>state.containerProps;
const $301f6e82cd0b4e61$var$getConfiguredRouteSelector = (0, $ahm5r.createSelector)((state)=>state.containerProps?.resource, (state)=>state.containerProps?.section, (state)=>state.routeFromStorage, (resource, section, routeFromStorage)=>{
    if (section !== undefined && section !== null) return {
        section: section,
        resource: resource
    };
    return routeFromStorage;
});
const $301f6e82cd0b4e61$var$getDefaultRouteSelector = (0, $ahm5r.createSelector)((state)=>state.containerProps?.defaultSection, (state)=>state.containerProps?.defaultResource, (section, resource)=>({
        section: section || (0, $446867fcb16be82a$export$4fce57eba3db1f42),
        resource: resource
    }));
const $301f6e82cd0b4e61$var$getHasSelectedIssueQueryParameter = (0, $ahm5r.createSelector)((state)=>state.containerProps?.query.selectedIssue, (selectedIssue)=>selectedIssue !== undefined && !!(0, $e6XlU.POLARIS_QUERY_VALID_VALUES).selectedIssue(selectedIssue));
const $301f6e82cd0b4e61$export$6ed54c4577135f20 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$var$getDefaultRouteSelector, $301f6e82cd0b4e61$var$getConfiguredRouteSelector, $301f6e82cd0b4e61$var$getHasSelectedIssueQueryParameter, (state)=>state.containerProps?.allowedSections, (defaultRoute, configuredRoute, hasSelectedIssueQueryParam, allowedSections)=>{
    if (configuredRoute !== undefined && configuredRoute.section !== undefined && allowedSections?.includes(configuredRoute.section) && !(configuredRoute.section !== (0, $446867fcb16be82a$export$4fce57eba3db1f42) && hasSelectedIssueQueryParam)) return configuredRoute;
    return defaultRoute;
});
const $301f6e82cd0b4e61$export$e89b8890e02ec45e = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$6ed54c4577135f20, (currentRoute)=>currentRoute.section);
const $301f6e82cd0b4e61$var$getQueryValidValues = (state)=>state.containerProps?.queryValidValues;
const $301f6e82cd0b4e61$export$22f15478f7158013 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$var$getQueryValidValues, (0, $ahm5r.createStructuredSelector)((0, $kF1zg.getTypedKeys)((0, $e6XlU.POLARIS_QUERY_VALID_VALUES)).reduce((result, key)=>Object.assign(result, {
        [key]: (0, $ahm5r.createSelector)((state)=>state.containerProps?.query[key], (queryValue)=>{
            if (!queryValue) return undefined;
            const validator = (0, $e6XlU.POLARIS_QUERY_VALID_VALUES)[key];
            return validator(queryValue) ? queryValue : undefined;
        })
    }), {})), (queryValidValues, values)=>{
    const query = {};
    if (!queryValidValues) return query;
    return Object.keys(queryValidValues).reduce((result, key)=>{
        if (values[key] !== undefined) return Object.assign(result, {
            [key]: values[key]
        });
        return result;
    }, query);
});
const $301f6e82cd0b4e61$export$3c0b42d742ff4f88 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.issueViewLayout);
const $301f6e82cd0b4e61$export$12070c9eae7402b0 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.issueViewSection);
const $301f6e82cd0b4e61$export$2f80254b69843b80 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.fullscreen === 'true');
const $301f6e82cd0b4e61$export$98dec4fb5dc92495 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.selectedIssue);
const $301f6e82cd0b4e61$export$24444cbecc766a00 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.issueTypeId);
const $301f6e82cd0b4e61$export$4a1e7cde96b78c66 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.sidebar);
const $301f6e82cd0b4e61$export$ff036e0f4253074b = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.roadmap);
const $301f6e82cd0b4e61$export$bef822310ccdf5ea = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$3c0b42d742ff4f88, (issueViewLayout)=>issueViewLayout === (0, $e6XlU.POLARIS_QUERY_ISSUE_VIEW_SIDEBAR) ? issueViewLayout : undefined);
const $301f6e82cd0b4e61$export$654211dcd797740 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$bef822310ccdf5ea, $301f6e82cd0b4e61$export$98dec4fb5dc92495, (issueViewLayout, selectedIssue)=>issueViewLayout === undefined && selectedIssue !== undefined);
const $301f6e82cd0b4e61$export$2f14425c0214c341 = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$bef822310ccdf5ea, $301f6e82cd0b4e61$export$98dec4fb5dc92495, (issueViewLayout, selectedIssue)=>issueViewLayout !== undefined && selectedIssue !== undefined);
const $301f6e82cd0b4e61$export$efd29462b8885d3b = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$2f14425c0214c341, $301f6e82cd0b4e61$export$12070c9eae7402b0, $301f6e82cd0b4e61$export$98dec4fb5dc92495, (isIssueOpenInSidebar, issueViewSection, selectedIssue)=>{
    if (selectedIssue === undefined) return undefined;
    return isIssueOpenInSidebar ? issueViewSection ?? (0, $e6XlU.DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR) : issueViewSection ?? (0, $e6XlU.DEFAULT_ISSUE_VIEW_SECTION_FULLSCREEN);
});
const $301f6e82cd0b4e61$export$2d11a185506453dc = (0, $ahm5r.createSelector)($301f6e82cd0b4e61$export$22f15478f7158013, (query)=>query.createFormIssueTypeId);

});
const $446867fcb16be82a$export$4fce57eba3db1f42 = 'view';

parcelRegister("e6XlU", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR", () => $e146381bfb078229$export$fc856e90af6063b7);
$parcel$export(module.exports, "DEFAULT_ISSUE_VIEW_SECTION_FULLSCREEN", () => $e146381bfb078229$export$44ed4fbe898cb41a);
$parcel$export(module.exports, "POLARIS_QUERY_ISSUE_VIEW_SIDEBAR", () => $e146381bfb078229$export$66d4646147c88e69);
$parcel$export(module.exports, "POLARIS_QUERY_VALID_VALUES", () => $e146381bfb078229$export$f6bbbc8ed0d13331);
const $e146381bfb078229$export$fc856e90af6063b7 = 'overview';
const $e146381bfb078229$export$44ed4fbe898cb41a = 'comments';
const $e146381bfb078229$export$66d4646147c88e69 = 'sidebar';
const $e146381bfb078229$var$POLARIS_QUERY_ISSUE_VIEW_SECTIONS = [
    'overview',
    'capture',
    'comments',
    'deliver',
    'history',
    'connections'
].reduce((result, section)=>Object.assign(result, {
        [section]: true
    }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
{});
const $e146381bfb078229$export$f6bbbc8ed0d13331 = {
    selectedIssue: (value)=>typeof value === 'string',
    issueViewLayout: (value)=>value === $e146381bfb078229$export$66d4646147c88e69,
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'IssueViewSection'.
    issueViewSection: (value)=>$e146381bfb078229$var$POLARIS_QUERY_ISSUE_VIEW_SECTIONS[value],
    fullscreen: (value)=>value === 'true',
    viewCommentId: (value)=>typeof value === 'string',
    previewRole: (value)=>typeof value === 'string',
    landingViewRank: (value)=>typeof value === 'string',
    openIdeaCreationModal: (value)=>value === 'true',
    sidebar: (value)=>value === 'settings' || value === 'about',
    roadmap: (value)=>value !== '',
    issueTypeId: (value)=>value !== '',
    createFormIssueTypeId: (value)=>value !== ''
};

});


parcelRegister("2DPPQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6dd63bce47cd5d2$export$2e2bcd8739ae039);

var $cxpIO = parcelRequire("cxpIO");
class $a6dd63bce47cd5d2$export$843577d117cf4ba3 {
    constructor(){
        this.pushTimeout = undefined;
        this.replaceTimeout = undefined;
        this.currentPath = undefined;
        this.currentQuery = undefined;
        this.newPath = undefined;
        this.newQuery = undefined;
        this.nativePush = undefined;
        this.nativeReplace = undefined;
    }
    setCurrentState(currentPath, currentQuery) {
        this.currentPath = currentPath;
        this.currentQuery = currentQuery;
    }
    setNativeRouterMethods(nativePush, nativeReplace) {
        this.nativePush = nativePush;
        this.nativeReplace = nativeReplace;
    }
    setNewState(newPath, newQuery) {
        this.newQuery = newQuery ?? this.newQuery ?? this.currentQuery ?? {};
        this.newPath = newPath ?? this.newPath ?? this.currentPath;
    }
    resetNewState() {
        this.newQuery = undefined;
        this.newPath = undefined;
    }
    getNewUrl() {
        return `${this.newPath ?? ''}${(0, $cxpIO.createQueryStringPostfix)(this.newQuery ?? {})}`;
    }
    clearTimeouts() {
        clearTimeout(this.pushTimeout);
        clearTimeout(this.replaceTimeout);
    }
    push(newPath, newQuery) {
        this.setNewState(newPath, newQuery);
        this.clearTimeouts();
        this.pushTimeout = setTimeout(()=>{
            this.pushTimeout = undefined;
            this.nativePush?.(this.getNewUrl());
            this.resetNewState();
        }, 0);
    }
    replace(newPath, newQuery) {
        this.setNewState(newPath, newQuery);
        this.clearTimeouts();
        this.replaceTimeout = setTimeout(()=>{
            this.replaceTimeout = undefined;
            this.nativeReplace?.(this.getNewUrl());
            this.resetNewState();
        }, 0);
    }
}
// global debounce function in order to catch all usages of push() and replace()
const $a6dd63bce47cd5d2$var$debouncedRouterActions = new $a6dd63bce47cd5d2$export$843577d117cf4ba3();
var $a6dd63bce47cd5d2$export$2e2bcd8739ae039 = $a6dd63bce47cd5d2$var$debouncedRouterActions;

});
parcelRegister("cxpIO", function(module, exports) {
$parcel$export(module.exports, "createQueryStringPostfix", () => $36f232912babeac2$export$c6cd7780eb5a242f);

var $dw68A = parcelRequire("dw68A");

var $3zv7S = parcelRequire("3zv7S");

var $hbF3h = parcelRequire("hbF3h");

var $kF1zg = parcelRequire("kF1zg");

var $4cTDP = parcelRequire("4cTDP");
const $36f232912babeac2$var$createQueryStringPostfixLegacy = (query, keysToDrop)=>{
    // @ts-expect-error - TS2769 - No overload matches this call.
    const paramsList = (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(query, (agg, val, key)=>{
        if (val === undefined || keysToDrop && keysToDrop.includes(key)) return agg;
        return [
            ...agg,
            `${key}=${val}`
        ];
    }, []);
    if (paramsList.length === 0) return '';
    const flatGetParams = (0, (/*@__PURE__*/$parcel$interopDefault($dw68A)))(paramsList, '&');
    return `?${flatGetParams}`;
};
const $36f232912babeac2$var$createQueryStringPostfixNext = (query, keysToDrop)=>{
    const paramsList = (0, $kF1zg.getTypedKeys)(query).reduce((acc, key)=>{
        const val = query[key];
        if (val === undefined || keysToDrop && keysToDrop.includes(key)) return acc;
        acc.push(`${key}=${val}`);
        return acc;
    }, []);
    if (paramsList.length === 0) return '';
    const flatGetParams = paramsList.join('&');
    return `?${flatGetParams}`;
};
const $36f232912babeac2$export$c6cd7780eb5a242f = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('polaris_perf_improvements_spread_acc_lru_cache'), $36f232912babeac2$var$createQueryStringPostfixNext, $36f232912babeac2$var$createQueryStringPostfixLegacy);

});
parcelRegister("dw68A", function(module, exports) {
/** Used for built-in method references. */ var $9d730652fe58b493$var$arrayProto = Array.prototype;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9d730652fe58b493$var$nativeJoin = $9d730652fe58b493$var$arrayProto.join;
/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */ function $9d730652fe58b493$var$join(array, separator) {
    return array == null ? '' : $9d730652fe58b493$var$nativeJoin.call(array, separator);
}
module.exports = $9d730652fe58b493$var$join;

});

parcelRegister("3zv7S", function(module, exports) {

var $2x6Yt = parcelRequire("2x6Yt");

var $c3u3c = parcelRequire("c3u3c");

var $1lM9j = parcelRequire("1lM9j");

var $aiJg7 = parcelRequire("aiJg7");

var $4sprp = parcelRequire("4sprp");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $299cc8f655bd088e$var$reduce(collection, iteratee, accumulator) {
    var func = $4sprp(collection) ? $2x6Yt : $aiJg7, initAccum = arguments.length < 3;
    return func(collection, $1lM9j(iteratee, 4), accumulator, initAccum, $c3u3c);
}
module.exports = $299cc8f655bd088e$var$reduce;

});
parcelRegister("aiJg7", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $77feb151e6770379$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $77feb151e6770379$var$baseReduce;

});





parcelRegister("of4ZB", function(module, exports) {
$parcel$export(module.exports, "routeTo", () => $5af5c020377f9bbd$export$7464a66e30a44643);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3EGZm = parcelRequire("3EGZm");

var $2DPPQ = parcelRequire("2DPPQ");

var $cxpIO = parcelRequire("cxpIO");

var $haA3H = parcelRequire("haA3H");
const $5af5c020377f9bbd$export$7464a66e30a44643 = (route, params)=>({ getState: getState }, { getAppUrl: getAppUrl, storageKey: storageKey, useNativeReplaceMethod: useNativeReplaceMethod })=>{
        const routeParams = {
            clearParameters: true,
            replaceInHistory: false,
            saveStorageRouteSlug: true,
            ...params
        };
        const { clearParameters: clearParameters, replaceInHistory: replaceInHistory, saveStorageRouteSlug: saveStorageRouteSlug } = routeParams;
        const currentRoute = (0, $3EGZm.getCurrentRouteSelector)(getState());
        const currentQuery = (0, $3EGZm.getPolarisQuerySelector)(getState());
        if (route.section === currentRoute.section && route.resource === currentRoute.resource) // same route, early exit
        return;
        const url = `${getAppUrl(route)}${clearParameters ? '' : (0, $cxpIO.createQueryStringPostfix)(currentQuery)}`;
        if (replaceInHistory) // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
        useNativeReplaceMethod(url);
        else (0, $2DPPQ.default).push(getAppUrl(route), clearParameters ? {} : undefined);
        if (saveStorageRouteSlug && storageKey !== undefined) (0, $haA3H.setStorageRouteSlug)({
            ...route,
            storageKey: storageKey
        });
    };

});
parcelRegister("haA3H", function(module, exports) {
$parcel$export(module.exports, "setStorageRouteSlug", () => $b4a3eb6c229d0d79$export$a22fe837277f4dd0);
$parcel$export(module.exports, "getStorageRouteSlugWithLegacySupport", () => $b4a3eb6c229d0d79$export$ca6a8f450b3093a6);
$parcel$export(module.exports, "getStorageRouteSlug", () => $b4a3eb6c229d0d79$export$bba59e976bdd53ea);

var $3hRxq = parcelRequire("3hRxq");

var $4cTDP = parcelRequire("4cTDP");
const $b4a3eb6c229d0d79$var$storage = (0, $3hRxq.createLocalStorageProvider)('polaris');
const $b4a3eb6c229d0d79$var$ROUTE_SLUG_STORAGE_KEY = 'routeslug';
const $b4a3eb6c229d0d79$export$a22fe837277f4dd0 = (route)=>{
    if ((0, $4cTDP.fg)('polaris_functional_storage_killswitch')) return;
    $b4a3eb6c229d0d79$var$storage.set($b4a3eb6c229d0d79$var$ROUTE_SLUG_STORAGE_KEY, route);
};
const $b4a3eb6c229d0d79$export$ca6a8f450b3093a6 = ()=>{
    if ((0, $4cTDP.fg)('polaris_functional_storage_killswitch')) return;
    const localRouteSlug = $b4a3eb6c229d0d79$var$storage.get('routeslug');
    if (localRouteSlug !== null && localRouteSlug !== undefined) return localRouteSlug;
    const legacyLocalRouteSlug = $b4a3eb6c229d0d79$var$storage.get('viewslug');
    if (legacyLocalRouteSlug !== null && legacyLocalRouteSlug !== undefined) return {
        section: legacyLocalRouteSlug.section,
        resource: legacyLocalRouteSlug.id
    };
    return undefined;
};
const $b4a3eb6c229d0d79$export$bba59e976bdd53ea = ()=>{
    if ((0, $4cTDP.fg)('polaris_functional_storage_killswitch')) return;
    return $b4a3eb6c229d0d79$var$storage.get($b4a3eb6c229d0d79$var$ROUTE_SLUG_STORAGE_KEY);
};

});


parcelRegister("gbYTG", function(module, exports) {
$parcel$export(module.exports, "updateDebouncedRouterActions", () => $d69c7f2482163fea$export$e203da31a87d8a65);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3EGZm = parcelRequire("3EGZm");

var $2DPPQ = parcelRequire("2DPPQ");
const $d69c7f2482163fea$export$e203da31a87d8a65 = ()=>({ getState: getState }, { getAppUrl: getAppUrl, useNativePushMethod: useNativePushMethod, useNativeReplaceMethod: useNativeReplaceMethod })=>{
        (0, $2DPPQ.default).setNativeRouterMethods(useNativePushMethod, useNativeReplaceMethod);
        const currentQuery = (0, $3EGZm.getPolarisQuerySelector)(getState());
        const currentRoute = (0, $3EGZm.getCurrentRouteSelector)(getState());
        const path = getAppUrl?.(currentRoute);
        if (getAppUrl !== undefined) (0, $2DPPQ.default).setCurrentState(path, currentQuery);
    };

});

parcelRegister("8rYUw", function(module, exports) {
$parcel$export(module.exports, "init", () => $4de1af4526f85389$export$2cd8252107eb640b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4cTDP = parcelRequire("4cTDP");


var $3EGZm = parcelRequire("3EGZm");

var $cxpIO = parcelRequire("cxpIO");

var $haA3H = parcelRequire("haA3H");
const $4de1af4526f85389$export$2cd8252107eb640b = ()=>({ getState: getState, setState: setState }, { getAppUrl: getAppUrl, storageKey: storageKey, section: section, useNativeReplaceMethod: useNativeReplaceMethod })=>{
        const storage = (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration') ? (0, $haA3H.getStorageRouteSlug)() : (0, $haA3H.getStorageRouteSlugWithLegacySupport)();
        // use storage route only if it's related to current project
        if (storage && storage.storageKey === storageKey) {
            setState({
                routeFromStorage: {
                    section: storage.section,
                    resource: storage.resource
                }
            });
            const currentQuery = (0, $3EGZm.getPolarisQuerySelector)(getState());
            if (storage === undefined || section !== undefined || storage.section === 'settings' && storage.resource === 'workflow' || storage.section !== (0, $446867fcb16be82a$export$4fce57eba3db1f42) && currentQuery.selectedIssue || storage.storageKey !== undefined && storage.storageKey !== storageKey || storageKey === undefined || getAppUrl === undefined) return;
            // eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
            useNativeReplaceMethod(`${getAppUrl({
                resource: storage.resource,
                section: storage.section
            })}${(0, $cxpIO.createQueryStringPostfix)(currentQuery)}`);
        }
    };

});

parcelRegister("dhnQW", function(module, exports) {
$parcel$export(module.exports, "closeIssueView", () => $3400a72246cd239f$export$ba15dd71fa7afe95);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $aa1G1 = parcelRequire("aa1G1");
const $3400a72246cd239f$export$ba15dd71fa7afe95 = ()=>({ dispatch: dispatch })=>{
        dispatch((0, $aa1G1.setQuery)({
            selectedIssue: undefined,
            issueViewLayout: undefined,
            issueViewSection: undefined,
            viewCommentId: undefined
        }));
    };

});

parcelRegister("6SHOe", function(module, exports) {
$parcel$export(module.exports, "openIssueView", () => $93a1443f3697b1db$export$611cbcf98e4cfb6e);

var $b5oGV = parcelRequire("b5oGV");

var $3EGZm = parcelRequire("3EGZm");

var $e6XlU = parcelRequire("e6XlU");

var $aa1G1 = parcelRequire("aa1G1");
const $93a1443f3697b1db$var$getNextSection = ({ layout: layout, section: ideaViewSection }, currSidebarSection)=>{
    if (layout === 'sidebar') return ideaViewSection ?? currSidebarSection ?? (0, $e6XlU.DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR);
    return ideaViewSection ?? (0, $e6XlU.DEFAULT_ISSUE_VIEW_SECTION_FULLSCREEN);
};
const $93a1443f3697b1db$export$611cbcf98e4cfb6e = (issueKey, { layout: layout, section: ideaViewSection } = {})=>({ dispatch: dispatch, getState: getState }, { section: section })=>{
        const query = (0, $3EGZm.getPolarisQuerySelector)(getState());
        // replace state instead of push if only change tab
        const updateQueryMethod = issueKey === query?.selectedIssue && layout === query?.issueViewLayout && section !== query?.issueViewSection ? 'replace' : 'push';
        if (updateQueryMethod === 'push') {
            (0, $b5oGV.experience).ideaView.pageSegmentLoad.abort();
            (0, $b5oGV.experience).ideaView.pageSegmentLoad.start();
        }
        dispatch((0, $aa1G1.setQuery)({
            selectedIssue: issueKey,
            issueViewLayout: layout,
            issueViewSection: $93a1443f3697b1db$var$getNextSection({
                layout: layout,
                section: ideaViewSection
            }, query.issueViewSection),
            viewCommentId: undefined
        }, updateQueryMethod));
    };

});


parcelRegister("7a8xH", function(module, exports) {
$parcel$export(module.exports, "useUrlSection", () => $c906b70bebfc4367$export$47d0b879d0f8a136);
$parcel$export(module.exports, "useUrlResource", () => $c906b70bebfc4367$export$cf5a91dc1cc71b53);

var $2FqDG = parcelRequire("2FqDG");


const $c906b70bebfc4367$export$47d0b879d0f8a136 = ()=>{
    const [section] = (0, $2FqDG.usePathParam)('section');
    return section === 'views' ? 'view' : section;
};
const $c906b70bebfc4367$export$cf5a91dc1cc71b53 = ()=>{
    const [resource] = (0, $2FqDG.usePathParam)('resource');
    return resource;
};

});


parcelRegister("laX72", function(module, exports) {
$parcel$export(module.exports, "messages", () => $990690c458ecec42$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $990690c458ecec42$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        "id": "issue-archival-archives.manage-bars.label",
        "defaultMessage": "{count} {count, plural, one {item} other {items}} selected"
    },
    closeButtonLabel: {
        "id": "issue-archival-archives.manage-bars.close-button-label",
        "defaultMessage": "Close"
    }
});

});

parcelRegister("33HhI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dac2bd091119bd3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $48ZTT = parcelRequire("48ZTT");

var $lRq8t = parcelRequire("lRq8t");

var $98BOR = parcelRequire("98BOR");

var $h4JbH = parcelRequire("h4JbH");

var $6eQho = parcelRequire("6eQho");

var $eWZnZ = parcelRequire("eWZnZ");
const $8dac2bd091119bd3$var$UnarchiveIssues = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const state = (0, $6eQho.useArchiveIssueStates)();
    const allSelectedIssuesWithDetails = (0, $6eQho.getAllSelectedIssuesWithDetails)({
        state: state
    });
    const { openUnarchiveIssuesModal: openUnarchiveIssuesModal } = (0, $98BOR.useUnarchiveIssueModalActions)();
    const { clearAllSelections: clearAllSelections, setRefetchArchivesIssuesData: setRefetchArchivesIssuesData } = (0, $h4JbH.useArchiveIssueActions)();
    const onClick = ()=>{
        openUnarchiveIssuesModal({
            selectedIssuesDetails: allSelectedIssuesWithDetails,
            onSuccessCallback: ()=>{
                clearAllSelections();
                setRefetchArchivesIssuesData(true);
            },
            showViewIssueActionInSuccessFlag: true
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48ZTT.default), {
        id: "issue-archival-archives.manage-bars.unarchive-issues.button",
        appearance: "subtle",
        onClick: onClick
    }, formatMessage((0, $eWZnZ.messages).buttonLabel));
};
var $8dac2bd091119bd3$export$2e2bcd8739ae039 = $8dac2bd091119bd3$var$UnarchiveIssues;

});
parcelRegister("eWZnZ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $cea25561ada231a6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $cea25561ada231a6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    buttonLabel: {
        "id": "issue-archival-archives.manage-bars.unarchive-issues.button-label",
        "defaultMessage": "Restore"
    }
});

});



parcelRegister("d5Bcm", function(module, exports) {
$parcel$export(module.exports, "default", () => $383cf0a16808d396$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $fwzaq = parcelRequire("fwzaq");

var $dqc6Z = parcelRequire("dqc6Z");

var $4cTDP = parcelRequire("4cTDP");

var $h4JbH = parcelRequire("h4JbH");

var $6eQho = parcelRequire("6eQho");

var $9OhmL = parcelRequire("9OhmL");
const $383cf0a16808d396$var$Search = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const inputRef = (0, $eJOHy.useRef)(null);
    const { setSearchBy: setSearchBy } = (0, $h4JbH.useArchiveIssueActions)();
    const { searchBy: searchBy } = (0, $6eQho.useArchiveIssueStates)();
    const [debouncedQuery] = (0, $fwzaq.default)((query)=>{
        setSearchBy(query);
    }, 500);
    (0, $eJOHy.useEffect)(()=>{
        if (searchBy === '' && inputRef.current && inputRef.current.nextSibling) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        inputRef.current.nextSibling.childNodes[0]?.click();
    }, [
        searchBy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
        inputRef: inputRef,
        isAlwaysExpanded: true,
        placeholderAlwaysVisible: true,
        placeholder: (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $9OhmL.default).searchIssuesMessageIssueTermRefresh) : formatMessage((0, $9OhmL.default).searchIssuesMessage),
        value: searchBy,
        onChange: (query)=>debouncedQuery(query),
        testId: "issue-archival-archives.ui.search.search-input"
    });
};
var $383cf0a16808d396$export$2e2bcd8739ae039 = $383cf0a16808d396$var$Search;

});
parcelRegister("fwzaq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab2d121bc64be0a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
function $ab2d121bc64be0a3$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eJOHy.useRef)(options);
    const callbackRef = (0, $eJOHy.useRef)(callback);
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eJOHy.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("dqc6Z", function(module, exports) {
$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $awMH0 = parcelRequire("awMH0");

var $7txzk = parcelRequire("7txzk");

var $aFF42 = parcelRequire("aFF42");

var $7QB0D = parcelRequire("7QB0D");
var $e7uOb = parcelRequire("e7uOb");

var $lRq8t = parcelRequire("lRq8t");

var $jd93d = parcelRequire("jd93d");

var $4cTDP = parcelRequire("4cTDP");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7QB0D.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $awMH0.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]);
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded,
        ...(0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? {
            inCustomSearchField: renderCustomSearchField !== undefined
        } : {}
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps;
    const showTooltip = (0, $eJOHy.useMemo)(()=>{
        return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
    }, [
        renderTooltipContent,
        value
    ]);
    const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
        showTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFF42.default), {
        content: renderTooltipContent,
        canAppear: useShowTooltip,
        position: "bottom-start",
        hideTooltipOnClick: true,
        ignoreTooltipPointerEvents: true
    }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7txzk.default), {
            ...tooltipProps,
            ...restTextFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {},
            // eslint-disable-next-line react-hooks/rules-of-hooks
            onFocus: (0, $eJOHy.useCallback)((event)=>{
                onFocusTextField && onFocusTextField(event);
                onFocusTooltip(event);
            }, [
                onFocusTooltip
            ]),
            // eslint-disable-next-line react-hooks/rules-of-hooks
            onBlur: (0, $eJOHy.useCallback)((event)=>{
                onBlurTextField && onBlurTextField(event);
                onBlurTooltip(event);
            }, [
                onBlurTooltip
            ]),
            ref: (0, $jd93d.mergeRefs)(textFieldRef, tooltipRef),
            "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
        }))));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $e7uOb.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $e7uOb.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $e7uOb.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-radius-small, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CY7m", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {
$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $dZl0l = parcelRequire("dZl0l");

var $aadxn = parcelRequire("aadxn");

var $4B1T2 = parcelRequire("4B1T2");

var $lRrud = parcelRequire("lRrud");
var $70XT1 = parcelRequire("70XT1");
var $hVGGZ = parcelRequire("hVGGZ");
var $e7uOb = parcelRequire("e7uOb");

var $4cTDP = parcelRequire("4cTDP");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), {
        xcss: [
            (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? $047d370cc11f69d8$var$wrapperStylesClearIcon : $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hVGGZ.default), {
        xcss: $047d370cc11f69d8$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        "aria-label": clearIconLabel,
        testId: "searchfield.ui.clearfield-icon.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4B1T2))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dZl0l.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aadxn)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $e7uOb.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $70XT1.media).above.md]: {
        marginRight: 'space.050'
    }
});
const $047d370cc11f69d8$var$wrapperStylesClearIcon = (0, $e7uOb.xcss)({
    display: 'flex',
    marginRight: 'space.050',
    [(0, $70XT1.media).above.md]: {
        marginRight: 'space.075'
    }
});
const $047d370cc11f69d8$var$iconWrapperStyles = (0, $e7uOb.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {
$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $48ZTT = parcelRequire("48ZTT");

var $7vpYj = parcelRequire("7vpYj");

var $hML5E = parcelRequire("hML5E");

var $ixLFX = parcelRequire("ixLFX");

var $lRrud = parcelRequire("lRrud");
var $70XT1 = parcelRequire("70XT1");
var $hVGGZ = parcelRequire("hVGGZ");
var $e7uOb = parcelRequire("e7uOb");

var $4B1T2 = parcelRequire("4B1T2");

var $4cTDP = parcelRequire("4cTDP");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false, inCustomSearchField: inCustomSearchField = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hML5E))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles,
            inCustomSearchField && (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') && $fd1be89cde4ae981$var$minimalSpacingStyles
        ]
    }, // eslint-disable-next-line no-nested-ternary
    hasValue ? (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hVGGZ.default), {
        xcss: $fd1be89cde4ae981$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        testId: "searchfield.ui.searchfield-icon.clear-button",
        "aria-label": clearIconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4B1T2))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48ZTT.default), {
        appearance: "subtle",
        spacing: "none",
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7vpYj))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRrud.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ixLFX))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $e7uOb.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    // the wider marginRight is applicable for when the search/clear icon is after the input
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex',
    alignItems: 'center'
});
// if this icon is used in a custom search field, we won't assume any spacing since we don't know where their searchIcon is used
// i.e. before or after the input
// it will be up to the consumers to add spacing where needed
const $fd1be89cde4ae981$var$minimalSpacingStyles = (0, $e7uOb.xcss)({
    marginRight: 'space.0'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $e7uOb.xcss)({
    marginRight: 'space.075',
    [(0, $70XT1.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $e7uOb.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $70XT1.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $e7uOb.xcss)({
    marginLeft: 'space.075',
    [(0, $70XT1.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$iconWrapperStyles = (0, $e7uOb.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});


parcelRegister("9OhmL", function(module, exports) {
$parcel$export(module.exports, "default", () => $eccaf04df3651f64$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $eccaf04df3651f64$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    searchIssuesMessage: {
        "id": "issue-archival-archives.search.search-issues-message",
        "defaultMessage": "Search issues"
    },
    searchIssuesMessageIssueTermRefresh: {
        "id": "issue-archival-archives.search.search-issues-message-issue-term-refresh",
        "defaultMessage": "Search work items"
    }
});

});


parcelRegister("7s3BR", function(module, exports) {
$parcel$export(module.exports, "LayoutMainWrapper", () => $6a7e0fc706d4f11d$export$712225703044cda);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6a7e0fc706d4f11d$export$712225703044cda = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a7e0fc706d4f11d$var$LayoutMainWrapperStyle, null, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a7e0fc706d4f11d$var$LayoutMainWrapperStyle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v5641fl4 _1e0c1txw _2lx21bp4 _1bsb16n6 _4t3i1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("akiS9", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_START_MARK", () => $50b865cde2c2d004$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $50b865cde2c2d004$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $50b865cde2c2d004$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $50b865cde2c2d004$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($50b865cde2c2d004$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($50b865cde2c2d004$export$8e54fca0a680fdfd);
    }
    return null;
};

});



//# sourceMappingURL=async-archived-issues-entrypoint.adae44a3.js.map
